import { __commonJS, __export, __toESM } from './chunk-G3PMV62Z.js';
import { Heading, Button as Button$1, Label as Label$1, FieldError as FieldError$1, Text, CheckboxGroup as CheckboxGroup$1, Checkbox as Checkbox$1, Tag, TagGroup, TagList, DialogTrigger as DialogTrigger$1, Dialog as Dialog$1, Form as Form$1, Link as Link$1, TooltipTrigger, Tooltip as Tooltip$1, TextField, Input as Input$1, FileTrigger, DropZone, TextArea as TextArea$1, ModalOverlay, Modal as Modal$1, RadioGroup as RadioGroup$1, Radio as Radio$1, ProgressBar, Popover as Popover$1, SelectValue as SelectValue$1, ListBox, ListBoxItem, Select as Select$1, Header as Header$1, ListBoxSection, SliderThumb as SliderThumb$1, SliderTrack as SliderTrack$1, SliderOutput as SliderOutput$1, Slider as Slider$1, Switch as Switch$1, TabList as TabList$1, TabsContext, Tabs as Tabs$1, Tab as Tab$1, TabPanel as TabPanel$1, OverlayArrow as OverlayArrow$1 } from 'react-aria-components';
export { TabsContext } from 'react-aria-components';
import { sva, cva, css } from '@allenai/varnish-panda-runtime/css';
import * as React10 from 'react';
import React10__default, { createContext, useContext, useEffect, Component, useState, createElement, useCallback, useRef } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Prism } from 'react-syntax-highlighter';
import { createPortal } from 'react-dom';
import ReactMarkdown from 'react-markdown';
import { ThemeProvider } from '@emotion/react';
import VarnishTheme from '@allenai/varnish-theme';

// ../../node_modules/css-mediaquery/index.js
var require_css_mediaquery = __commonJS({
  "../../node_modules/css-mediaquery/index.js"(exports) {
    exports.match = matchQuery;
    exports.parse = parseQuery;
    var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i;
    var RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/;
    var RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/;
    var RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/;
    var RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    function matchQuery(mediaQuery, values) {
      return parseQuery(mediaQuery).some(function(query) {
        var inverse = query.inverse;
        var typeMatch = query.type === "all" || values.type === query.type;
        if (typeMatch && inverse || !(typeMatch || inverse)) {
          return false;
        }
        var expressionsMatch = query.expressions.every(function(expression) {
          var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
          if (!value) {
            return false;
          }
          switch (feature) {
            case "orientation":
            case "scan":
              return value.toLowerCase() === expValue.toLowerCase();
            case "width":
            case "height":
            case "device-width":
            case "device-height":
              expValue = toPx(expValue);
              value = toPx(value);
              break;
            case "resolution":
              expValue = toDpi(expValue);
              value = toDpi(value);
              break;
            case "aspect-ratio":
            case "device-aspect-ratio":
            case /* Deprecated */
            "device-pixel-ratio":
              expValue = toDecimal(expValue);
              value = toDecimal(value);
              break;
            case "grid":
            case "color":
            case "color-index":
            case "monochrome":
              expValue = parseInt(expValue, 10) || 1;
              value = parseInt(value, 10) || 0;
              break;
          }
          switch (modifier) {
            case "min":
              return value >= expValue;
            case "max":
              return value <= expValue;
            default:
              return value === expValue;
          }
        });
        return expressionsMatch && !inverse || !expressionsMatch && inverse;
      });
    }
    function parseQuery(mediaQuery) {
      return mediaQuery.split(",").map(function(query) {
        query = query.trim();
        var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type2 = captures[2], expressions = captures[3] || "", parsed = {};
        parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
        parsed.type = type2 ? type2.toLowerCase() : "all";
        expressions = expressions.match(/\([^\)]+\)/g) || [];
        parsed.expressions = expressions.map(function(expression) {
          var captures2 = expression.match(RE_MQ_EXPRESSION), feature = captures2[1].toLowerCase().match(RE_MQ_FEATURE);
          return {
            modifier: feature[1],
            feature: feature[2],
            value: captures2[2]
          };
        });
        return parsed;
      });
    }
    function toDecimal(ratio) {
      var decimal = Number(ratio), numbers;
      if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
      }
      return decimal;
    }
    function toDpi(resolution) {
      var value = parseFloat(resolution), units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
      switch (units) {
        case "dpcm":
          return value / 2.54;
        case "dppx":
          return value * 96;
        default:
          return value;
      }
    }
    function toPx(length) {
      var value = parseFloat(length), units = String(length).match(RE_LENGTH_UNIT)[1];
      switch (units) {
        case "em":
          return value * 16;
        case "rem":
          return value * 16;
        case "cm":
          return value * 96 / 2.54;
        case "mm":
          return value * 96 / 2.54 / 10;
        case "in":
          return value * 96;
        case "pt":
          return value * 72;
        case "pc":
          return value * 72 / 12;
        default:
          return value;
      }
    }
  }
});

// ../../node_modules/matchmediaquery/index.js
var require_matchmediaquery = __commonJS({
  "../../node_modules/matchmediaquery/index.js"(exports, module) {
    var staticMatch = require_css_mediaquery().match;
    var dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
    function Mql(query, values, forceStatic) {
      var self = this;
      var mql;
      if (dynamicMatch && !forceStatic) mql = dynamicMatch.call(window, query);
      if (mql) {
        this.matches = mql.matches;
        this.media = mql.media;
        mql.addListener(update);
      } else {
        this.matches = staticMatch(query, values);
        this.media = query;
      }
      this.addListener = addListener;
      this.removeListener = removeListener;
      this.dispose = dispose;
      function addListener(listener) {
        if (mql) {
          mql.addListener(listener);
        }
      }
      function removeListener(listener) {
        if (mql) {
          mql.removeListener(listener);
        }
      }
      function update(evt) {
        self.matches = evt.matches;
        self.media = evt.media;
      }
      function dispose() {
        if (mql) {
          mql.removeListener(update);
        }
      }
    }
    function matchMedia2(query, values, forceStatic) {
      return new Mql(query, values, forceStatic);
    }
    module.exports = matchMedia2;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t;
    };
    exports.isMemo = function(a) {
      return z(a) === r;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type2) {
          return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type2 = object.type;
                switch (type2) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type2;
                  default:
                    var $$typeofType = type2 && type2.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment10 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment10;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports, module) {
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty2.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text3) {
        var message = "Warning: " + text3;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text3) {
        var message = "Warning: " + text3;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is4(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is4(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type2 = getPreciseType(value);
            if (type2 === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type2) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type2 = getPreciseType(value);
        switch (type2) {
          case "array":
          case "object":
            return "an " + type2;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type2;
          default:
            return type2;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// src/utils/cx.ts
var atomicClassRegex = /(.*\]:)?[^_]*(?=_)|.*(?=\]:)/g;
function cx(...args) {
  const presentClassNames = Array.prototype.slice.call(args).filter(Boolean).filter((arg) => typeof arg === "string");
  const atomicClasses = {};
  const nonAtomicClasses = [];
  presentClassNames.forEach((arg) => {
    const individualClassNames = arg ? arg.split(" ").filter(Boolean) : [];
    individualClassNames.forEach((className) => {
      const atomicMatch = className.match(atomicClassRegex);
      if (!className.includes("__") && atomicMatch) {
        const key = atomicMatch[0];
        atomicClasses[key] = className;
      } else {
        nonAtomicClasses.push(className);
      }
    });
  });
  const result = [];
  for (const key in atomicClasses) {
    if (Object.prototype.hasOwnProperty.call(atomicClasses, key)) {
      result.push(atomicClasses[key]);
    }
  }
  result.push(...nonAtomicClasses);
  return result.join(" ");
}
var alertRecipe = sva({
  slots: ["root", "icon", "title", "message", "actions", "closeButton"],
  base: {
    root: {
      display: "flex",
      alignItems: "flex-start",
      gap: "1",
      borderRadius: "sm",
      padding: "[8px]",
      width: "[100%]",
      color: "text.primary"
    },
    icon: {
      display: "flex",
      fontSize: "[22px]",
      lineHeight: "1",
      color: "var(--alert-color)"
    },
    title: {
      margin: "0"
    },
    message: {
      flexGrow: "1",
      fontSize: "sm"
    },
    actions: {},
    closeButton: {
      appearance: "none",
      backgroundColor: "[transparent]",
      border: "0",
      padding: "0",
      fontSize: "[22px]",
      lineHeight: "1",
      display: "flex"
    }
  },
  variants: {
    severity: {
      success: {
        root: {
          "--alert-color": "{colors.success-green.100}"
        }
      },
      info: {
        root: {
          "--alert-color": "{colors.info-blue.100}"
        }
      },
      warning: {
        root: {
          "--alert-color": "{colors.warning-orange.100}"
        }
      },
      error: {
        root: {
          "--alert-color": "{colors.error-red.100}"
        }
      }
    },
    variant: {
      outlined: {
        root: {
          border: "[1px solid var(--alert-color)]"
        }
      },
      contained: {
        root: {
          color: "extra-dark-teal.100",
          backgroundColor: "var(--alert-color)"
        },
        icon: {
          color: "[inherit]"
        }
      }
    }
  },
  compoundVariants: [
    {
      severity: ["success", "info"],
      variant: "contained",
      css: {
        root: {
          color: "[white]"
        }
      }
    }
  ],
  defaultVariants: {
    severity: "info",
    variant: "contained"
  }
});

// src/components/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  Add: () => Add,
  Check: () => Check,
  Close: () => Close,
  Menu: () => Menu,
  Remove: () => Remove,
  Spark: () => Spark,
  Upload: () => Upload
});
var defaultSpriteState = {
  idPrefix: "vui-svg-",
  external: true,
  sprite: "/varnish-ui-sprite.svg"
};
var SpriteContext = React10.createContext(defaultSpriteState);
var SpriteProvider = ({ children, ...spriteState }) => {
  const spriteStateMerged = {
    ...defaultSpriteState,
    ...spriteState
  };
  return /* @__PURE__ */ jsx(SpriteContext.Provider, { value: spriteStateMerged, children });
};
var useSpriteConfig = () => {
  return React10.useContext(SpriteContext);
};
var svgStyles = cva({
  base: {
    width: "[100%]"
  },
  variants: {
    color: {
      default: {
        color: "text.primary"
      },
      reversed: {
        color: "text.primary.reversed"
      },
      primary: {
        color: "accent.primary"
      },
      secondary: {
        color: "accent.secondary"
      },
      tertiary: {
        color: "accent.tertiary"
      }
    }
  }
});
var SVGBase = ({
  viewBox,
  title,
  color: color2,
  aspectRatio,
  className,
  role = "img",
  children,
  ...rest
}) => {
  const colorStyles = colorProp(color2);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      viewBox,
      className: cx(css(colorStyles, { aspectRatio }), svgStyles(), className),
      role,
      ...rest,
      children: [
        title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
        children
      ]
    }
  );
};
var SVGSprite = ({
  SVGComponent,
  use,
  forceInternal = false,
  ...rest
}) => {
  const SVGComponentRender = SVGComponent || SVGBase;
  const { idPrefix, external, sprite } = useSpriteConfig();
  const href = !forceInternal && external ? sprite : "";
  return /* @__PURE__ */ jsx(SVGComponentRender, { ...rest, children: /* @__PURE__ */ jsx("use", { href: `${href}#${idPrefix}${use}` }) });
};
var colorProp = (color2) => {
  if (color2) {
    const colorMerged = css.raw(
      { color: color2 },
      svgStyles.raw({ color: color2 })
    );
    return colorMerged;
  }
  return {};
};
var iconStyles = cva({
  base: {
    aspectRatio: "1",
    width: "[1em]"
  },
  variants: {
    // colors are handled by SVG
    // do this the same as MUI ? use fontSize
    size: {
      inherit: {},
      small: {
        fontSize: "[12px]"
      },
      medium: {
        fontSize: "[16px]"
      },
      large: {
        fontSize: "[24px]"
      }
    }
  }
});
var SVGIcon = ({ viewBox, color: color2, className, ...rest }) => {
  const [variantProps, localProps] = iconStyles.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(
    SVGBase,
    {
      viewBox,
      className: cx(iconStyles(variantProps), className),
      color: color2,
      ...localProps
    }
  );
};
var SVGIconSprite = ({ icon, ...rest }) => {
  return /* @__PURE__ */ jsx(SVGSprite, { SVGComponent: SVGIcon, use: icon, ...rest });
};
var varnishIconSprite = (icon) => {
  const VarnishedSprite = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { icon, ...props });
  return VarnishedSprite;
};
var Upload = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "upload" });
var Spark = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "spark" });
var Remove = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "remove" });
var Menu = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "menu" });
var Close = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "close" });
var Check = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "check" });
var Add = (props) => /* @__PURE__ */ jsx(SVGIconSprite, { ...props, icon: "add" });
var sevrityIconMap = {
  info: Check,
  success: Check,
  warning: Close,
  error: Close
};
var Alert = ({
  icon,
  action,
  title,
  children,
  onClose,
  closeText = "Close",
  className,
  titleClassName,
  messageClassName,
  iconClassName,
  actionClassName,
  ...rest
}) => {
  const [variantProps, localProps] = alertRecipe.splitVariantProps(rest);
  const alertClassNames = alertRecipe(variantProps);
  const { severity = "info" } = variantProps;
  const actionComponent = action || (onClose ? /* @__PURE__ */ jsx(DefaultCloseAction, { onClose, closeText }) : null);
  return /* @__PURE__ */ jsxs("div", { className: cx(alertClassNames.root, className), ...localProps, children: [
    icon !== false ? /* @__PURE__ */ jsx("div", { className: cx(alertClassNames.icon, iconClassName), ...localProps, children: icon || /* @__PURE__ */ jsx(DefaultAlertIcon, { severity }) }) : null,
    /* @__PURE__ */ jsxs("div", { className: cx(alertClassNames.message, messageClassName), children: [
      title ? /* @__PURE__ */ jsx(AlertTitle, { className: titleClassName, children: title }) : null,
      children
    ] }),
    actionComponent ? /* @__PURE__ */ jsx("div", { className: cx(alertClassNames.actions, actionClassName), ...localProps, children: actionComponent }) : null
  ] });
};
var AlertTitle = ({
  level,
  className,
  children
}) => {
  const alertClassNames = alertRecipe();
  return /* @__PURE__ */ jsx(Heading, { level, className: cx(alertClassNames.title, className), children });
};
var AlertCloseButton = ({
  children,
  className,
  ...props
}) => {
  const alertClassNames = alertRecipe();
  return /* @__PURE__ */ jsx(Button$1, { ...props, className: cx(className, alertClassNames.closeButton), children });
};
var DefaultCloseAction = ({ onClose, closeText }) => {
  return /* @__PURE__ */ jsx(AlertCloseButton, { onPress: onClose, "aria-label": closeText, children: /* @__PURE__ */ jsx(Close, {}) });
};
var DefaultAlertIcon = ({ severity }) => {
  const Icon2 = sevrityIconMap[severity];
  return /* @__PURE__ */ jsx(Icon2, {});
};
var avatarRecipe = sva({
  slots: ["root", "image"],
  base: {
    root: {
      cursor: "pointer",
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      margin: "[5px]"
    },
    image: {
      width: "[100%]",
      height: "[100%]",
      objectFit: "cover",
      borderRadius: "[20%]"
    }
  },
  variants: {
    size: {
      small: {
        root: {
          width: "[32px]",
          height: "[32px]"
        }
      },
      medium: {
        root: {
          width: "[40px]",
          height: "[40px]"
        }
      },
      large: {
        root: {
          width: "[56px]",
          height: "[56px]"
        }
      }
    },
    color: {
      primary: {
        root: {
          backgroundColor: "accent.primary"
        }
      },
      secondary: {
        root: {
          backgroundColor: "accent.secondary"
        }
      },
      tertiary: {
        root: {
          backgroundColor: "cream.100"
        }
      }
    },
    shape: {
      square: {
        root: {
          borderRadius: "[0]"
        }
      },
      circle: {
        root: {
          borderRadius: "[50%]"
        }
      }
    },
    hasImage: {
      true: {
        root: {
          padding: "[0]"
        }
      },
      false: {
        root: {
          padding: "[4px]"
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    shape: "square",
    hasImage: true,
    color: "primary"
  }
});
function Avatar({ className, src, alt, children, ...rest }) {
  const hasImage = !!src;
  const [variantProps, localProps] = avatarRecipe.splitVariantProps({
    hasImage,
    ...rest
  });
  const recipeClassNames = avatarRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.root), className), ...localProps, children: hasImage ? /* @__PURE__ */ jsx("img", { src, alt, className: css(recipeClassNames.image) }) : children });
}
var buttonRecipe = sva({
  slots: ["root", "startIcon", "endIcon"],
  base: {
    root: {
      boxSizing: "border-box",
      // button has a font, so we need to ensure this is set
      // for the most part, manrope should be default font though (cascade down)
      fontFamily: "body",
      gap: "[5px]",
      // Override HTML button base styles
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      backgroundColor: "[transparent]",
      cursor: "pointer",
      // should should probably only apply to interactive buttons ...
      // Defaults apply to all variants
      fontWeight: "medium",
      borderRadius: "sm",
      _disabled: {
        cursor: "not-allowed",
        color: "gray.60",
        backgroundColor: "gray.20",
        borderColor: "gray.40"
      },
      transition: "[background-color 250ms, color 250ms, opacity 250ms]",
      // defaults - applies to bordered & text, contained will override these
      color: "var(--button-color)"
    },
    startIcon: {
      verticalAlign: "middle",
      display: "flex"
    },
    endIcon: {
      verticalAlign: "middle",
      display: "flex"
    }
  },
  // Variants
  variants: {
    // Colors follow a pattern
    //   The `--button-color` var will be used to set all the color related properties
    //
    // Colors will need to take into account the contrast versions
    color: {
      primary: {
        root: {
          "--button-color": "{colors.accent.primary}",
          // pink.100 ?
          _hover: {
            _notDisabled: {
              backgroundColor: "pink.10"
            }
          }
        }
      },
      secondary: {
        root: {
          "--button-color": "{colors.accent.secondary}",
          // green.100 ?
          _hover: {
            _notDisabled: {
              backgroundColor: "green.10"
            }
          }
        }
      },
      tertiary: {
        root: {
          "--button-color": "{colors.accent.tertiary}",
          // purple.100 ?
          _hover: {
            _notDisabled: {
              backgroundColor: "purple.10"
            }
          }
        }
      },
      warning: {
        root: {
          "--button-color": "{colors.alert.warning}",
          _hover: {
            _notDisabled: {
              backgroundColor: "warning-orange.20"
            }
          }
        }
      },
      error: {
        root: {
          "--button-color": "{colors.alert.error}",
          _hover: {
            _notDisabled: {
              backgroundColor: "error-red.20"
            }
          }
        }
      },
      info: {
        root: {
          "--button-color": "{colors.alert.information}",
          _hover: {
            _notDisabled: {
              backgroundColor: "info-blue.20"
            }
          }
        }
      },
      confirmation: {
        root: {
          "--button-color": "{colors.alert.confirmation}",
          _hover: {
            _notDisabled: {
              backgroundColor: "success-green.20"
            }
          }
        }
      },
      teal: {
        root: {
          "--button-color": "{colors.teal.100}",
          _hover: {
            _notDisabled: {
              backgroundColor: "teal.10"
            }
          }
        }
      },
      cream: {
        root: {
          "--button-color": "{colors.cream.100}",
          _hover: {
            _notDisabled: {
              backgroundColor: "dark-teal.10"
            }
          }
        }
      },
      darkTeal: {
        root: {
          "--button-color": "{colors.dark-teal.100}",
          _hover: {
            _notDisabled: {
              backgroundColor: "cream.10"
            }
          }
        }
      },
      default: {
        root: {
          "--button-color": "{colors.text.primary}",
          _hover: {
            _notDisabled: {
              backgroundColor: {
                base: "dark-teal.10",
                _dark: "cream.10"
              }
            }
          }
        }
      },
      reversed: {
        root: {
          "--button-color": "{colors.text.primary.reversed}",
          _hover: {
            _notDisabled: {
              backgroundColor: {
                base: "cream.10",
                _dark: "dark-teal.10"
              }
            }
          }
        }
      }
    },
    // Visual variant of buttons
    variant: {
      text: {
        root: {}
      },
      outlined: {
        root: {
          border: "[1px solid var(--button-color)]",
          _disabled: {
            borderColor: "gray.10"
            // gray.100 in figma
          }
        }
      },
      contained: {
        root: {
          backgroundColor: "[var(--button-color)]"
        }
      }
    },
    size: {
      small: {
        root: {
          padding: "[4px 10px]",
          fontSize: "sm",
          lineHeight: "1.55"
        }
      },
      medium: {
        root: {
          padding: "[6px 16px]",
          fontSize: "sm",
          lineHeight: "1.55"
        }
      },
      large: {
        root: {
          padding: "[12px 24px]",
          fontSize: "md",
          lineHeight: "1.5"
        }
      }
    }
  },
  compoundVariants: [
    // Contained buttons text color can be broken into a few categories
    {
      variant: "contained",
      color: ["primary", "secondary", "warning", "error"],
      css: {
        root: {
          color: "extra-dark-teal.100"
        }
      }
    },
    {
      variant: "contained",
      color: ["tertiary", "info", "confirmation", "darkTeal", "teal"],
      css: {
        root: {
          color: "cream.100"
        }
      }
    },
    // contained background colors need to be set specifically
    {
      variant: "contained",
      color: "primary",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "pink.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "secondary",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "green.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "tertiary",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "purple.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "info",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "info-blue.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "confirmation",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "success-green.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "warning",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "warning-orange.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "error",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "error-red.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "cream",
      css: {
        root: {
          color: "extra-dark-teal.100",
          _hover: {
            _notDisabled: {
              backgroundColor: "cream.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "teal",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "teal.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "darkTeal",
      css: {
        root: {
          _hover: {
            _notDisabled: {
              backgroundColor: "dark-teal.80"
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "default",
      css: {
        root: {
          color: "text.primary.reversed",
          _hover: {
            _notDisabled: {
              backgroundColor: {
                base: "dark-teal.80",
                _dark: "cream.80"
              }
            }
          }
        }
      }
    },
    {
      variant: "contained",
      color: "reversed",
      css: {
        root: {
          color: "text.primary",
          _hover: {
            _notDisabled: {
              backgroundColor: {
                base: "cream.80",
                _dark: "dark-teal.80"
              }
            }
          }
        }
      }
    },
    // Outlined sizes:
    // need to reduce padding for these by 1px each side
    // to account for border
    {
      variant: "outlined",
      size: "small",
      css: {
        root: {
          padding: "[3px 9px]"
        }
      }
    },
    {
      variant: "outlined",
      size: "medium",
      css: {
        root: {
          padding: "[5px 15px]"
        }
      }
    },
    {
      variant: "outlined",
      size: "large",
      css: {
        root: {
          padding: "[11px 23px]"
        }
      }
    }
  ],
  defaultVariants: {
    variant: "outlined",
    size: "medium",
    color: "default"
  }
});
var focusRingGenericStyles = css.raw({
  outlineStyle: "solid",
  ringColor: {
    base: "accent.tertiary"
  },
  ringOffset: "[0]",
  ringWidth: {
    base: "0"
  }
});
var focusRing = css.raw(focusRingGenericStyles, {
  ringWidth: {
    _focusVisible: "2px"
  }
});
var groupFocusRing = css.raw(focusRingGenericStyles, {
  ringWidth: {
    _groupFocusVisible: "2px"
  }
});
css.raw(focusRingGenericStyles, {
  ringWidth: {
    _peerFocusVisible: "2px"
  }
});
var childFocusRing = css.raw(focusRingGenericStyles, {
  ringWidth: {
    _groupFocusWithin: "2px"
  }
});
var Button = ({
  className,
  startIconClassName,
  endIconClassName,
  startIcon,
  endIcon,
  buttonAriaLabel,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = buttonRecipe.splitVariantProps(rest);
  const recipeClassNames = buttonRecipe.raw(variantProps);
  return /* @__PURE__ */ jsxs(
    Button$1,
    {
      ...localProps,
      className: cx(css(focusRing, recipeClassNames.root), className),
      "aria-label": buttonAriaLabel,
      children: [
        startIcon ? /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.startIcon), startIconClassName), children: startIcon }) : null,
        children,
        endIcon ? /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.endIcon), endIconClassName), children: endIcon }) : null
      ]
    }
  );
};
var checkboxRecipe = sva({
  slots: ["root", "box", "icon"],
  base: {
    root: {
      display: "flex",
      gap: "[8px]",
      alignItems: "center",
      cursor: "pointer",
      color: "text.primary",
      _disabled: {
        cursor: "not-allowed"
      },
      _componentReadOnly: {
        cursor: "default"
      }
    },
    box: {
      boxSizing: "border-box",
      width: "[20px]",
      height: "[20px]",
      flexShrink: "0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "[1px solid]",
      borderColor: "teal.80",
      borderRadius: "xs",
      backgroundColor: "[white]",
      _groupHover: {
        borderColor: "teal.100"
      },
      _groupSelected: {
        backgroundColor: "[currentColor]",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[transparent]"
        }
      },
      _groupDisabled: {
        color: "gray.40",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[currentColor]"
        }
      },
      _groupInvalid: {
        color: "alert.error",
        borderColor: "[currentColor]"
      }
    },
    icon: {
      width: "[0.625rem]",
      height: "[auto]",
      strokeWidth: "[4px]",
      stroke: "[currentColor]",
      color: "[transparent]",
      _groupSelected: {
        color: "cream.100"
      },
      _groupDisabled: {
        color: "cream.100"
      },
      _groupInvalid: {
        color: "cream.100"
      }
    }
  },
  variants: {
    size: {
      small: {
        root: {
          fontSize: "[12px]"
        },
        box: {
          width: "[0.75rem]",
          height: "[0.75rem]"
        }
      },
      medium: {
        root: {
          fontSize: "sm"
        },
        box: {
          width: "[0.875rem]",
          height: "[0.875rem]"
        }
      },
      large: {
        root: {
          fontSize: "md"
        },
        box: {
          width: "[1.25rem]",
          height: "[1.25rem]"
        },
        icon: {
          width: "[0.75rem]"
        }
      }
    },
    color: {
      primary: {
        box: {
          color: "accent.primary"
        }
      },
      secondary: {
        box: {
          color: "accent.secondary"
        },
        icon: {
          _groupSelected: {
            color: "dark-teal.100"
          }
        }
      },
      tertiary: {
        box: {
          color: "accent.tertiary"
        }
      },
      teal: {
        box: {
          color: "teal.100"
        }
      },
      cream: {
        box: {
          color: "cream.100",
          borderColor: "[transparent]"
        },
        icon: {
          _groupSelected: {
            color: "teal.100"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    color: "primary"
  }
});
var labelRecipe = cva({
  base: {
    cursor: "default",
    color: "text.primary",
    _groupDisabled: {
      color: "[#343434]"
      // gray.40 -- https://github.com/allenai/varnish/issues/1026
    },
    _groupInvalid: {
      color: "alert.error"
    }
  },
  variants: {
    size: {
      small: {
        fontSize: "[12px]"
      },
      medium: {
        fontSize: "sm"
      },
      large: {
        fontSize: "md"
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
var Label = ({ className, ...rest }) => {
  const [variantProps, localProps] = labelRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(Label$1, { ...localProps, className: cx(labelRecipe(variantProps), className) });
};
var fieldErrorRecipe = cva({
  base: {
    color: "alert.error"
  },
  variants: {
    size: {
      small: {
        fontSize: "[12px]"
      },
      medium: {
        fontSize: "sm"
      },
      large: {
        fontSize: "md"
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
var FieldError = ({ className, ...rest }) => {
  const [variantProps, localProps] = fieldErrorRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(FieldError$1, { ...localProps, className: cx(fieldErrorRecipe(variantProps), className) });
};
var descriptionRecipe = cva({
  base: {
    color: "text.primary",
    _groupDisabled: {
      color: "[#343434]"
      // gray.40 -- https://github.com/allenai/varnish/issues/1026
    }
  },
  variants: {
    size: {
      small: {
        fontSize: "[12px]"
      },
      medium: {
        fontSize: "sm"
      },
      large: {
        fontSize: "md"
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
var Description = ({ className, ...rest }) => {
  const [variantProps, localProps] = descriptionRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(
    Text,
    {
      ...localProps,
      slot: "description",
      className: cx(descriptionRecipe(variantProps), className)
    }
  );
};
var checkboxGroupRecipe = sva({
  slots: ["root", "label", "description", "error"],
  base: {
    root: {
      display: "flex",
      flexDir: "column",
      gap: "[2px]"
    },
    label: {},
    description: {},
    error: {}
  }
});
var CheckboxVariantContext = createContext(void 0);
function CheckboxGroup({
  label,
  children,
  description,
  errorMessage,
  className,
  labelClassName,
  descriptionClassName,
  errorClassName,
  ...props
}) {
  const [groupVariantProps, rest] = checkboxGroupRecipe.splitVariantProps(props);
  const [checkboxVariantProps, localProps] = checkboxRecipe.splitVariantProps(rest);
  const { size } = props;
  const recipeClassNames = checkboxGroupRecipe(groupVariantProps);
  return /* @__PURE__ */ jsx(CheckboxGroup$1, { ...localProps, className: cx(recipeClassNames.root, className), children: /* @__PURE__ */ jsxs(CheckboxVariantContext.Provider, { value: checkboxVariantProps, children: [
    /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
    children,
    /* @__PURE__ */ jsx(
      Description,
      {
        size,
        className: cx(recipeClassNames.description, descriptionClassName),
        children: description
      }
    ),
    /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] }) });
}
function Checkbox({ className, boxClassName, iconClassName, children, ...rest }) {
  const [variantProps, localProps] = checkboxRecipe.splitVariantProps(rest);
  const groupProps = useContext(CheckboxVariantContext);
  const recipeClassNames = checkboxRecipe.raw({ ...groupProps, ...variantProps });
  return /* @__PURE__ */ jsx(
    Checkbox$1,
    {
      ...localProps,
      className: cx("group", css(focusRing, recipeClassNames.root), className),
      children: ({ isSelected, isIndeterminate }) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.box), boxClassName), children: isIndeterminate ? /* @__PURE__ */ jsx(
          Remove,
          {
            "aria-hidden": true,
            className: cx(css(recipeClassNames.icon), iconClassName)
          }
        ) : isSelected ? /* @__PURE__ */ jsx(
          Check,
          {
            "aria-hidden": true,
            className: cx(css(recipeClassNames.icon), iconClassName)
          }
        ) : null }),
        children
      ] })
    }
  );
}
var chipGroupRecipe = sva({
  slots: ["root", "chipList", "label", "description", "label", "error"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1"
    },
    chipList: {
      display: "flex",
      flexWrap: "wrap",
      gap: "1"
    },
    label: {
      color: "text.primary"
    },
    description: {
      color: "text.primary"
    },
    error: {}
  }
});
var chipRecipe = sva({
  slots: ["root", "removeButton"],
  base: {
    root: {
      display: "flex",
      alignItems: "center",
      gap: "[4px]",
      borderRadius: "[40px]",
      border: "[1px solid]",
      padding: "[5px]",
      color: "text.primary",
      backgroundColor: "[var(--chip-color)]",
      borderColor: "[var(--chip-color)]",
      _disabled: {
        cursor: "not-allowed",
        color: "text.primary",
        backgroundColor: "gray.20",
        borderColor: "gray.40"
      },
      // default light contained styles
      "--chip-color": "[white]",
      _dark: {
        "--chip-color": "{colors.background}",
        _disabled: {
          backgroundColor: "gray.20",
          borderColor: "gray.40",
          color: "text.primary.reversed"
        }
      },
      // link chips
      "&[data-href]": {
        cursor: "pointer",
        textDecoration: "underline"
      },
      // selected chips
      "&[aria-selected=false]": {
        _hover: {
          _notDisabled: {
            borderColor: "green.40"
          }
        }
      },
      "&[data-selected]": {
        _hover: {
          _notDisabled: {
            borderColor: "green.40"
          }
        },
        borderColor: "green.100"
      }
    },
    removeButton: {
      display: "inline-flex",
      alignItems: "center",
      background: "[none]",
      marginLeft: "[2px]",
      border: "none",
      cursor: "pointer",
      padding: "0",
      color: "accent.primary",
      _dark: {
        color: "accent.secondary"
      }
    }
  },
  variants: {
    variant: {
      contained: {},
      outlined: {
        root: {
          borderColor: "dark-teal.20",
          _dark: {
            borderColor: "[color-mix(in srgb, {colors.cream.100} 20%, var(--chip-color))]",
            color: "text.primary"
          }
        }
      }
    },
    shape: {
      rounded: {},
      box: {
        root: {
          borderRadius: "[4px]"
        }
      }
    },
    color: {
      primary: {
        root: {
          color: "extra-dark-teal.100",
          "--chip-color": "{colors.accent.primary}",
          _dark: {
            color: "extra-dark-teal.100",
            "--chip-color": "{colors.accent.primary}"
          }
        },
        removeButton: {
          color: "extra-dark-teal.100",
          _dark: {
            color: "extra-dark-teal.100"
          }
        }
      },
      secondary: {
        root: {
          color: "extra-dark-teal.100",
          "--chip-color": "{colors.accent.secondary}",
          _dark: {
            color: "extra-dark-teal.100",
            "--chip-color": "{colors.accent.secondary}"
          }
        },
        removeButton: {
          color: "extra-dark-teal.100",
          _dark: {
            color: "extra-dark-teal.100"
          }
        }
      },
      tertiary: {
        root: {
          color: "text.primary.reversed",
          "--chip-color": "{colors.accent.tertiary}",
          _dark: {
            color: "text.primary.reversed",
            "--chip-color": "{colors.accent.tertiary}"
          }
        },
        removeButton: {
          color: "text.primary.reversed",
          _dark: {
            color: "text.primary.reversed"
          }
        }
      }
    },
    size: {
      small: {
        root: {
          height: "[32px]",
          padding: "[5px 12px]",
          fontSize: "[12px]"
        }
      },
      medium: {
        root: {
          height: "[36px]",
          padding: "[8px 15px]",
          fontSize: "sm"
        }
      },
      large: {
        root: {
          height: "[48px]",
          padding: "[12px 20px]",
          fontSize: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    variant: "outlined"
  }
});
var Chip = ({ icon, text: text3, className, removeButtonClassName, ...rest }) => {
  const [variantProps, localProps] = chipRecipe.splitVariantProps(rest);
  const groupProps = useContext(ChipGroupContext);
  const recipeClassNames = chipRecipe({ ...groupProps, ...variantProps });
  return /* @__PURE__ */ jsx(
    Tag,
    {
      ...localProps,
      ...groupProps,
      className: cx(css(focusRing), recipeClassNames.root, className),
      children: (renderProps) => /* @__PURE__ */ jsxs(Fragment, { children: [
        icon,
        /* @__PURE__ */ jsx("span", { children: text3 }),
        renderProps.allowsRemoving && /* @__PURE__ */ jsx(
          Button$1,
          {
            slot: "remove",
            className: cx(recipeClassNames.removeButton, removeButtonClassName),
            children: /* @__PURE__ */ jsx(Close, { size: "medium" })
          }
        )
      ] })
    }
  );
};
var ChipGroupContext = createContext({});
var ChipGroup = ({
  items,
  selectedKeys,
  label,
  description,
  errorMessage,
  className,
  chipClassName,
  labelClassName,
  descriptionClassName,
  errorClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = chipGroupRecipe.splitVariantProps(rest);
  const recipeClassNames = chipGroupRecipe(variantProps);
  return /* @__PURE__ */ jsx(TagGroup, { ...localProps, className: cx(recipeClassNames.root, className), children: /* @__PURE__ */ jsxs(ChipGroupContext.Provider, { value: { ...rest }, children: [
    /* @__PURE__ */ jsx(Label$1, { className: cx(recipeClassNames.label, labelClassName), children: label }),
    /* @__PURE__ */ jsxs(TagList, { className: cx(recipeClassNames.chipList, className), children: [
      items?.map((item) => /* @__PURE__ */ jsx(Chip, { ...item, className: chipClassName }, item.id)),
      children
    ] }),
    /* @__PURE__ */ jsx(Description, { className: cx(recipeClassNames.description, descriptionClassName), children: description }),
    /* @__PURE__ */ jsx(FieldError$1, { className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] }) });
};
var codeBlockRecipe = sva({
  slots: ["root", "pre"],
  base: {
    root: {},
    pre: {}
  }
});
var CodeBlock = ({
  value,
  language,
  className,
  codeTagClassName,
  ...rest
}) => {
  const [variantProps, localProps] = codeBlockRecipe.splitVariantProps(rest);
  const recipeClassNames = codeBlockRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.root), className), children: /* @__PURE__ */ jsx(
    Prism,
    {
      language,
      PreTag: "pre",
      CodeTag: "code",
      codeTagProps: { className: cx(css(recipeClassNames.pre), codeTagClassName) },
      ...localProps,
      children: value
    }
  ) });
};
var dialogStyles = sva({
  slots: ["root", "heading", "actions"],
  base: {
    root: {
      outline: "none",
      display: "flex",
      flex: "1",
      flexDirection: "column"
    },
    heading: {
      fontSize: "lg",
      fontWeight: "medium",
      margin: "[0]"
    },
    actions: {
      display: "flex",
      justifyContent: "end",
      gap: "[16px]"
    }
  },
  variants: {}
});
var DialogHeadingBase = (props) => {
  return /* @__PURE__ */ jsx(Heading, { slot: "title", ...props });
};
var DialogHeading = ({ className, ...rest }) => {
  const [variantProps, localProps] = dialogStyles.splitVariantProps(rest);
  const variantClassNames = dialogStyles(variantProps);
  return /* @__PURE__ */ jsx(DialogHeadingBase, { className: cx(variantClassNames.heading, className), ...localProps });
};
var DialogActions = ({ className, css: cssProp, children, ...rest }) => {
  const [variantProps, localProps] = dialogStyles.splitVariantProps(rest);
  const variantStyles = dialogStyles.raw(variantProps);
  return /* @__PURE__ */ jsx("div", { className: cx(css(variantStyles.actions, cssProp), className), ...localProps, children });
};
var DialogCloseButton = ({ children, ...rest }) => {
  return /* @__PURE__ */ jsx(Button, { slot: "close", ...rest, children });
};
var DialogTrigger = ({ children, content, ...rest }) => {
  return /* @__PURE__ */ jsxs(DialogTrigger$1, { ...rest, children: [
    children,
    content
  ] });
};
var Dialog = ({
  heading: heading2,
  buttons,
  className,
  headingClassName,
  actionsClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = dialogStyles.splitVariantProps(rest);
  const variantClassNames = dialogStyles(variantProps);
  const headingNode = typeof heading2 === "string" ? /* @__PURE__ */ jsx(DialogHeading, { className: headingClassName, ...variantProps, children: heading2 }) : heading2;
  return /* @__PURE__ */ jsxs(Dialog$1, { className: cx(variantClassNames.root, className), ...localProps, children: [
    headingNode,
    children,
    buttons ? /* @__PURE__ */ jsx(DialogActions, { className: actionsClassName, ...variantProps, children: buttons }) : null
  ] });
};
var drawerRecipe = sva({
  slots: ["root", "backdrop", "header", "content", "defaultHeader"],
  base: {
    root: {
      overflow: "auto",
      boxShadow: "[0 0 15px rgba(0, 0, 0, 0.5)]",
      transition: "[transform 0.3s ease]",
      top: "[0]",
      left: "[0]",
      backgroundColor: "background.reversed",
      color: "text.primary.reversed",
      _dark: {
        backgroundColor: "cream.100",
        color: "text.primary.reversed"
      }
    },
    backdrop: {
      position: "fixed",
      top: "0",
      left: "0",
      width: "[100%]",
      height: "[100%]",
      background: "[rgba(0, 0, 0, 0.5)]",
      transition: "[opacity 0.3s ease, visibility 0.3s ease]",
      opacity: "[0]",
      visibility: "hidden",
      pointerEvents: "none",
      willChange: "opacity"
    },
    header: {
      padding: "[5px]",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    content: {
      padding: "[5px]"
    },
    defaultHeader: {
      display: "flex",
      justifyContent: "flex-end"
    }
  },
  variants: {
    placement: {
      left: {
        root: {
          top: "[0]",
          left: "[0]",
          width: "[320px]",
          height: "[100%]",
          transform: "[translateX(-100%)]",
          lg: {
            width: "[320px]",
            height: "[100%]"
          },
          md: {
            width: "[320px]",
            height: "[100%]"
          },
          sm: {
            width: "[100%]",
            height: "[100%]"
          }
        }
      },
      right: {
        root: {
          top: "[0]",
          right: "[0]",
          left: "[unset]",
          width: "[320px]",
          height: "[100%]",
          transform: "[translateX(100%)]",
          lg: {
            width: "[320px]",
            height: "[100%]"
          },
          md: {
            width: "[320px]",
            height: "[100%]"
          },
          sm: {
            width: "[100%]",
            height: "[100%]"
          }
        }
      },
      top: {
        root: {
          top: "[0]",
          left: "[0]",
          right: "[0]",
          width: "[100%]",
          height: "[320px]",
          transform: "[translateY(-100%)]",
          lg: {
            width: "[100%]",
            height: "[320px]"
          },
          md: {
            width: "[100%]",
            height: "[320px]"
          },
          sm: {
            height: "[100%]"
          }
        }
      },
      bottom: {
        root: {
          bottom: "[0]",
          left: "[0]",
          right: "[unset]",
          top: "[unset]",
          width: "[100%]",
          height: "[320px]",
          transform: "[translateY(100%)]",
          lg: {
            width: "[100%]",
            height: "[320px]"
          },
          md: {
            width: "[100%]",
            height: "[320px]"
          },
          sm: {
            height: "[100%]"
          }
        }
      }
    },
    isOpen: {
      true: {
        root: {
          transform: "translate(0)",
          zIndex: "drawer"
        },
        backdrop: {
          visibility: "visible",
          opacity: "1",
          pointerEvents: "auto",
          zIndex: "backdrop",
          transition: "[opacity 0.3s ease, visibility 0s 0.3s]"
        }
      },
      false: {}
    },
    backdrop: {
      true: {
        backdrop: {}
      },
      false: {
        backdrop: {
          display: "none"
        }
      }
    },
    variant: {
      temporary: {
        root: {
          position: "fixed"
        }
      },
      persistent: {
        root: {
          // default left styles
          position: "relative",
          transform: "none",
          width: "[20%]",
          height: "[100%]",
          transition: "[transform 0.3s ease]"
        },
        backdrop: {
          display: "none"
        }
      },
      permanent: {
        root: {
          position: "relative",
          transform: "none",
          width: "[20%]",
          height: "[100%]"
        },
        backdrop: {
          display: "none"
        }
      }
    }
  },
  compoundVariants: [
    {
      placement: "right",
      variant: "persistent",
      css: {
        root: {
          order: "999"
          // realign flex item to the right
        }
      }
    },
    {
      placement: "left",
      isOpen: true,
      css: {
        root: {
          animation: "slideInLeft 250ms ease-out forwards"
        }
      }
    },
    {
      placement: "right",
      isOpen: true,
      css: {
        root: {
          animation: "slideInRight 250ms ease-out forwards"
        }
      }
    },
    {
      placement: "top",
      isOpen: true,
      css: {
        root: {
          animation: "slideInTop 250ms ease-out forwards"
        }
      }
    },
    {
      placement: "bottom",
      isOpen: true,
      css: {
        root: {
          animation: "slideInBottom 250ms ease-out forwards"
        }
      }
    }
  ],
  defaultVariants: {
    placement: "left",
    isOpen: false,
    backdrop: true,
    variant: "temporary"
  }
});
function Drawer({
  className,
  isOpen,
  placement = "left",
  backdrop = true,
  children,
  variant = "temporary",
  header,
  backdropClassName,
  headerClassName,
  contentClassName,
  ariaLabel = "Drawer",
  onClose,
  ...rest
}) {
  const [variantProps, localProps] = drawerRecipe.splitVariantProps(rest);
  const recipeClassNames = drawerRecipe.raw({
    ...variantProps,
    placement,
    isOpen,
    backdrop,
    variant
  });
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && onClose !== void 0) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);
  const defaultHeader = () => /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.defaultHeader)), children: variant !== "permanent" && /* @__PURE__ */ jsx(Button, { variant: "text", onPress: onClose, startIcon: /* @__PURE__ */ jsx(Close, { size: "large" }) }) });
  const content = isOpen ? /* @__PURE__ */ jsxs(Fragment, { children: [
    backdrop && variant === "temporary" && /* @__PURE__ */ jsx(
      "div",
      {
        className: cx(css(recipeClassNames.backdrop), backdropClassName),
        "aria-hidden": "true",
        onClick: onClose
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cx(css(recipeClassNames.root), className),
        ...localProps,
        "aria-label": ariaLabel,
        children: [
          header !== void 0 ? /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.header), headerClassName), children: [
            header,
            variant !== "permanent" && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "text",
                onPress: onClose,
                startIcon: /* @__PURE__ */ jsx(Close, { size: "large" })
              }
            )
          ] }) : defaultHeader(),
          /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.content), contentClassName), children })
        ]
      }
    )
  ] }) : null;
  if ((variant === "persistent" || variant === "permanent") && isOpen) {
    return content;
  }
  return createPortal(content, document.body);
}
var errorBoundaryRecipe = sva({
  slots: ["root", "errorSelection"],
  base: {
    root: {
      height: "[100vh]",
      backgroundColor: "extra-dark-teal.100",
      display: "grid",
      placeItems: "center",
      color: "text.primary.reversed",
      _dark: {
        color: "text.primary"
      }
    },
    errorSelection: {
      width: "[750px]",
      margin: "auto",
      padding: "[16px]",
      minHeight: "[50%]",
      maxHeight: "[90%]",
      overflowY: "auto",
      border: "2px solid red"
    }
  }
});
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ error, errorInfo });
  }
  render() {
    const { className, errorSelectionClassName, fallback, ...rest } = this.props;
    const { hasError, error, errorInfo } = this.state;
    if (!hasError) {
      return this.props.children;
    }
    const [variantProps, localProps] = errorBoundaryRecipe.splitVariantProps(rest);
    const recipeClassNames = errorBoundaryRecipe.raw(variantProps);
    return /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.root), className), ...localProps, children: /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.errorSelection), errorSelectionClassName), children: [
      /* @__PURE__ */ jsx("h1", { children: "Sorry, something went wrong" }),
      fallback || /* @__PURE__ */ jsx("p", { children: "Please try again." }),
      process.env.NODE_ENV !== "production" && error !== void 0 && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { children: "Error Details:" }),
        /* @__PURE__ */ jsxs("p", { children: [
          /* @__PURE__ */ jsx("strong", { children: "Message:" }),
          " ",
          error.message
        ] }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx("strong", { children: "Stack Trace:" }) }),
        /* @__PURE__ */ jsx("pre", { children: error.stack }),
        /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx("strong", { children: "Component Stack:" }) }),
        errorInfo !== void 0 && /* @__PURE__ */ jsx("pre", { children: errorInfo.componentStack })
      ] })
    ] }) });
  }
};
var formRecipe = sva({
  slots: ["root"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "[8px]",
      alignItems: "stretch",
      fontWeight: "medium",
      color: "[inherit]",
      _hover: {
        color: "[inherit]"
      },
      _focus: {
        outline: "2px solid",
        outlineColor: "[currentColor]"
      },
      _disabled: {
        opacity: 0.6,
        cursor: "not-allowed"
      }
    }
  }
});
function Form({ className, onSubmit, onReset, children, ...rest }) {
  const [localProps] = formRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(Form$1, { ...localProps, className, onSubmit, onReset, children });
}
var footerRecipe = sva({
  slots: ["root", "linksGroup", "copyRight"],
  base: {
    root: {
      display: "flex",
      width: "[100%]",
      padding: "[16px]"
    },
    linksGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      gap: "[16px]",
      lg: {
        gridTemplateColumns: "[repeat(4, 1fr)]",
        justifyContent: "space-between",
        gap: "[16px]"
      },
      md: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "[16px]"
      },
      "& ul": {
        padding: "0",
        margin: "0",
        listStyleType: "none"
      },
      "& a": {
        textDecoration: "none"
      },
      "& label": {
        fontSize: "[20px]"
      }
    },
    copyRight: {
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      gap: "[0px]",
      "& span": {
        marginRight: "[32px]"
      },
      "& ul": {
        display: "flex",
        gap: "[32px]",
        padding: "0",
        "& li:first-child": {
          listStyle: "[none]"
        }
      }
    }
  },
  variants: {
    variant: {
      full: {
        root: {
          flexDirection: "column",
          gap: "[16px]"
        }
      },
      slimLeft: {
        root: {
          justifyContent: "flex-start"
        },
        copyRight: {
          display: "flex",
          alignItems: "center"
        }
      },
      slimCenter: {
        root: {
          justifyContent: "center"
        },
        copyRight: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    },
    color: {
      default: {
        root: {
          backgroundColor: "extra-dark-teal.100",
          color: "cream.100"
        },
        linksGroup: {
          "& label": {
            color: "[inherit]"
          },
          "& a": {
            color: "green.100"
          }
        },
        copyRight: {
          "& li::marker": {
            color: "cream.10"
          },
          "& a": {
            color: "green.100"
          }
        }
      },
      cream: {
        root: {
          backgroundColor: "cream.100",
          color: "dark-teal.100"
        },
        linksGroup: {
          "& label": {
            color: "[inherit]"
          },
          "& a": {
            color: "accent.primary"
          }
        },
        copyRight: {
          "& li::marker": {
            color: "extra-dark-teal.10"
          },
          "& a": {
            color: "accent.primary"
          }
        }
      }
    }
  },
  defaultVariants: {
    color: "default",
    variant: "full"
  }
});
var linkRecipe = cva({
  base: {
    fontWeight: "medium",
    // Do we want this?
    cursor: "pointer",
    color: "[inherit]",
    _disabled: {
      color: "gray.40",
      cursor: "not-allowed"
    }
  },
  variants: {
    color: {
      inherit: {
        color: "text.primary"
      },
      primary: {
        color: "accent.primary"
      },
      secondary: {
        color: "accent.secondary"
      },
      tertiary: {
        color: "accent.tertiary"
      }
    },
    underline: {
      // not implemented: `hover` only version
      // can manually use `none` with a _hover style
      always: {
        textDecorationLine: "underline",
        textDecorationColor: "[currentColor/50]",
        _hover: {
          _notDisabled: {
            textDecorationColor: "[inherit]"
          }
        }
      },
      none: {
        textDecoration: "none"
      }
    },
    size: {
      inherit: {},
      small: {
        fontSize: "sm"
      },
      medium: {
        fontSize: "md"
      },
      large: {
        fontSize: "lg"
      }
    }
  },
  defaultVariants: {
    color: "inherit",
    size: "inherit",
    underline: "always"
  }
});
function Link({ className, children, ...rest }) {
  const [variantProps, localProps] = linkRecipe.splitVariantProps(rest);
  const linkRecipeClassNames = linkRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(Link$1, { ...localProps, className: cx(css(focusRing, linkRecipeClassNames), className), children });
}
function Footer({
  className,
  linksGroupClassName,
  copyRightClassName,
  variant = "full",
  linksGroup = [],
  ...rest
}) {
  const [variantProps, localProps] = footerRecipe.splitVariantProps(rest);
  const recipeClassNames = footerRecipe.raw({ ...variantProps, variant });
  return /* @__PURE__ */ jsxs("footer", { className: cx(css(recipeClassNames.root), className), ...localProps, children: [
    variant === "full" && /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.linksGroup), linksGroupClassName), children: linksGroup.map((link2, id) => /* @__PURE__ */ jsx(React10__default.Fragment, { children: link2 }, id)) }),
    /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.copyRight), copyRightClassName), children: [
      /* @__PURE__ */ jsx("span", { children: "\xA9 The Allen Institute for Artificial Intelligence - All Rights Reserved" }),
      variant !== "full" && /* @__PURE__ */ jsxs("ul", { children: [
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          Link,
          {
            color: "primary",
            href: "https://allenai.org/privacy-policy/2022-07-21",
            children: "Privacy Policy"
          }
        ) }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { color: "primary", href: "https://allenai.org/terms/2024-09-25", children: "Terms of Service" }) }),
        /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { color: "primary", href: "https://allenai.org/responsible-use", children: "Responsible use" }) })
      ] })
    ] })
  ] });
}

// ../../node_modules/react-responsive/dist/esm/index.js
var import_matchmediaquery = __toESM(require_matchmediaquery());

// ../../node_modules/hyphenate-style-name/index.js
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
function toHyphenLower(match) {
  return "-" + match.toLowerCase();
}
function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name];
  }
  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
}
var hyphenate_style_name_default = hyphenateStyleName;

// ../../node_modules/shallow-equal/dist/index.modern.mjs
function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }
  if (!objA || !objB) {
    return false;
  }
  const aKeys = Object.keys(objA);
  const bKeys = Object.keys(objB);
  const len = aKeys.length;
  if (bKeys.length !== len) {
    return false;
  }
  for (let i = 0; i < len; i++) {
    const key = aKeys[i];
    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }
  return true;
}

// ../../node_modules/react-responsive/dist/esm/index.js
var import_prop_types = __toESM(require_prop_types());
var stringOrNumber = import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number]);
var types = {
  all: import_prop_types.default.bool,
  grid: import_prop_types.default.bool,
  aural: import_prop_types.default.bool,
  braille: import_prop_types.default.bool,
  handheld: import_prop_types.default.bool,
  print: import_prop_types.default.bool,
  projection: import_prop_types.default.bool,
  screen: import_prop_types.default.bool,
  tty: import_prop_types.default.bool,
  tv: import_prop_types.default.bool,
  embossed: import_prop_types.default.bool
};
var matchers = {
  orientation: import_prop_types.default.oneOf(["portrait", "landscape"]),
  scan: import_prop_types.default.oneOf(["progressive", "interlace"]),
  aspectRatio: import_prop_types.default.string,
  deviceAspectRatio: import_prop_types.default.string,
  height: stringOrNumber,
  deviceHeight: stringOrNumber,
  width: stringOrNumber,
  deviceWidth: stringOrNumber,
  color: import_prop_types.default.bool,
  colorIndex: import_prop_types.default.bool,
  monochrome: import_prop_types.default.bool,
  resolution: stringOrNumber,
  type: Object.keys(types)
};
var { type, ...featureMatchers } = matchers;
var features = {
  minAspectRatio: import_prop_types.default.string,
  maxAspectRatio: import_prop_types.default.string,
  minDeviceAspectRatio: import_prop_types.default.string,
  maxDeviceAspectRatio: import_prop_types.default.string,
  minHeight: stringOrNumber,
  maxHeight: stringOrNumber,
  minDeviceHeight: stringOrNumber,
  maxDeviceHeight: stringOrNumber,
  minWidth: stringOrNumber,
  maxWidth: stringOrNumber,
  minDeviceWidth: stringOrNumber,
  maxDeviceWidth: stringOrNumber,
  minColor: import_prop_types.default.number,
  maxColor: import_prop_types.default.number,
  minColorIndex: import_prop_types.default.number,
  maxColorIndex: import_prop_types.default.number,
  minMonochrome: import_prop_types.default.number,
  maxMonochrome: import_prop_types.default.number,
  minResolution: stringOrNumber,
  maxResolution: stringOrNumber,
  ...featureMatchers
};
var all = { ...types, ...features };
var mq = {
  all,
  types,
  matchers,
  features
};
var negate = (cond) => `not ${cond}`;
var keyVal = (k, v) => {
  const realKey = hyphenate_style_name_default(k);
  if (typeof v === "number") {
    v = `${v}px`;
  }
  if (v === true) {
    return realKey;
  }
  if (v === false) {
    return negate(realKey);
  }
  return `(${realKey}: ${v})`;
};
var join = (conds) => conds.join(" and ");
var toQuery = (obj) => {
  const rules = [];
  Object.keys(mq.all).forEach((k) => {
    const v = obj[k];
    if (v != null) {
      rules.push(keyVal(k, v));
    }
  });
  return join(rules);
};
var Context = createContext(void 0);
var makeQuery = (settings) => settings.query || toQuery(settings);
var hyphenateKeys = (obj) => {
  if (!obj)
    return void 0;
  const keys = Object.keys(obj);
  return keys.reduce((result, key) => {
    result[hyphenate_style_name_default(key)] = obj[key];
    return result;
  }, {});
};
var useIsUpdate = () => {
  const ref = useRef(false);
  useEffect(() => {
    ref.current = true;
  }, []);
  return ref.current;
};
var useDevice = (deviceFromProps) => {
  const deviceFromContext = useContext(Context);
  const getDevice = () => hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
  const [device, setDevice] = useState(getDevice);
  useEffect(() => {
    const newDevice = getDevice();
    if (!shallowEqualObjects(device, newDevice)) {
      setDevice(newDevice);
    }
  }, [deviceFromProps, deviceFromContext]);
  return device;
};
var useQuery = (settings) => {
  const getQuery = () => makeQuery(settings);
  const [query, setQuery] = useState(getQuery);
  useEffect(() => {
    const newQuery = getQuery();
    if (query !== newQuery) {
      setQuery(newQuery);
    }
  }, [settings]);
  return query;
};
var useMatchMedia = (query, device) => {
  const getMatchMedia = () => (0, import_matchmediaquery.default)(query, device || {}, !!device);
  const [mq2, setMq] = useState(getMatchMedia);
  const isUpdate = useIsUpdate();
  useEffect(() => {
    if (isUpdate) {
      const newMq = getMatchMedia();
      setMq(newMq);
      return () => {
        if (newMq) {
          newMq.dispose();
        }
      };
    }
  }, [query, device]);
  return mq2;
};
var useMatches = (mediaQuery) => {
  const [matches, setMatches] = useState(mediaQuery.matches);
  useEffect(() => {
    const updateMatches = (ev) => {
      setMatches(ev.matches);
    };
    mediaQuery.addListener(updateMatches);
    setMatches(mediaQuery.matches);
    return () => {
      mediaQuery.removeListener(updateMatches);
    };
  }, [mediaQuery]);
  return matches;
};
var useMediaQuery = (settings, device, onChange) => {
  const deviceSettings = useDevice(device);
  const query = useQuery(settings);
  if (!query)
    throw new Error("Invalid or missing MediaQuery!");
  const mq2 = useMatchMedia(query, deviceSettings);
  const matches = useMatches(mq2);
  const isUpdate = useIsUpdate();
  useEffect(() => {
    if (isUpdate && onChange) {
      onChange(matches);
    }
  }, [matches]);
  useEffect(() => () => {
    if (mq2) {
      mq2.dispose();
    }
  }, []);
  return matches;
};
var headerRecipe = sva({
  slots: ["root", "container", "search", "action", "nav", "logo", "slots", "container", "icon"],
  base: {
    root: {
      border: "none",
      top: "0",
      backgroundColor: "background.reversed",
      color: "accent.secondary",
      _dark: {
        color: "accent.primary"
      }
    },
    container: {
      color: "[inherit]",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "nowrap",
      whiteSpace: "nowrap"
    },
    logo: {
      display: "flex",
      alignItems: "center",
      gap: "[12px]",
      flexShrink: 0
    },
    slots: {
      color: "[inherit]",
      display: "flex",
      alignItems: "center",
      gap: "[1rem]",
      flexDirection: "row"
    },
    nav: {
      display: "flex",
      gap: "[16px]",
      alignSelf: "center",
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      color: "[inherit]",
      flexDirection: "row"
    },
    search: {},
    action: {
      whiteSpace: "nowrap",
      color: "[inherit]"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle"
    }
  },
  variants: {
    position: {
      fixed: {
        root: {
          position: "fixed"
        }
      },
      sticky: {
        root: {
          position: "sticky"
        }
      }
    },
    shape: {
      box: {
        root: {
          borderRadius: "[16px]",
          smOnly: {
            borderRadius: "[8px]"
          }
        },
        container: {
          padding: "[16px]",
          smOnly: {
            padding: "[16px]"
          }
        }
      },
      rounded: {
        root: {
          borderRadius: "full"
        },
        container: {
          padding: "[16px 32px]",
          smOnly: {
            padding: "[16px 24px]"
          }
        }
      },
      full: {
        root: {
          border: "none",
          backgroundColor: "[transparent]"
        },
        container: {
          padding: "[16px 24px]",
          smOnly: {
            padding: "[16px]"
          }
        }
      }
    },
    fullWidth: {
      false: {},
      true: {
        root: {
          width: "[100%]",
          backgroundColor: "[transparent]",
          border: "none"
        }
      }
    }
  },
  defaultVariants: {
    shape: "box",
    position: "sticky"
  }
});
var useIsMobile = () => {
  return useMediaQuery({ maxWidth: 768 });
};
function Header({
  logo,
  navItem,
  search,
  action,
  className,
  searchClassName,
  actionClassName,
  navClassName,
  logoClassName,
  ...rest
}) {
  const [variantProps, localProps] = headerRecipe.splitVariantProps(rest);
  const recipeClassNames = headerRecipe.raw(variantProps);
  const isMobile = useIsMobile();
  return /* @__PURE__ */ jsx("header", { className: cx(css(recipeClassNames.root), className), ...localProps, children: /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.container)), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        "aria-label": "Site Logo",
        className: cx(css(recipeClassNames.logo), logoClassName),
        children: [
          isMobile && /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.icon)), children: /* @__PURE__ */ jsx(icons_exports.Menu, {}) }),
          logo
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.slots)), children: [
      !!navItem && /* @__PURE__ */ jsx(
        "nav",
        {
          className: cx(css(recipeClassNames.nav), navClassName),
          "aria-label": "Main Navigation",
          children: navItem
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cx(css(recipeClassNames.search), searchClassName),
          "aria-label": "Search Bar",
          children: search
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cx(css(recipeClassNames.action), actionClassName),
          "aria-label": "Action Button",
          children: action
        }
      )
    ] })
  ] }) });
}

// ../../node_modules/ccount/index.js
function ccount(value, character) {
  const source = String(value);
  if (typeof character !== "string") {
    throw new TypeError("Expected character");
  }
  let count = 0;
  let index = source.indexOf(character);
  while (index !== -1) {
    count++;
    index = source.indexOf(character, index + character.length);
  }
  return count;
}

// ../../node_modules/devlop/lib/default.js
function ok() {
}

// ../../node_modules/micromark-util-character/index.js
var asciiAlpha = regexCheck(/[A-Za-z]/);
var asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
function asciiControl(code3) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code3 !== null && (code3 < 32 || code3 === 127)
  );
}
function markdownLineEnding(code3) {
  return code3 !== null && code3 < -2;
}
function markdownLineEndingOrSpace(code3) {
  return code3 !== null && (code3 < 0 || code3 === 32);
}
function markdownSpace(code3) {
  return code3 === -2 || code3 === -1 || code3 === 32;
}
var unicodePunctuation = regexCheck(/\p{P}|\p{S}/u);
var unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check;
  function check(code3) {
    return code3 !== null && code3 > -1 && regex.test(String.fromCharCode(code3));
  }
}

// ../../node_modules/mdast-util-find-and-replace/node_modules/escape-string-regexp/index.js
function escapeStringRegexp(string) {
  if (typeof string !== "string") {
    throw new TypeError("Expected a string");
  }
  return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

// ../../node_modules/unist-util-visit-parents/node_modules/unist-util-is/lib/index.js
var convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(test) {
    if (test === null || test === void 0) {
      return ok2;
    }
    if (typeof test === "function") {
      return castFactory(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory(test) : propsFactory(test);
    }
    if (typeof test === "string") {
      return typeFactory(test);
    }
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory(tests) {
  const checks = [];
  let index = -1;
  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }
  return castFactory(any);
  function any(...parameters) {
    let index2 = -1;
    while (++index2 < checks.length) {
      if (checks[index2].apply(this, parameters)) return true;
    }
    return false;
  }
}
function propsFactory(check) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check
  );
  return castFactory(all3);
  function all3(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
    }
    return true;
  }
}
function typeFactory(check) {
  return castFactory(type2);
  function type2(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory(testFunction) {
  return check;
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode(value) && testFunction.call(
        this,
        value,
        typeof index === "number" ? index : void 0,
        parent || void 0
      )
    );
  }
}
function ok2() {
  return true;
}
function looksLikeANode(value) {
  return value !== null && typeof value === "object" && "type" in value;
}

// ../../node_modules/unist-util-visit-parents/lib/color.node.js
function color(d) {
  return "\x1B[33m" + d + "\x1B[39m";
}

// ../../node_modules/unist-util-visit-parents/lib/index.js
var empty = [];
var CONTINUE = true;
var EXIT = false;
var SKIP = "skip";
function visitParents(tree, test, visitor, reverse) {
  let check;
  if (typeof test === "function" && typeof visitor !== "function") {
    reverse = visitor;
    visitor = test;
  } else {
    check = test;
  }
  const is4 = convert(check);
  const step = reverse ? -1 : 1;
  factory(tree, void 0, [])();
  function factory(node2, index, parents) {
    const value = (
      /** @type {Record<string, unknown>} */
      node2 && typeof node2 === "object" ? node2 : {}
    );
    if (typeof value.type === "string") {
      const name = (
        // `hast`
        typeof value.tagName === "string" ? value.tagName : (
          // `xast`
          typeof value.name === "string" ? value.name : void 0
        )
      );
      Object.defineProperty(visit2, "name", {
        value: "node (" + color(node2.type + (name ? "<" + name + ">" : "")) + ")"
      });
    }
    return visit2;
    function visit2() {
      let result = empty;
      let subresult;
      let offset;
      let grandparents;
      if (!test || is4(node2, index, parents[parents.length - 1] || void 0)) {
        result = toResult(visitor(node2, parents));
        if (result[0] === EXIT) {
          return result;
        }
      }
      if ("children" in node2 && node2.children) {
        const nodeAsParent = (
          /** @type {UnistParent} */
          node2
        );
        if (nodeAsParent.children && result[0] !== SKIP) {
          offset = (reverse ? nodeAsParent.children.length : -1) + step;
          grandparents = parents.concat(nodeAsParent);
          while (offset > -1 && offset < nodeAsParent.children.length) {
            const child = nodeAsParent.children[offset];
            subresult = factory(child, offset, grandparents)();
            if (subresult[0] === EXIT) {
              return subresult;
            }
            offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
          }
        }
      }
      return result;
    }
  }
}
function toResult(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return value === null || value === void 0 ? empty : [value];
}

// ../../node_modules/mdast-util-find-and-replace/node_modules/unist-util-is/lib/index.js
var convert2 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(test) {
    if (test === null || test === void 0) {
      return ok3;
    }
    if (typeof test === "function") {
      return castFactory2(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory2(test) : propsFactory2(test);
    }
    if (typeof test === "string") {
      return typeFactory2(test);
    }
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory2(tests) {
  const checks = [];
  let index = -1;
  while (++index < tests.length) {
    checks[index] = convert2(tests[index]);
  }
  return castFactory2(any);
  function any(...parameters) {
    let index2 = -1;
    while (++index2 < checks.length) {
      if (checks[index2].apply(this, parameters)) return true;
    }
    return false;
  }
}
function propsFactory2(check) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check
  );
  return castFactory2(all3);
  function all3(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
    }
    return true;
  }
}
function typeFactory2(check) {
  return castFactory2(type2);
  function type2(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory2(testFunction) {
  return check;
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode2(value) && testFunction.call(
        this,
        value,
        typeof index === "number" ? index : void 0,
        parent || void 0
      )
    );
  }
}
function ok3() {
  return true;
}
function looksLikeANode2(value) {
  return value !== null && typeof value === "object" && "type" in value;
}

// ../../node_modules/mdast-util-find-and-replace/lib/index.js
function findAndReplace(tree, list2, options) {
  const settings = options || {};
  const ignored = convert2(settings.ignore || []);
  const pairs = toPairs(list2);
  let pairIndex = -1;
  while (++pairIndex < pairs.length) {
    visitParents(tree, "text", visitor);
  }
  function visitor(node2, parents) {
    let index = -1;
    let grandparent;
    while (++index < parents.length) {
      const parent = parents[index];
      const siblings = grandparent ? grandparent.children : void 0;
      if (ignored(
        parent,
        siblings ? siblings.indexOf(parent) : void 0,
        grandparent
      )) {
        return;
      }
      grandparent = parent;
    }
    if (grandparent) {
      return handler(node2, parents);
    }
  }
  function handler(node2, parents) {
    const parent = parents[parents.length - 1];
    const find = pairs[pairIndex][0];
    const replace2 = pairs[pairIndex][1];
    let start = 0;
    const siblings = parent.children;
    const index = siblings.indexOf(node2);
    let change = false;
    let nodes = [];
    find.lastIndex = 0;
    let match = find.exec(node2.value);
    while (match) {
      const position = match.index;
      const matchObject = {
        index: match.index,
        input: match.input,
        stack: [...parents, node2]
      };
      let value = replace2(...match, matchObject);
      if (typeof value === "string") {
        value = value.length > 0 ? { type: "text", value } : void 0;
      }
      if (value === false) {
        find.lastIndex = position + 1;
      } else {
        if (start !== position) {
          nodes.push({
            type: "text",
            value: node2.value.slice(start, position)
          });
        }
        if (Array.isArray(value)) {
          nodes.push(...value);
        } else if (value) {
          nodes.push(value);
        }
        start = position + match[0].length;
        change = true;
      }
      if (!find.global) {
        break;
      }
      match = find.exec(node2.value);
    }
    if (change) {
      if (start < node2.value.length) {
        nodes.push({ type: "text", value: node2.value.slice(start) });
      }
      parent.children.splice(index, 1, ...nodes);
    } else {
      nodes = [node2];
    }
    return index + nodes.length;
  }
}
function toPairs(tupleOrList) {
  const result = [];
  if (!Array.isArray(tupleOrList)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const list2 = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [tupleOrList];
  let index = -1;
  while (++index < list2.length) {
    const tuple = list2[index];
    result.push([toExpression(tuple[0]), toFunction(tuple[1])]);
  }
  return result;
}
function toExpression(find) {
  return typeof find === "string" ? new RegExp(escapeStringRegexp(find), "g") : find;
}
function toFunction(replace2) {
  return typeof replace2 === "function" ? replace2 : function() {
    return replace2;
  };
}

// ../../node_modules/mdast-util-gfm-autolink-literal/lib/index.js
var inConstruct = "phrasing";
var notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(token) {
  this.enter({ type: "link", title: null, url: "", children: [] }, token);
}
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  const node2 = this.stack[this.stack.length - 1];
  ok(node2.type === "link");
  node2.url = "http://" + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
  this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(_, protocol, domain2, path2, match) {
  let prefix = "";
  if (!previous(match)) {
    return false;
  }
  if (/^w/i.test(protocol)) {
    domain2 = protocol + domain2;
    protocol = "";
    prefix = "http://";
  }
  if (!isCorrectDomain(domain2)) {
    return false;
  }
  const parts = splitUrl(domain2 + path2);
  if (!parts[0]) return false;
  const result = {
    type: "link",
    title: null,
    url: prefix + protocol + parts[0],
    children: [{ type: "text", value: protocol + parts[0] }]
  };
  if (parts[1]) {
    return [result, { type: "text", value: parts[1] }];
  }
  return result;
}
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false;
  }
  return {
    type: "link",
    title: null,
    url: "mailto:" + atext + "@" + label,
    children: [{ type: "text", value: atext + "@" + label }]
  };
}
function isCorrectDomain(domain2) {
  const parts = domain2.split(".");
  if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) {
    return false;
  }
  return true;
}
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
  if (!trailExec) {
    return [url, void 0];
  }
  url = url.slice(0, trailExec.index);
  let trail2 = trailExec[0];
  let closingParenIndex = trail2.indexOf(")");
  const openingParens = ccount(url, "(");
  let closingParens = ccount(url, ")");
  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail2.slice(0, closingParenIndex + 1);
    trail2 = trail2.slice(closingParenIndex + 1);
    closingParenIndex = trail2.indexOf(")");
    closingParens++;
  }
  return [url, trail2];
}
function previous(match, email) {
  const code3 = match.input.charCodeAt(match.index - 1);
  return (match.index === 0 || unicodeWhitespace(code3) || unicodePunctuation(code3)) && (!email || code3 !== 47);
}

// ../../node_modules/micromark-util-normalize-identifier/index.js
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}

// ../../node_modules/mdast-util-gfm-footnote/lib/index.js
footnoteReference.peek = footnoteReferencePeek;
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  };
}
function gfmFootnoteToMarkdown() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition, footnoteReference }
  };
}
function enterFootnoteDefinition(token) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    token
  );
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function exitFootnoteDefinitionLabelString(token) {
  const label = this.resume();
  const node2 = this.stack[this.stack.length - 1];
  ok(node2.type === "footnoteDefinition");
  node2.label = label;
  node2.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
}
function exitFootnoteDefinition(token) {
  this.exit(token);
}
function enterFootnoteCall(token) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, token);
}
function enterFootnoteCallString() {
  this.buffer();
}
function exitFootnoteCallString(token) {
  const label = this.resume();
  const node2 = this.stack[this.stack.length - 1];
  ok(node2.type === "footnoteReference");
  node2.label = label;
  node2.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
}
function exitFootnoteCall(token) {
  this.exit(token);
}
function footnoteReference(node2, _, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move("[^");
  const exit2 = state.enter("footnoteReference");
  const subexit = state.enter("reference");
  value += tracker.move(
    state.safe(state.associationId(node2), {
      ...tracker.current(),
      before: value,
      after: "]"
    })
  );
  subexit();
  exit2();
  value += tracker.move("]");
  return value;
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteDefinition(node2, _, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move("[^");
  const exit2 = state.enter("footnoteDefinition");
  const subexit = state.enter("label");
  value += tracker.move(
    state.safe(state.associationId(node2), {
      ...tracker.current(),
      before: value,
      after: "]"
    })
  );
  subexit();
  value += tracker.move(
    "]:" + (node2.children && node2.children.length > 0 ? " " : "")
  );
  tracker.shift(4);
  value += tracker.move(
    state.indentLines(state.containerFlow(node2, tracker.current()), map)
  );
  exit2();
  return value;
}
function map(line, index, blank) {
  if (index === 0) {
    return line;
  }
  return (blank ? "" : "    ") + line;
}

// ../../node_modules/mdast-util-gfm-strikethrough/lib/index.js
var constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(token) {
  this.enter({ type: "delete", children: [] }, token);
}
function exitStrikethrough(token) {
  this.exit(token);
}
function handleDelete(node2, _, state, info) {
  const tracker = state.createTracker(info);
  const exit2 = state.enter("strikethrough");
  let value = tracker.move("~~");
  value += state.containerPhrasing(node2, {
    ...tracker.current(),
    before: value,
    after: "~"
  });
  value += tracker.move("~~");
  exit2();
  return value;
}
function peekDelete() {
  return "~";
}

// ../../node_modules/markdown-table/index.js
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat();
  const stringLength = options.stringLength || defaultStringLength;
  const alignments = [];
  const cellMatrix = [];
  const sizeMatrix = [];
  const longestCellByColumn = [];
  let mostCellsPerRow = 0;
  let rowIndex = -1;
  while (++rowIndex < table.length) {
    const row2 = [];
    const sizes2 = [];
    let columnIndex2 = -1;
    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length;
    }
    while (++columnIndex2 < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex2]);
      if (options.alignDelimiters !== false) {
        const size = stringLength(cell);
        sizes2[columnIndex2] = size;
        if (longestCellByColumn[columnIndex2] === void 0 || size > longestCellByColumn[columnIndex2]) {
          longestCellByColumn[columnIndex2] = size;
        }
      }
      row2.push(cell);
    }
    cellMatrix[rowIndex] = row2;
    sizeMatrix[rowIndex] = sizes2;
  }
  let columnIndex = -1;
  if (typeof align === "object" && "length" in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    const code3 = toAlignment(align);
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code3;
    }
  }
  columnIndex = -1;
  const row = [];
  const sizes = [];
  while (++columnIndex < mostCellsPerRow) {
    const code3 = alignments[columnIndex];
    let before = "";
    let after = "";
    if (code3 === 99) {
      before = ":";
      after = ":";
    } else if (code3 === 108) {
      before = ":";
    } else if (code3 === 114) {
      after = ":";
    }
    let size = options.alignDelimiters === false ? 1 : Math.max(
      1,
      longestCellByColumn[columnIndex] - before.length - after.length
    );
    const cell = before + "-".repeat(size) + after;
    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length;
      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size;
      }
      sizes[columnIndex] = size;
    }
    row[columnIndex] = cell;
  }
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes);
  rowIndex = -1;
  const lines = [];
  while (++rowIndex < cellMatrix.length) {
    const row2 = cellMatrix[rowIndex];
    const sizes2 = sizeMatrix[rowIndex];
    columnIndex = -1;
    const line = [];
    while (++columnIndex < mostCellsPerRow) {
      const cell = row2[columnIndex] || "";
      let before = "";
      let after = "";
      if (options.alignDelimiters !== false) {
        const size = longestCellByColumn[columnIndex] - (sizes2[columnIndex] || 0);
        const code3 = alignments[columnIndex];
        if (code3 === 114) {
          before = " ".repeat(size);
        } else if (code3 === 99) {
          if (size % 2) {
            before = " ".repeat(size / 2 + 0.5);
            after = " ".repeat(size / 2 - 0.5);
          } else {
            before = " ".repeat(size / 2);
            after = before;
          }
        } else {
          after = " ".repeat(size);
        }
      }
      if (options.delimiterStart !== false && !columnIndex) {
        line.push("|");
      }
      if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) {
        line.push(" ");
      }
      if (options.alignDelimiters !== false) {
        line.push(before);
      }
      line.push(cell);
      if (options.alignDelimiters !== false) {
        line.push(after);
      }
      if (options.padding !== false) {
        line.push(" ");
      }
      if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) {
        line.push("|");
      }
    }
    lines.push(
      options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join("")
    );
  }
  return lines.join("\n");
}
function serialize(value) {
  return value === null || value === void 0 ? "" : String(value);
}
function defaultStringLength(value) {
  return value.length;
}
function toAlignment(value) {
  const code3 = typeof value === "string" ? value.codePointAt(0) : 0;
  return code3 === 67 || code3 === 99 ? 99 : code3 === 76 || code3 === 108 ? 108 : code3 === 82 || code3 === 114 ? 114 : 0;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/blockquote.js
function blockquote(node2, _, state, info) {
  const exit2 = state.enter("blockquote");
  const tracker = state.createTracker(info);
  tracker.move("> ");
  tracker.shift(2);
  const value = state.indentLines(
    state.containerFlow(node2, tracker.current()),
    map2
  );
  exit2();
  return value;
}
function map2(line, _, blank) {
  return ">" + (blank ? "" : " ") + line;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/pattern-in-scope.js
function patternInScope(stack, pattern) {
  return listInScope(stack, pattern.inConstruct, true) && !listInScope(stack, pattern.notInConstruct, false);
}
function listInScope(stack, list2, none) {
  if (typeof list2 === "string") {
    list2 = [list2];
  }
  if (!list2 || list2.length === 0) {
    return none;
  }
  let index = -1;
  while (++index < list2.length) {
    if (stack.includes(list2[index])) {
      return true;
    }
  }
  return false;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/break.js
function hardBreak(_, _1, state, info) {
  let index = -1;
  while (++index < state.unsafe.length) {
    if (state.unsafe[index].character === "\n" && patternInScope(state.stack, state.unsafe[index])) {
      return /[ \t]/.test(info.before) ? "" : " ";
    }
  }
  return "\\\n";
}

// ../../node_modules/longest-streak/index.js
function longestStreak(value, substring) {
  const source = String(value);
  let index = source.indexOf(substring);
  let expected = index;
  let count = 0;
  let max = 0;
  if (typeof substring !== "string") {
    throw new TypeError("Expected substring");
  }
  while (index !== -1) {
    if (index === expected) {
      if (++count > max) {
        max = count;
      }
    } else {
      count = 1;
    }
    expected = index + substring.length;
    index = source.indexOf(substring, expected);
  }
  return max;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/format-code-as-indented.js
function formatCodeAsIndented(node2, state) {
  return Boolean(
    state.options.fences === false && node2.value && // If there’s no info…
    !node2.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node2.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node2.value)
  );
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-fence.js
function checkFence(state) {
  const marker = state.options.fence || "`";
  if (marker !== "`" && marker !== "~") {
    throw new Error(
      "Cannot serialize code with `" + marker + "` for `options.fence`, expected `` ` `` or `~`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/code.js
function code(node2, _, state, info) {
  const marker = checkFence(state);
  const raw = node2.value || "";
  const suffix = marker === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(node2, state)) {
    const exit3 = state.enter("codeIndented");
    const value2 = state.indentLines(raw, map3);
    exit3();
    return value2;
  }
  const tracker = state.createTracker(info);
  const sequence = marker.repeat(Math.max(longestStreak(raw, marker) + 1, 3));
  const exit2 = state.enter("codeFenced");
  let value = tracker.move(sequence);
  if (node2.lang) {
    const subexit = state.enter(`codeFencedLang${suffix}`);
    value += tracker.move(
      state.safe(node2.lang, {
        before: value,
        after: " ",
        encode: ["`"],
        ...tracker.current()
      })
    );
    subexit();
  }
  if (node2.lang && node2.meta) {
    const subexit = state.enter(`codeFencedMeta${suffix}`);
    value += tracker.move(" ");
    value += tracker.move(
      state.safe(node2.meta, {
        before: value,
        after: "\n",
        encode: ["`"],
        ...tracker.current()
      })
    );
    subexit();
  }
  value += tracker.move("\n");
  if (raw) {
    value += tracker.move(raw + "\n");
  }
  value += tracker.move(sequence);
  exit2();
  return value;
}
function map3(line, _, blank) {
  return (blank ? "" : "    ") + line;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-quote.js
function checkQuote(state) {
  const marker = state.options.quote || '"';
  if (marker !== '"' && marker !== "'") {
    throw new Error(
      "Cannot serialize title with `" + marker + "` for `options.quote`, expected `\"`, or `'`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/definition.js
function definition(node2, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? "Quote" : "Apostrophe";
  const exit2 = state.enter("definition");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("[");
  value += tracker.move(
    state.safe(state.associationId(node2), {
      before: value,
      after: "]",
      ...tracker.current()
    })
  );
  value += tracker.move("]: ");
  subexit();
  if (
    // If there’s no url, or…
    !node2.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : "\n",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  exit2();
  return value;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-emphasis.js
function checkEmphasis(state) {
  const marker = state.options.emphasis || "*";
  if (marker !== "*" && marker !== "_") {
    throw new Error(
      "Cannot serialize emphasis with `" + marker + "` for `options.emphasis`, expected `*`, or `_`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/emphasis.js
emphasis.peek = emphasisPeek;
function emphasis(node2, _, state, info) {
  const marker = checkEmphasis(state);
  const exit2 = state.enter("emphasis");
  const tracker = state.createTracker(info);
  let value = tracker.move(marker);
  value += tracker.move(
    state.containerPhrasing(node2, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  );
  value += tracker.move(marker);
  exit2();
  return value;
}
function emphasisPeek(_, _1, state) {
  return state.options.emphasis || "*";
}

// ../../node_modules/unist-util-visit/lib/index.js
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  let reverse;
  let test;
  let visitor;
  if (typeof testOrVisitor === "function" && typeof visitorOrReverse !== "function") {
    test = void 0;
    visitor = testOrVisitor;
    reverse = visitorOrReverse;
  } else {
    test = testOrVisitor;
    visitor = visitorOrReverse;
    reverse = maybeReverse;
  }
  visitParents(tree, test, overload, reverse);
  function overload(node2, parents) {
    const parent = parents[parents.length - 1];
    const index = parent ? parent.children.indexOf(node2) : void 0;
    return visitor(node2, index, parent);
  }
}

// ../../node_modules/mdast-util-to-string/lib/index.js
var emptyOptions = {};
function toString(value, options) {
  const settings = emptyOptions;
  const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
  const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
  return one(value, includeImageAlt, includeHtml);
}
function one(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ("value" in value) {
      return value.type === "html" && !includeHtml ? "" : value.value;
    }
    if (includeImageAlt && "alt" in value && value.alt) {
      return value.alt;
    }
    if ("children" in value) {
      return all2(value.children, includeImageAlt, includeHtml);
    }
  }
  if (Array.isArray(value)) {
    return all2(value, includeImageAlt, includeHtml);
  }
  return "";
}
function all2(values, includeImageAlt, includeHtml) {
  const result = [];
  let index = -1;
  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt, includeHtml);
  }
  return result.join("");
}
function node(value) {
  return Boolean(value && typeof value === "object");
}

// ../../node_modules/mdast-util-to-markdown/lib/util/format-heading-as-setext.js
function formatHeadingAsSetext(node2, state) {
  let literalWithBreak = false;
  visit(node2, function(node3) {
    if ("value" in node3 && /\r?\n|\r/.test(node3.value) || node3.type === "break") {
      literalWithBreak = true;
      return EXIT;
    }
  });
  return Boolean(
    (!node2.depth || node2.depth < 3) && toString(node2) && (state.options.setext || literalWithBreak)
  );
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/heading.js
function heading(node2, _, state, info) {
  const rank = Math.max(Math.min(6, node2.depth || 1), 1);
  const tracker = state.createTracker(info);
  if (formatHeadingAsSetext(node2, state)) {
    const exit3 = state.enter("headingSetext");
    const subexit2 = state.enter("phrasing");
    const value2 = state.containerPhrasing(node2, {
      ...tracker.current(),
      before: "\n",
      after: "\n"
    });
    subexit2();
    exit3();
    return value2 + "\n" + (rank === 1 ? "=" : "-").repeat(
      // The whole size…
      value2.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(value2.lastIndexOf("\r"), value2.lastIndexOf("\n")) + 1)
    );
  }
  const sequence = "#".repeat(rank);
  const exit2 = state.enter("headingAtx");
  const subexit = state.enter("phrasing");
  tracker.move(sequence + " ");
  let value = state.containerPhrasing(node2, {
    before: "# ",
    after: "\n",
    ...tracker.current()
  });
  if (/^[\t ]/.test(value)) {
    value = "&#x" + value.charCodeAt(0).toString(16).toUpperCase() + ";" + value.slice(1);
  }
  value = value ? sequence + " " + value : sequence;
  if (state.options.closeAtx) {
    value += " " + sequence;
  }
  subexit();
  exit2();
  return value;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/html.js
html.peek = htmlPeek;
function html(node2) {
  return node2.value || "";
}
function htmlPeek() {
  return "<";
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/image.js
image.peek = imagePeek;
function image(node2, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? "Quote" : "Apostrophe";
  const exit2 = state.enter("image");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("![");
  value += tracker.move(
    state.safe(node2.alt, { before: value, after: "]", ...tracker.current() })
  );
  value += tracker.move("](");
  subexit();
  if (
    // If there’s no url but there is a title…
    !node2.url && node2.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : ")",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  value += tracker.move(")");
  exit2();
  return value;
}
function imagePeek() {
  return "!";
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/image-reference.js
imageReference.peek = imageReferencePeek;
function imageReference(node2, _, state, info) {
  const type2 = node2.referenceType;
  const exit2 = state.enter("imageReference");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("![");
  const alt = state.safe(node2.alt, {
    before: value,
    after: "]",
    ...tracker.current()
  });
  value += tracker.move(alt + "][");
  subexit();
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter("reference");
  const reference = state.safe(state.associationId(node2), {
    before: value,
    after: "]",
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit2();
  if (type2 === "full" || !alt || alt !== reference) {
    value += tracker.move(reference + "]");
  } else if (type2 === "shortcut") {
    value = value.slice(0, -1);
  } else {
    value += tracker.move("]");
  }
  return value;
}
function imageReferencePeek() {
  return "!";
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/inline-code.js
inlineCode.peek = inlineCodePeek;
function inlineCode(node2, _, state) {
  let value = node2.value || "";
  let sequence = "`";
  let index = -1;
  while (new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value)) {
    sequence += "`";
  }
  if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) {
    value = " " + value + " ";
  }
  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index];
    const expression = state.compilePattern(pattern);
    let match;
    if (!pattern.atBreak) continue;
    while (match = expression.exec(value)) {
      let position = match.index;
      if (value.charCodeAt(position) === 10 && value.charCodeAt(position - 1) === 13) {
        position--;
      }
      value = value.slice(0, position) + " " + value.slice(match.index + 1);
    }
  }
  return sequence + value + sequence;
}
function inlineCodePeek() {
  return "`";
}

// ../../node_modules/mdast-util-to-markdown/lib/util/format-link-as-autolink.js
function formatLinkAsAutolink(node2, state) {
  const raw = toString(node2);
  return Boolean(
    !state.options.resourceLink && // If there’s a url…
    node2.url && // And there’s a no title…
    !node2.title && // And the content of `node` is a single text node…
    node2.children && node2.children.length === 1 && node2.children[0].type === "text" && // And if the url is the same as the content…
    (raw === node2.url || "mailto:" + raw === node2.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node2.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node2.url)
  );
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/link.js
link.peek = linkPeek;
function link(node2, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? "Quote" : "Apostrophe";
  const tracker = state.createTracker(info);
  let exit2;
  let subexit;
  if (formatLinkAsAutolink(node2, state)) {
    const stack = state.stack;
    state.stack = [];
    exit2 = state.enter("autolink");
    let value2 = tracker.move("<");
    value2 += tracker.move(
      state.containerPhrasing(node2, {
        before: value2,
        after: ">",
        ...tracker.current()
      })
    );
    value2 += tracker.move(">");
    exit2();
    state.stack = stack;
    return value2;
  }
  exit2 = state.enter("link");
  subexit = state.enter("label");
  let value = tracker.move("[");
  value += tracker.move(
    state.containerPhrasing(node2, {
      before: value,
      after: "](",
      ...tracker.current()
    })
  );
  value += tracker.move("](");
  subexit();
  if (
    // If there’s no url but there is a title…
    !node2.url && node2.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : ")",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  value += tracker.move(")");
  exit2();
  return value;
}
function linkPeek(node2, _, state) {
  return formatLinkAsAutolink(node2, state) ? "<" : "[";
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/link-reference.js
linkReference.peek = linkReferencePeek;
function linkReference(node2, _, state, info) {
  const type2 = node2.referenceType;
  const exit2 = state.enter("linkReference");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("[");
  const text3 = state.containerPhrasing(node2, {
    before: value,
    after: "]",
    ...tracker.current()
  });
  value += tracker.move(text3 + "][");
  subexit();
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter("reference");
  const reference = state.safe(state.associationId(node2), {
    before: value,
    after: "]",
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit2();
  if (type2 === "full" || !text3 || text3 !== reference) {
    value += tracker.move(reference + "]");
  } else if (type2 === "shortcut") {
    value = value.slice(0, -1);
  } else {
    value += tracker.move("]");
  }
  return value;
}
function linkReferencePeek() {
  return "[";
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-bullet.js
function checkBullet(state) {
  const marker = state.options.bullet || "*";
  if (marker !== "*" && marker !== "+" && marker !== "-") {
    throw new Error(
      "Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-bullet-other.js
function checkBulletOther(state) {
  const bullet = checkBullet(state);
  const bulletOther = state.options.bulletOther;
  if (!bulletOther) {
    return bullet === "*" ? "-" : "*";
  }
  if (bulletOther !== "*" && bulletOther !== "+" && bulletOther !== "-") {
    throw new Error(
      "Cannot serialize items with `" + bulletOther + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  }
  if (bulletOther === bullet) {
    throw new Error(
      "Expected `bullet` (`" + bullet + "`) and `bulletOther` (`" + bulletOther + "`) to be different"
    );
  }
  return bulletOther;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-bullet-ordered.js
function checkBulletOrdered(state) {
  const marker = state.options.bulletOrdered || ".";
  if (marker !== "." && marker !== ")") {
    throw new Error(
      "Cannot serialize items with `" + marker + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-rule.js
function checkRule(state) {
  const marker = state.options.rule || "*";
  if (marker !== "*" && marker !== "-" && marker !== "_") {
    throw new Error(
      "Cannot serialize rules with `" + marker + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/list.js
function list(node2, parent, state, info) {
  const exit2 = state.enter("list");
  const bulletCurrent = state.bulletCurrent;
  let bullet = node2.ordered ? checkBulletOrdered(state) : checkBullet(state);
  const bulletOther = node2.ordered ? bullet === "." ? ")" : "." : checkBulletOther(state);
  let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
  if (!node2.ordered) {
    const firstListItem = node2.children ? node2.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (bullet === "*" || bullet === "-") && // Empty first list item:
      firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
      state.stack[state.stack.length - 1] === "list" && state.stack[state.stack.length - 2] === "listItem" && state.stack[state.stack.length - 3] === "list" && state.stack[state.stack.length - 4] === "listItem" && // That are each the first child.
      state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0
    ) {
      useDifferentMarker = true;
    }
    if (checkRule(state) === bullet && firstListItem) {
      let index = -1;
      while (++index < node2.children.length) {
        const item = node2.children[index];
        if (item && item.type === "listItem" && item.children && item.children[0] && item.children[0].type === "thematicBreak") {
          useDifferentMarker = true;
          break;
        }
      }
    }
  }
  if (useDifferentMarker) {
    bullet = bulletOther;
  }
  state.bulletCurrent = bullet;
  const value = state.containerFlow(node2, info);
  state.bulletLastUsed = bullet;
  state.bulletCurrent = bulletCurrent;
  exit2();
  return value;
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-list-item-indent.js
function checkListItemIndent(state) {
  const style = state.options.listItemIndent || "one";
  if (style !== "tab" && style !== "one" && style !== "mixed") {
    throw new Error(
      "Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  }
  return style;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/list-item.js
function listItem(node2, parent, state, info) {
  const listItemIndent = checkListItemIndent(state);
  let bullet = state.bulletCurrent || checkBullet(state);
  if (parent && parent.type === "list" && parent.ordered) {
    bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node2)) + bullet;
  }
  let size = bullet.length + 1;
  if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node2.spread)) {
    size = Math.ceil(size / 4) * 4;
  }
  const tracker = state.createTracker(info);
  tracker.move(bullet + " ".repeat(size - bullet.length));
  tracker.shift(size);
  const exit2 = state.enter("listItem");
  const value = state.indentLines(
    state.containerFlow(node2, tracker.current()),
    map4
  );
  exit2();
  return value;
  function map4(line, index, blank) {
    if (index) {
      return (blank ? "" : " ".repeat(size)) + line;
    }
    return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
  }
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/paragraph.js
function paragraph(node2, _, state, info) {
  const exit2 = state.enter("paragraph");
  const subexit = state.enter("phrasing");
  const value = state.containerPhrasing(node2, info);
  subexit();
  exit2();
  return value;
}

// ../../node_modules/mdast-util-phrasing/node_modules/unist-util-is/lib/index.js
var convert3 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(test) {
    if (test === null || test === void 0) {
      return ok4;
    }
    if (typeof test === "function") {
      return castFactory3(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory3(test) : propsFactory3(test);
    }
    if (typeof test === "string") {
      return typeFactory3(test);
    }
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory3(tests) {
  const checks = [];
  let index = -1;
  while (++index < tests.length) {
    checks[index] = convert3(tests[index]);
  }
  return castFactory3(any);
  function any(...parameters) {
    let index2 = -1;
    while (++index2 < checks.length) {
      if (checks[index2].apply(this, parameters)) return true;
    }
    return false;
  }
}
function propsFactory3(check) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check
  );
  return castFactory3(all3);
  function all3(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
    }
    return true;
  }
}
function typeFactory3(check) {
  return castFactory3(type2);
  function type2(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory3(testFunction) {
  return check;
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode3(value) && testFunction.call(
        this,
        value,
        typeof index === "number" ? index : void 0,
        parent || void 0
      )
    );
  }
}
function ok4() {
  return true;
}
function looksLikeANode3(value) {
  return value !== null && typeof value === "object" && "type" in value;
}

// ../../node_modules/mdast-util-phrasing/lib/index.js
var phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert3([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);

// ../../node_modules/mdast-util-to-markdown/lib/handle/root.js
function root(node2, _, state, info) {
  const hasPhrasing = node2.children.some(function(d) {
    return phrasing(d);
  });
  const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow;
  return fn.call(state, node2, info);
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-strong.js
function checkStrong(state) {
  const marker = state.options.strong || "*";
  if (marker !== "*" && marker !== "_") {
    throw new Error(
      "Cannot serialize strong with `" + marker + "` for `options.strong`, expected `*`, or `_`"
    );
  }
  return marker;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/strong.js
strong.peek = strongPeek;
function strong(node2, _, state, info) {
  const marker = checkStrong(state);
  const exit2 = state.enter("strong");
  const tracker = state.createTracker(info);
  let value = tracker.move(marker + marker);
  value += tracker.move(
    state.containerPhrasing(node2, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  );
  value += tracker.move(marker + marker);
  exit2();
  return value;
}
function strongPeek(_, _1, state) {
  return state.options.strong || "*";
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/text.js
function text(node2, _, state, info) {
  return state.safe(node2.value, info);
}

// ../../node_modules/mdast-util-to-markdown/lib/util/check-rule-repetition.js
function checkRuleRepetition(state) {
  const repetition = state.options.ruleRepetition || 3;
  if (repetition < 3) {
    throw new Error(
      "Cannot serialize rules with repetition `" + repetition + "` for `options.ruleRepetition`, expected `3` or more"
    );
  }
  return repetition;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/thematic-break.js
function thematicBreak(_, _1, state) {
  const value = (checkRule(state) + (state.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(state));
  return state.options.ruleSpaces ? value.slice(0, -1) : value;
}

// ../../node_modules/mdast-util-to-markdown/lib/handle/index.js
var handle = {
  blockquote,
  break: hardBreak,
  code,
  definition,
  emphasis,
  hardBreak,
  heading,
  html,
  image,
  imageReference,
  inlineCode,
  link,
  linkReference,
  list,
  listItem,
  paragraph,
  root,
  strong,
  text,
  thematicBreak
};

// ../../node_modules/mdast-util-gfm-table/lib/index.js
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(token) {
  const align = token._align;
  this.enter(
    {
      type: "table",
      align: align.map(function(d) {
        return d === "none" ? null : d;
      }),
      children: []
    },
    token
  );
  this.data.inTable = true;
}
function exitTable(token) {
  this.exit(token);
  this.data.inTable = void 0;
}
function enterRow(token) {
  this.enter({ type: "tableRow", children: [] }, token);
}
function exit(token) {
  this.exit(token);
}
function enterCell(token) {
  this.enter({ type: "tableCell", children: [] }, token);
}
function exitCodeText(token) {
  let value = this.resume();
  if (this.data.inTable) {
    value = value.replace(/\\([\\|])/g, replace);
  }
  const node2 = this.stack[this.stack.length - 1];
  ok(node2.type === "inlineCode");
  node2.value = value;
  this.exit(token);
}
function replace($0, $1) {
  return $1 === "|" ? $1 : $0;
}
function gfmTableToMarkdown(options) {
  const settings = options || {};
  const padding = settings.tableCellPadding;
  const alignDelimiters = settings.tablePipeAlign;
  const stringLength = settings.stringLength;
  const around = padding ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: "\n", inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: true, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: true, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: true, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: inlineCodeWithTable,
      table: handleTable,
      tableCell: handleTableCell,
      tableRow: handleTableRow
    }
  };
  function handleTable(node2, _, state, info) {
    return serializeData(handleTableAsData(node2, state, info), node2.align);
  }
  function handleTableRow(node2, _, state, info) {
    const row = handleTableRowAsData(node2, state, info);
    const value = serializeData([row]);
    return value.slice(0, value.indexOf("\n"));
  }
  function handleTableCell(node2, _, state, info) {
    const exit2 = state.enter("tableCell");
    const subexit = state.enter("phrasing");
    const value = state.containerPhrasing(node2, {
      ...info,
      before: around,
      after: around
    });
    subexit();
    exit2();
    return value;
  }
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    });
  }
  function handleTableAsData(node2, state, info) {
    const children = node2.children;
    let index = -1;
    const result = [];
    const subexit = state.enter("table");
    while (++index < children.length) {
      result[index] = handleTableRowAsData(children[index], state, info);
    }
    subexit();
    return result;
  }
  function handleTableRowAsData(node2, state, info) {
    const children = node2.children;
    let index = -1;
    const result = [];
    const subexit = state.enter("tableRow");
    while (++index < children.length) {
      result[index] = handleTableCell(children[index], node2, state, info);
    }
    subexit();
    return result;
  }
  function inlineCodeWithTable(node2, parent, state) {
    let value = handle.inlineCode(node2, parent, state);
    if (state.stack.includes("tableCell")) {
      value = value.replace(/\|/g, "\\$&");
    }
    return value;
  }
}

// ../../node_modules/mdast-util-gfm-task-list-item/lib/index.js
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: true, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(token) {
  const node2 = this.stack[this.stack.length - 2];
  ok(node2.type === "listItem");
  node2.checked = token.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(token) {
  const parent = this.stack[this.stack.length - 2];
  if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
    const node2 = this.stack[this.stack.length - 1];
    ok(node2.type === "paragraph");
    const head = node2.children[0];
    if (head && head.type === "text") {
      const siblings = parent.children;
      let index = -1;
      let firstParaghraph;
      while (++index < siblings.length) {
        const sibling = siblings[index];
        if (sibling.type === "paragraph") {
          firstParaghraph = sibling;
          break;
        }
      }
      if (firstParaghraph === node2) {
        head.value = head.value.slice(1);
        if (head.value.length === 0) {
          node2.children.shift();
        } else if (node2.position && head.position && typeof head.position.start.offset === "number") {
          head.position.start.column++;
          head.position.start.offset++;
          node2.position.start = Object.assign({}, head.position.start);
        }
      }
    }
  }
  this.exit(token);
}
function listItemWithTaskListItem(node2, parent, state, info) {
  const head = node2.children[0];
  const checkable = typeof node2.checked === "boolean" && head && head.type === "paragraph";
  const checkbox = "[" + (node2.checked ? "x" : " ") + "] ";
  const tracker = state.createTracker(info);
  if (checkable) {
    tracker.move(checkbox);
  }
  let value = handle.listItem(node2, parent, state, {
    ...info,
    ...tracker.current()
  });
  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }
  return value;
  function check($0) {
    return $0 + checkbox;
  }
}

// ../../node_modules/mdast-util-gfm/lib/index.js
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown()
    ]
  };
}

// ../../node_modules/micromark-util-chunked/index.js
function splice(list2, start, remove, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    list2.splice(...parameters);
  } else {
    if (remove) list2.splice(start, remove);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}

// ../../node_modules/micromark-util-combine-extensions/index.js
var hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all3 = {};
  let index = -1;
  while (++index < extensions.length) {
    syntaxExtension(all3, extensions[index]);
  }
  return all3;
}
function syntaxExtension(all3, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty.call(all3, hook) ? all3[hook] : void 0;
    const left = maybe || (all3[hook] = {});
    const right = extension[hook];
    let code3;
    if (right) {
      for (code3 in right) {
        if (!hasOwnProperty.call(left, code3)) left[code3] = [];
        const value = right[code3];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code3],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index = -1;
  const before = [];
  while (++index < list2.length) {
    (list2[index].add === "after" ? existing : before).push(list2[index]);
  }
  splice(existing, 0, 0, before);
}

// ../../node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
var wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
};
var domain = {
  tokenize: tokenizeDomain,
  partial: true
};
var path = {
  tokenize: tokenizePath,
  partial: true
};
var trail = {
  tokenize: tokenizeTrail,
  partial: true
};
var emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
};
var wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
var protocolAutolink = {
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
};
var emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
var text2 = {};
function gfmAutolinkLiteral() {
  return {
    text: text2
  };
}
var code2 = 48;
while (code2 < 123) {
  text2[code2] = emailAutolink;
  code2++;
  if (code2 === 58) code2 = 65;
  else if (code2 === 91) code2 = 97;
}
text2[43] = emailAutolink;
text2[45] = emailAutolink;
text2[46] = emailAutolink;
text2[95] = emailAutolink;
text2[72] = [emailAutolink, protocolAutolink];
text2[104] = [emailAutolink, protocolAutolink];
text2[87] = [emailAutolink, wwwAutolink];
text2[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok5, nok) {
  const self = this;
  let dot;
  let data;
  return start;
  function start(code3) {
    if (!gfmAtext(code3) || !previousEmail.call(self, self.previous) || previousUnbalanced(self.events)) {
      return nok(code3);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkEmail");
    return atext(code3);
  }
  function atext(code3) {
    if (gfmAtext(code3)) {
      effects.consume(code3);
      return atext;
    }
    if (code3 === 64) {
      effects.consume(code3);
      return emailDomain;
    }
    return nok(code3);
  }
  function emailDomain(code3) {
    if (code3 === 46) {
      return effects.check(
        emailDomainDotTrail,
        emailDomainAfter,
        emailDomainDot
      )(code3);
    }
    if (code3 === 45 || code3 === 95 || asciiAlphanumeric(code3)) {
      data = true;
      effects.consume(code3);
      return emailDomain;
    }
    return emailDomainAfter(code3);
  }
  function emailDomainDot(code3) {
    effects.consume(code3);
    dot = true;
    return emailDomain;
  }
  function emailDomainAfter(code3) {
    if (data && dot && asciiAlpha(self.previous)) {
      effects.exit("literalAutolinkEmail");
      effects.exit("literalAutolink");
      return ok5(code3);
    }
    return nok(code3);
  }
}
function tokenizeWwwAutolink(effects, ok5, nok) {
  const self = this;
  return wwwStart;
  function wwwStart(code3) {
    if (code3 !== 87 && code3 !== 119 || !previousWww.call(self, self.previous) || previousUnbalanced(self.events)) {
      return nok(code3);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkWww");
    return effects.check(
      wwwPrefix,
      effects.attempt(domain, effects.attempt(path, wwwAfter), nok),
      nok
    )(code3);
  }
  function wwwAfter(code3) {
    effects.exit("literalAutolinkWww");
    effects.exit("literalAutolink");
    return ok5(code3);
  }
}
function tokenizeProtocolAutolink(effects, ok5, nok) {
  const self = this;
  let buffer = "";
  let seen = false;
  return protocolStart;
  function protocolStart(code3) {
    if ((code3 === 72 || code3 === 104) && previousProtocol.call(self, self.previous) && !previousUnbalanced(self.events)) {
      effects.enter("literalAutolink");
      effects.enter("literalAutolinkHttp");
      buffer += String.fromCodePoint(code3);
      effects.consume(code3);
      return protocolPrefixInside;
    }
    return nok(code3);
  }
  function protocolPrefixInside(code3) {
    if (asciiAlpha(code3) && buffer.length < 5) {
      buffer += String.fromCodePoint(code3);
      effects.consume(code3);
      return protocolPrefixInside;
    }
    if (code3 === 58) {
      const protocol = buffer.toLowerCase();
      if (protocol === "http" || protocol === "https") {
        effects.consume(code3);
        return protocolSlashesInside;
      }
    }
    return nok(code3);
  }
  function protocolSlashesInside(code3) {
    if (code3 === 47) {
      effects.consume(code3);
      if (seen) {
        return afterProtocol;
      }
      seen = true;
      return protocolSlashesInside;
    }
    return nok(code3);
  }
  function afterProtocol(code3) {
    return code3 === null || asciiControl(code3) || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3) || unicodePunctuation(code3) ? nok(code3) : effects.attempt(domain, effects.attempt(path, protocolAfter), nok)(code3);
  }
  function protocolAfter(code3) {
    effects.exit("literalAutolinkHttp");
    effects.exit("literalAutolink");
    return ok5(code3);
  }
}
function tokenizeWwwPrefix(effects, ok5, nok) {
  let size = 0;
  return wwwPrefixInside;
  function wwwPrefixInside(code3) {
    if ((code3 === 87 || code3 === 119) && size < 3) {
      size++;
      effects.consume(code3);
      return wwwPrefixInside;
    }
    if (code3 === 46 && size === 3) {
      effects.consume(code3);
      return wwwPrefixAfter;
    }
    return nok(code3);
  }
  function wwwPrefixAfter(code3) {
    return code3 === null ? nok(code3) : ok5(code3);
  }
}
function tokenizeDomain(effects, ok5, nok) {
  let underscoreInLastSegment;
  let underscoreInLastLastSegment;
  let seen;
  return domainInside;
  function domainInside(code3) {
    if (code3 === 46 || code3 === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code3);
    }
    if (code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3) || code3 !== 45 && unicodePunctuation(code3)) {
      return domainAfter(code3);
    }
    seen = true;
    effects.consume(code3);
    return domainInside;
  }
  function domainAtPunctuation(code3) {
    if (code3 === 95) {
      underscoreInLastSegment = true;
    } else {
      underscoreInLastLastSegment = underscoreInLastSegment;
      underscoreInLastSegment = void 0;
    }
    effects.consume(code3);
    return domainInside;
  }
  function domainAfter(code3) {
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code3);
    }
    return ok5(code3);
  }
}
function tokenizePath(effects, ok5) {
  let sizeOpen = 0;
  let sizeClose = 0;
  return pathInside;
  function pathInside(code3) {
    if (code3 === 40) {
      sizeOpen++;
      effects.consume(code3);
      return pathInside;
    }
    if (code3 === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code3);
    }
    if (code3 === 33 || code3 === 34 || code3 === 38 || code3 === 39 || code3 === 41 || code3 === 42 || code3 === 44 || code3 === 46 || code3 === 58 || code3 === 59 || code3 === 60 || code3 === 63 || code3 === 93 || code3 === 95 || code3 === 126) {
      return effects.check(trail, ok5, pathAtPunctuation)(code3);
    }
    if (code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)) {
      return ok5(code3);
    }
    effects.consume(code3);
    return pathInside;
  }
  function pathAtPunctuation(code3) {
    if (code3 === 41) {
      sizeClose++;
    }
    effects.consume(code3);
    return pathInside;
  }
}
function tokenizeTrail(effects, ok5, nok) {
  return trail2;
  function trail2(code3) {
    if (code3 === 33 || code3 === 34 || code3 === 39 || code3 === 41 || code3 === 42 || code3 === 44 || code3 === 46 || code3 === 58 || code3 === 59 || code3 === 63 || code3 === 95 || code3 === 126) {
      effects.consume(code3);
      return trail2;
    }
    if (code3 === 38) {
      effects.consume(code3);
      return trailCharRefStart;
    }
    if (code3 === 93) {
      effects.consume(code3);
      return trailBracketAfter;
    }
    if (
      // `<` is an end.
      code3 === 60 || // So is whitespace.
      code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)
    ) {
      return ok5(code3);
    }
    return nok(code3);
  }
  function trailBracketAfter(code3) {
    if (code3 === null || code3 === 40 || code3 === 91 || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)) {
      return ok5(code3);
    }
    return trail2(code3);
  }
  function trailCharRefStart(code3) {
    return asciiAlpha(code3) ? trailCharRefInside(code3) : nok(code3);
  }
  function trailCharRefInside(code3) {
    if (code3 === 59) {
      effects.consume(code3);
      return trail2;
    }
    if (asciiAlpha(code3)) {
      effects.consume(code3);
      return trailCharRefInside;
    }
    return nok(code3);
  }
}
function tokenizeEmailDomainDotTrail(effects, ok5, nok) {
  return start;
  function start(code3) {
    effects.consume(code3);
    return after;
  }
  function after(code3) {
    return asciiAlphanumeric(code3) ? nok(code3) : ok5(code3);
  }
}
function previousWww(code3) {
  return code3 === null || code3 === 40 || code3 === 42 || code3 === 95 || code3 === 91 || code3 === 93 || code3 === 126 || markdownLineEndingOrSpace(code3);
}
function previousProtocol(code3) {
  return !asciiAlpha(code3);
}
function previousEmail(code3) {
  return !(code3 === 47 || gfmAtext(code3));
}
function gfmAtext(code3) {
  return code3 === 43 || code3 === 45 || code3 === 46 || code3 === 95 || asciiAlphanumeric(code3);
}
function previousUnbalanced(events) {
  let index = events.length;
  let result = false;
  while (index--) {
    const token = events[index][1];
    if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
      result = true;
      break;
    }
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break;
    }
  }
  if (events.length > 0 && !result) {
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }
  return result;
}

// ../../node_modules/micromark-util-classify-character/index.js
function classifyCharacter(code3) {
  if (code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)) {
    return 1;
  }
  if (unicodePunctuation(code3)) {
    return 2;
  }
}

// ../../node_modules/micromark-util-resolve-all/index.js
function resolveAll(constructs2, events, context) {
  const called = [];
  let index = -1;
  while (++index < constructs2.length) {
    const resolve = constructs2[index].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }
  return events;
}

// ../../node_modules/micromark-factory-space/index.js
function factorySpace(effects, ok5, type2, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start;
  function start(code3) {
    if (markdownSpace(code3)) {
      effects.enter(type2);
      return prefix(code3);
    }
    return ok5(code3);
  }
  function prefix(code3) {
    if (markdownSpace(code3) && size++ < limit) {
      effects.consume(code3);
      return prefix;
    }
    effects.exit(type2);
    return ok5(code3);
  }
}

// ../../node_modules/micromark-core-commonmark/lib/blank-line.js
var blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
};
function tokenizeBlankLine(effects, ok5, nok) {
  return start;
  function start(code3) {
    return markdownSpace(code3) ? factorySpace(effects, after, "linePrefix")(code3) : after(code3);
  }
  function after(code3) {
    return code3 === null || markdownLineEnding(code3) ? ok5(code3) : nok(code3);
  }
}

// ../../node_modules/micromark-extension-gfm-footnote/lib/syntax.js
var indent = {
  tokenize: tokenizeIndent,
  partial: true
};
function gfmFootnote() {
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(effects, ok5, nok) {
  const self = this;
  let index = self.events.length;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  let labelStart;
  while (index--) {
    const token = self.events[index][1];
    if (token.type === "labelImage") {
      labelStart = token;
      break;
    }
    if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") {
      break;
    }
  }
  return start;
  function start(code3) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code3);
    }
    const id = normalizeIdentifier(
      self.sliceSerialize({
        start: labelStart.end,
        end: self.now()
      })
    );
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code3);
    }
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallLabelMarker");
    return ok5(code3);
  }
}
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length;
  while (index--) {
    if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
      events[index][1];
      break;
    }
  }
  events[index + 1][1].type = "data";
  events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
  const call = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const marker = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  };
  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  const string = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  };
  const chunk = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  };
  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index + 1],
    events[index + 2],
    ["enter", call, context],
    // The `[`
    events[index + 3],
    events[index + 4],
    // The `^`.
    ["enter", marker, context],
    ["exit", marker, context],
    // Everything in between.
    ["enter", string, context],
    ["enter", chunk, context],
    ["exit", chunk, context],
    ["exit", string, context],
    // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ["exit", call, context]
  ];
  events.splice(index, events.length - index + 1, ...replacement);
  return events;
}
function tokenizeGfmFootnoteCall(effects, ok5, nok) {
  const self = this;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  let size = 0;
  let data;
  return start;
  function start(code3) {
    effects.enter("gfmFootnoteCall");
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallLabelMarker");
    return callStart;
  }
  function callStart(code3) {
    if (code3 !== 94) return nok(code3);
    effects.enter("gfmFootnoteCallMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallMarker");
    effects.enter("gfmFootnoteCallString");
    effects.enter("chunkString").contentType = "string";
    return callData;
  }
  function callData(code3) {
    if (
      // Too long.
      size > 999 || // Closing brace with nothing.
      code3 === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code3 === null || code3 === 91 || markdownLineEndingOrSpace(code3)
    ) {
      return nok(code3);
    }
    if (code3 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteCallString");
      if (!defined.includes(normalizeIdentifier(self.sliceSerialize(token)))) {
        return nok(code3);
      }
      effects.enter("gfmFootnoteCallLabelMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteCallLabelMarker");
      effects.exit("gfmFootnoteCall");
      return ok5;
    }
    if (!markdownLineEndingOrSpace(code3)) {
      data = true;
    }
    size++;
    effects.consume(code3);
    return code3 === 92 ? callEscape : callData;
  }
  function callEscape(code3) {
    if (code3 === 91 || code3 === 92 || code3 === 93) {
      effects.consume(code3);
      size++;
      return callData;
    }
    return callData(code3);
  }
}
function tokenizeDefinitionStart(effects, ok5, nok) {
  const self = this;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  let identifier;
  let size = 0;
  let data;
  return start;
  function start(code3) {
    effects.enter("gfmFootnoteDefinition")._container = true;
    effects.enter("gfmFootnoteDefinitionLabel");
    effects.enter("gfmFootnoteDefinitionLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteDefinitionLabelMarker");
    return labelAtMarker;
  }
  function labelAtMarker(code3) {
    if (code3 === 94) {
      effects.enter("gfmFootnoteDefinitionMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteDefinitionMarker");
      effects.enter("gfmFootnoteDefinitionLabelString");
      effects.enter("chunkString").contentType = "string";
      return labelInside;
    }
    return nok(code3);
  }
  function labelInside(code3) {
    if (
      // Too long.
      size > 999 || // Closing brace with nothing.
      code3 === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code3 === null || code3 === 91 || markdownLineEndingOrSpace(code3)
    ) {
      return nok(code3);
    }
    if (code3 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteDefinitionLabelString");
      identifier = normalizeIdentifier(self.sliceSerialize(token));
      effects.enter("gfmFootnoteDefinitionLabelMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteDefinitionLabelMarker");
      effects.exit("gfmFootnoteDefinitionLabel");
      return labelAfter;
    }
    if (!markdownLineEndingOrSpace(code3)) {
      data = true;
    }
    size++;
    effects.consume(code3);
    return code3 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code3) {
    if (code3 === 91 || code3 === 92 || code3 === 93) {
      effects.consume(code3);
      size++;
      return labelInside;
    }
    return labelInside(code3);
  }
  function labelAfter(code3) {
    if (code3 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code3);
      effects.exit("definitionMarker");
      if (!defined.includes(identifier)) {
        defined.push(identifier);
      }
      return factorySpace(
        effects,
        whitespaceAfter,
        "gfmFootnoteDefinitionWhitespace"
      );
    }
    return nok(code3);
  }
  function whitespaceAfter(code3) {
    return ok5(code3);
  }
}
function tokenizeDefinitionContinuation(effects, ok5, nok) {
  return effects.check(blankLine, ok5, effects.attempt(indent, ok5, nok));
}
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(effects, ok5, nok) {
  const self = this;
  return factorySpace(
    effects,
    afterPrefix,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function afterPrefix(code3) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok5(code3) : nok(code3);
  }
}

// ../../node_modules/micromark-extension-gfm-strikethrough/lib/syntax.js
function gfmStrikethrough(options) {
  const options_ = options || {};
  let single = options_.singleTilde;
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === void 0) {
    single = true;
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function resolveAllStrikethrough(events, context) {
    let index = -1;
    while (++index < events.length) {
      if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
        let open = index;
        while (open--) {
          if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
          events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
            events[index][1].type = "strikethroughSequence";
            events[open][1].type = "strikethroughSequence";
            const strikethrough = {
              type: "strikethrough",
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            };
            const text3 = {
              type: "strikethroughText",
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            };
            const nextEvents = [
              ["enter", strikethrough, context],
              ["enter", events[open][1], context],
              ["exit", events[open][1], context],
              ["enter", text3, context]
            ];
            const insideSpan = context.parser.constructs.insideSpan.null;
            if (insideSpan) {
              splice(
                nextEvents,
                nextEvents.length,
                0,
                resolveAll(insideSpan, events.slice(open + 1, index), context)
              );
            }
            splice(nextEvents, nextEvents.length, 0, [
              ["exit", text3, context],
              ["enter", events[index][1], context],
              ["exit", events[index][1], context],
              ["exit", strikethrough, context]
            ]);
            splice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      if (events[index][1].type === "strikethroughSequenceTemporary") {
        events[index][1].type = "data";
      }
    }
    return events;
  }
  function tokenizeStrikethrough(effects, ok5, nok) {
    const previous2 = this.previous;
    const events = this.events;
    let size = 0;
    return start;
    function start(code3) {
      if (previous2 === 126 && events[events.length - 1][1].type !== "characterEscape") {
        return nok(code3);
      }
      effects.enter("strikethroughSequenceTemporary");
      return more(code3);
    }
    function more(code3) {
      const before = classifyCharacter(previous2);
      if (code3 === 126) {
        if (size > 1) return nok(code3);
        effects.consume(code3);
        size++;
        return more;
      }
      if (size < 2 && !single) return nok(code3);
      const token = effects.exit("strikethroughSequenceTemporary");
      const after = classifyCharacter(code3);
      token._open = !after || after === 2 && Boolean(before);
      token._close = !before || before === 2 && Boolean(after);
      return ok5(code3);
    }
  }
}

// ../../node_modules/micromark-extension-gfm-table/lib/edit-map.js
var EditMap = class {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(index, remove, add) {
    addImpl(this, index, remove, add);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(events) {
    this.map.sort(function(a, b) {
      return a[0] - b[0];
    });
    if (this.map.length === 0) {
      return;
    }
    let index = this.map.length;
    const vecs = [];
    while (index > 0) {
      index -= 1;
      vecs.push(
        events.slice(this.map[index][0] + this.map[index][1]),
        this.map[index][2]
      );
      events.length = this.map[index][0];
    }
    vecs.push([...events]);
    events.length = 0;
    let slice = vecs.pop();
    while (slice) {
      events.push(...slice);
      slice = vecs.pop();
    }
    this.map.length = 0;
  }
};
function addImpl(editMap, at, remove, add) {
  let index = 0;
  if (remove === 0 && add.length === 0) {
    return;
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove;
      editMap.map[index][2].push(...add);
      return;
    }
    index += 1;
  }
  editMap.map.push([at, remove, add]);
}

// ../../node_modules/micromark-extension-gfm-table/lib/infer.js
function gfmTableAlign(events, index) {
  let inDelimiterRow = false;
  const align = [];
  while (index < events.length) {
    const event = events[index];
    if (inDelimiterRow) {
      if (event[0] === "enter") {
        if (event[1].type === "tableContent") {
          align.push(
            events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
          );
        }
      } else if (event[1].type === "tableContent") {
        if (events[index - 1][1].type === "tableDelimiterMarker") {
          const alignIndex = align.length - 1;
          align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
        }
      } else if (event[1].type === "tableDelimiterRow") {
        break;
      }
    } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") {
      inDelimiterRow = true;
    }
    index += 1;
  }
  return align;
}

// ../../node_modules/micromark-extension-gfm-table/lib/syntax.js
function gfmTable() {
  return {
    flow: {
      null: {
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(effects, ok5, nok) {
  const self = this;
  let size = 0;
  let sizeB = 0;
  let seen;
  return start;
  function start(code3) {
    let index = self.events.length - 1;
    while (index > -1) {
      const type2 = self.events[index][1].type;
      if (type2 === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      type2 === "linePrefix")
        index--;
      else break;
    }
    const tail = index > -1 ? self.events[index][1].type : null;
    const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
    if (next === bodyRowStart && self.parser.lazy[self.now().line]) {
      return nok(code3);
    }
    return next(code3);
  }
  function headRowBefore(code3) {
    effects.enter("tableHead");
    effects.enter("tableRow");
    return headRowStart(code3);
  }
  function headRowStart(code3) {
    if (code3 === 124) {
      return headRowBreak(code3);
    }
    seen = true;
    sizeB += 1;
    return headRowBreak(code3);
  }
  function headRowBreak(code3) {
    if (code3 === null) {
      return nok(code3);
    }
    if (markdownLineEnding(code3)) {
      if (sizeB > 1) {
        sizeB = 0;
        self.interrupt = true;
        effects.exit("tableRow");
        effects.enter("lineEnding");
        effects.consume(code3);
        effects.exit("lineEnding");
        return headDelimiterStart;
      }
      return nok(code3);
    }
    if (markdownSpace(code3)) {
      return factorySpace(effects, headRowBreak, "whitespace")(code3);
    }
    sizeB += 1;
    if (seen) {
      seen = false;
      size += 1;
    }
    if (code3 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code3);
      effects.exit("tableCellDivider");
      seen = true;
      return headRowBreak;
    }
    effects.enter("data");
    return headRowData(code3);
  }
  function headRowData(code3) {
    if (code3 === null || code3 === 124 || markdownLineEndingOrSpace(code3)) {
      effects.exit("data");
      return headRowBreak(code3);
    }
    effects.consume(code3);
    return code3 === 92 ? headRowEscape : headRowData;
  }
  function headRowEscape(code3) {
    if (code3 === 92 || code3 === 124) {
      effects.consume(code3);
      return headRowData;
    }
    return headRowData(code3);
  }
  function headDelimiterStart(code3) {
    self.interrupt = false;
    if (self.parser.lazy[self.now().line]) {
      return nok(code3);
    }
    effects.enter("tableDelimiterRow");
    seen = false;
    if (markdownSpace(code3)) {
      return factorySpace(
        effects,
        headDelimiterBefore,
        "linePrefix",
        self.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code3);
    }
    return headDelimiterBefore(code3);
  }
  function headDelimiterBefore(code3) {
    if (code3 === 45 || code3 === 58) {
      return headDelimiterValueBefore(code3);
    }
    if (code3 === 124) {
      seen = true;
      effects.enter("tableCellDivider");
      effects.consume(code3);
      effects.exit("tableCellDivider");
      return headDelimiterCellBefore;
    }
    return headDelimiterNok(code3);
  }
  function headDelimiterCellBefore(code3) {
    if (markdownSpace(code3)) {
      return factorySpace(effects, headDelimiterValueBefore, "whitespace")(code3);
    }
    return headDelimiterValueBefore(code3);
  }
  function headDelimiterValueBefore(code3) {
    if (code3 === 58) {
      sizeB += 1;
      seen = true;
      effects.enter("tableDelimiterMarker");
      effects.consume(code3);
      effects.exit("tableDelimiterMarker");
      return headDelimiterLeftAlignmentAfter;
    }
    if (code3 === 45) {
      sizeB += 1;
      return headDelimiterLeftAlignmentAfter(code3);
    }
    if (code3 === null || markdownLineEnding(code3)) {
      return headDelimiterCellAfter(code3);
    }
    return headDelimiterNok(code3);
  }
  function headDelimiterLeftAlignmentAfter(code3) {
    if (code3 === 45) {
      effects.enter("tableDelimiterFiller");
      return headDelimiterFiller(code3);
    }
    return headDelimiterNok(code3);
  }
  function headDelimiterFiller(code3) {
    if (code3 === 45) {
      effects.consume(code3);
      return headDelimiterFiller;
    }
    if (code3 === 58) {
      seen = true;
      effects.exit("tableDelimiterFiller");
      effects.enter("tableDelimiterMarker");
      effects.consume(code3);
      effects.exit("tableDelimiterMarker");
      return headDelimiterRightAlignmentAfter;
    }
    effects.exit("tableDelimiterFiller");
    return headDelimiterRightAlignmentAfter(code3);
  }
  function headDelimiterRightAlignmentAfter(code3) {
    if (markdownSpace(code3)) {
      return factorySpace(effects, headDelimiterCellAfter, "whitespace")(code3);
    }
    return headDelimiterCellAfter(code3);
  }
  function headDelimiterCellAfter(code3) {
    if (code3 === 124) {
      return headDelimiterBefore(code3);
    }
    if (code3 === null || markdownLineEnding(code3)) {
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code3);
      }
      effects.exit("tableDelimiterRow");
      effects.exit("tableHead");
      return ok5(code3);
    }
    return headDelimiterNok(code3);
  }
  function headDelimiterNok(code3) {
    return nok(code3);
  }
  function bodyRowStart(code3) {
    effects.enter("tableRow");
    return bodyRowBreak(code3);
  }
  function bodyRowBreak(code3) {
    if (code3 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code3);
      effects.exit("tableCellDivider");
      return bodyRowBreak;
    }
    if (code3 === null || markdownLineEnding(code3)) {
      effects.exit("tableRow");
      return ok5(code3);
    }
    if (markdownSpace(code3)) {
      return factorySpace(effects, bodyRowBreak, "whitespace")(code3);
    }
    effects.enter("data");
    return bodyRowData(code3);
  }
  function bodyRowData(code3) {
    if (code3 === null || code3 === 124 || markdownLineEndingOrSpace(code3)) {
      effects.exit("data");
      return bodyRowBreak(code3);
    }
    effects.consume(code3);
    return code3 === 92 ? bodyRowEscape : bodyRowData;
  }
  function bodyRowEscape(code3) {
    if (code3 === 92 || code3 === 124) {
      effects.consume(code3);
      return bodyRowData;
    }
    return bodyRowData(code3);
  }
}
function resolveTable(events, context) {
  let index = -1;
  let inFirstCellAwaitingPipe = true;
  let rowKind = 0;
  let lastCell = [0, 0, 0, 0];
  let cell = [0, 0, 0, 0];
  let afterHeadAwaitingFirstBodyRow = false;
  let lastTableEnd = 0;
  let currentTable;
  let currentBody;
  let currentCell;
  const map4 = new EditMap();
  while (++index < events.length) {
    const event = events[index];
    const token = event[1];
    if (event[0] === "enter") {
      if (token.type === "tableHead") {
        afterHeadAwaitingFirstBodyRow = false;
        if (lastTableEnd !== 0) {
          flushTableEnd(map4, context, lastTableEnd, currentTable, currentBody);
          currentBody = void 0;
          lastTableEnd = 0;
        }
        currentTable = {
          type: "table",
          start: Object.assign({}, token.start),
          // Note: correct end is set later.
          end: Object.assign({}, token.end)
        };
        map4.add(index, 0, [["enter", currentTable, context]]);
      } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
        inFirstCellAwaitingPipe = true;
        currentCell = void 0;
        lastCell = [0, 0, 0, 0];
        cell = [0, index + 1, 0, 0];
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false;
          currentBody = {
            type: "tableBody",
            start: Object.assign({}, token.start),
            // Note: correct end is set later.
            end: Object.assign({}, token.end)
          };
          map4.add(index, 0, [["enter", currentBody, context]]);
        }
        rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
      } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
        inFirstCellAwaitingPipe = false;
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(
              map4,
              context,
              lastCell,
              rowKind,
              void 0,
              currentCell
            );
            lastCell = [0, 0, 0, 0];
          }
          cell[2] = index;
        }
      } else if (token.type === "tableCellDivider") {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false;
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(
              map4,
              context,
              lastCell,
              rowKind,
              void 0,
              currentCell
            );
          }
          lastCell = cell;
          cell = [lastCell[1], index, 0, 0];
        }
      }
    } else if (token.type === "tableHead") {
      afterHeadAwaitingFirstBodyRow = true;
      lastTableEnd = index;
    } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
      lastTableEnd = index;
      if (lastCell[1] !== 0) {
        cell[0] = cell[1];
        currentCell = flushCell(
          map4,
          context,
          lastCell,
          rowKind,
          index,
          currentCell
        );
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map4, context, cell, rowKind, index, currentCell);
      }
      rowKind = 0;
    } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
      cell[3] = index;
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map4, context, lastTableEnd, currentTable, currentBody);
  }
  map4.consume(context.events);
  index = -1;
  while (++index < context.events.length) {
    const event = context.events[index];
    if (event[0] === "enter" && event[1].type === "table") {
      event[1]._align = gfmTableAlign(context.events, index);
    }
  }
  return events;
}
function flushCell(map4, context, range, rowKind, rowEnd, previousCell) {
  const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
  const valueName = "tableContent";
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]));
    map4.add(range[0], 0, [["exit", previousCell, context]]);
  }
  const now = getPoint(context.events, range[1]);
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    // Note: correct end is set later.
    end: Object.assign({}, now)
  };
  map4.add(range[1], 0, [["enter", previousCell, context]]);
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2]);
    const relatedEnd = getPoint(context.events, range[3]);
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    };
    map4.add(range[2], 0, [["enter", valueToken, context]]);
    if (rowKind !== 2) {
      const start = context.events[range[2]];
      const end = context.events[range[3]];
      start[1].end = Object.assign({}, end[1].end);
      start[1].type = "chunkText";
      start[1].contentType = "text";
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1;
        const b = range[3] - range[2] - 1;
        map4.add(a, b, []);
      }
    }
    map4.add(range[3] + 1, 0, [["exit", valueToken, context]]);
  }
  if (rowEnd !== void 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd));
    map4.add(rowEnd, 0, [["exit", previousCell, context]]);
    previousCell = void 0;
  }
  return previousCell;
}
function flushTableEnd(map4, context, index, table, tableBody) {
  const exits = [];
  const related = getPoint(context.events, index);
  if (tableBody) {
    tableBody.end = Object.assign({}, related);
    exits.push(["exit", tableBody, context]);
  }
  table.end = Object.assign({}, related);
  exits.push(["exit", table, context]);
  map4.add(index + 1, 0, exits);
}
function getPoint(events, index) {
  const event = events[index];
  const side = event[0] === "enter" ? "start" : "end";
  return event[1][side];
}

// ../../node_modules/micromark-extension-gfm-task-list-item/lib/syntax.js
var tasklistCheck = {
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      [91]: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(effects, ok5, nok) {
  const self = this;
  return open;
  function open(code3) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code3);
    }
    effects.enter("taskListCheck");
    effects.enter("taskListCheckMarker");
    effects.consume(code3);
    effects.exit("taskListCheckMarker");
    return inside;
  }
  function inside(code3) {
    if (markdownLineEndingOrSpace(code3)) {
      effects.enter("taskListCheckValueUnchecked");
      effects.consume(code3);
      effects.exit("taskListCheckValueUnchecked");
      return close;
    }
    if (code3 === 88 || code3 === 120) {
      effects.enter("taskListCheckValueChecked");
      effects.consume(code3);
      effects.exit("taskListCheckValueChecked");
      return close;
    }
    return nok(code3);
  }
  function close(code3) {
    if (code3 === 93) {
      effects.enter("taskListCheckMarker");
      effects.consume(code3);
      effects.exit("taskListCheckMarker");
      effects.exit("taskListCheck");
      return after;
    }
    return nok(code3);
  }
  function after(code3) {
    if (markdownLineEnding(code3)) {
      return ok5(code3);
    }
    if (markdownSpace(code3)) {
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok5,
        nok
      )(code3);
    }
    return nok(code3);
  }
}
function spaceThenNonSpace(effects, ok5, nok) {
  return factorySpace(effects, after, "whitespace");
  function after(code3) {
    return code3 === null ? nok(code3) : ok5(code3);
  }
}

// ../../node_modules/micromark-extension-gfm/index.js
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable(),
    gfmTaskListItem()
  ]);
}

// ../../node_modules/remark-gfm/lib/index.js
var emptyOptions2 = {};
function remarkGfm(options) {
  const self = (
    /** @type {Processor} */
    this
  );
  const settings = options || emptyOptions2;
  const data = self.data();
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
  const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
  micromarkExtensions.push(gfm(settings));
  fromMarkdownExtensions.push(gfmFromMarkdown());
  toMarkdownExtensions.push(gfmToMarkdown(settings));
}
var markdownRecipe = sva({
  slots: [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "ul",
    "li",
    "img",
    "em",
    "del",
    "ol",
    "hr",
    "table"
  ],
  base: {
    root: {
      color: "text.primary"
    },
    h1: {
      fontSize: "[2.25rem]",
      fontFamily: "[PP Telegraf]",
      fontWeight: "[500]",
      fontStyle: "normal",
      letterSpacing: "0",
      lineHeight: "[43.2px]"
    },
    h2: {
      fontSize: "[2rem]",
      fontFamily: "[PP Telegraf]",
      fontStyle: "normal",
      fontWeight: "[500]",
      lineHeight: "[38.4px]",
      letterSpacing: "0"
    },
    h3: {
      fontSize: "[1.5rem]",
      fontFamily: "[PP Telegraf]",
      fontStyle: "normal",
      fontWeight: "[500]",
      lineHeight: "[28.8px]",
      letterSpacing: "0"
    },
    h4: {
      fontSize: "[1.25rem]",
      fontFamily: "[PP Telegraf]",
      fontStyle: "normal",
      fontWeight: "[500]",
      lineHeight: "[24px]",
      letterSpacing: "0"
    },
    h5: {
      fontSize: "[1.125rem]",
      fontFamily: "[PP Telegraf]",
      fontStyle: "normal",
      fontWeight: "[500]",
      lineHeight: "[21.6px]",
      letterSpacing: "0"
    },
    h6: {
      fontSize: "[1rem]",
      fontFamily: "[PP Telegraf]",
      fontStyle: "normal",
      fontWeight: "[500]",
      lineHeight: "[20.8px]",
      letterSpacing: "0"
    },
    p: {
      fontSize: "[0.875rem]",
      fontFamily: "[Manrope]",
      fontStyle: "normal",
      fontWeight: "[400]",
      lineHeight: "[21px]",
      letterSpacing: "0"
    },
    ul: {
      listStyleType: "revert",
      marginBottom: "[16px]"
    },
    li: {
      marginBottom: "0"
    },
    img: {
      maxWidth: "[100%]",
      '&[src*="#thumbnail"]': {
        width: "[64px]"
      }
    },
    em: {
      fontStyle: "italic"
    },
    del: {
      textDecoration: "line-through"
    },
    ol: {
      marginBottom: "[16px]"
    },
    hr: {
      borderColor: "gray.60"
    },
    table: {
      borderCollapse: "collapse",
      "& th, & td": {
        border: "1px solid",
        borderColor: "gray.60",
        textAlign: "left",
        padding: "[8px]"
      }
    }
  }
});
var Markdown = ({
  components,
  className,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = markdownRecipe.splitVariantProps(rest);
  const recipeClassNames = markdownRecipe.raw(variantProps);
  const DefaultComponents = {
    h1: (props) => /* @__PURE__ */ jsx("h1", { className: cx(css(recipeClassNames.h1)), children: props.children }),
    h2: (props) => /* @__PURE__ */ jsx("h2", { className: cx(css(recipeClassNames.h2)), children: props.children }),
    h3: (props) => /* @__PURE__ */ jsx("h3", { className: cx(css(recipeClassNames.h3)), children: props.children }),
    h4: (props) => /* @__PURE__ */ jsx("h4", { className: cx(css(recipeClassNames.h4)), children: props.children }),
    h5: (props) => /* @__PURE__ */ jsx("h5", { className: cx(css(recipeClassNames.h5)), children: props.children }),
    h6: (props) => /* @__PURE__ */ jsx("h6", { className: cx(css(recipeClassNames.h6)), children: props.children }),
    b: (props) => /* @__PURE__ */ jsx("strong", { children: props.children }),
    ul: (props) => /* @__PURE__ */ jsx("ul", { className: cx(css(recipeClassNames.ul)), ...props }),
    li: (props) => /* @__PURE__ */ jsx("li", { className: cx(css(recipeClassNames.li)), ...props }),
    img: (props) => /* @__PURE__ */ jsx("img", { className: cx(css(recipeClassNames.img)), alt: "", ...props }),
    em: (props) => /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.em)), children: props.children }),
    del: (props) => /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.del)), children: props.children }),
    ol: (props) => /* @__PURE__ */ jsx("ol", { className: cx(css(recipeClassNames.ol)), ...props }),
    pre: (props) => /* @__PURE__ */ jsx("pre", { ...props }),
    hr: () => /* @__PURE__ */ jsx("hr", { className: cx(css(recipeClassNames.hr)) }),
    table: (props) => /* @__PURE__ */ jsx("table", { ...props, className: cx(css(recipeClassNames.table)) })
  };
  return (
    /* Latest version of React-Mark-Down does not support className anymore */
    /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.root), className), children: /* @__PURE__ */ jsx(
      ReactMarkdown,
      {
        components: components !== void 0 ? components : DefaultComponents,
        remarkPlugins: [remarkGfm],
        ...localProps,
        children
      }
    ) })
  );
};
var OverlayArrow = ({ className, ...rest }) => {
  return /* @__PURE__ */ jsx(OverlayArrow$1, { className, ...rest, children: /* @__PURE__ */ jsx("svg", { width: "12", height: "7", viewBox: "0 0 12 7", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M-5.24537e-07 0.899995L12 0.899994L6 6.89999L-5.24537e-07 0.899995Z",
      fill: "currentColor"
    }
  ) }) });
};
var tooltipRecipe = sva({
  slots: ["root", "arrow"],
  base: {
    root: {
      padding: "[6px 12px]",
      cursor: "pointer",
      "&[data-entering]": {
        animation: "fadeIn 250ms ease-out forwards"
      },
      "&[data-exiting]": {
        animation: "fadeOut 250ms ease-out forwards"
      }
    },
    arrow: {
      display: "flex",
      '&[data-placement="top"] svg': {
        marginTop: "[-1px]"
      },
      '&[data-placement="left"] svg': {
        transform: "rotate(-90deg)",
        marginLeft: "[-4px]"
      },
      '&[data-placement="right"] svg': {
        transform: "rotate(90deg)",
        marginRight: "[-4px]"
      },
      '&[data-placement="bottom"] svg': {
        transform: "rotate(180deg)",
        marginBottom: "[-1px]"
      }
    }
  },
  variants: {
    shape: {
      box: {
        root: {
          borderRadius: "sm"
        }
      },
      rounded: {
        root: {
          borderRadius: "[full]"
        }
      }
    },
    color: {
      default: {
        root: {
          backgroundColor: "background",
          color: "text.primary"
        },
        arrow: {
          color: "background"
        }
      },
      reversed: {
        root: {
          backgroundColor: "background.reversed",
          color: "text.primary.reversed"
        },
        arrow: {
          color: "background.reversed"
        }
      }
    }
  },
  defaultVariants: {
    shape: "box",
    color: "reversed"
  }
});
var Tooltip = ({
  content,
  isOpen,
  className,
  placement = "top",
  offset = 10,
  delay = 150,
  arrowClassName,
  onOpenChange,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = tooltipRecipe.splitVariantProps(rest);
  const recipeClassNames = tooltipRecipe(variantProps);
  return /* @__PURE__ */ jsxs(
    TooltipTrigger,
    {
      isOpen,
      isDisabled: localProps.isDisabled,
      delay,
      onOpenChange,
      children: [
        children,
        /* @__PURE__ */ jsxs(
          Tooltip$1,
          {
            ...localProps,
            placement,
            offset,
            className: cx(recipeClassNames.root, className),
            children: [
              /* @__PURE__ */ jsx(TooltipOverlayArrow, { className: arrowClassName }),
              content
            ]
          }
        )
      ]
    }
  );
};
var TooltipOverlayArrow = ({ className, ...rest }) => {
  const [variantProps, localProps] = tooltipRecipe.splitVariantProps(rest);
  const recipeClassNames = tooltipRecipe(variantProps);
  return /* @__PURE__ */ jsx(OverlayArrow, { className: cx(recipeClassNames.arrow, className), ...localProps });
};
var inputRecipe = sva({
  slots: ["root", "input", "label", "description", "error"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "body"
    },
    input: {
      textStyle: "inherit",
      boxSizing: "border-box",
      border: "[1px solid]",
      flex: "1",
      minWidth: "[0]",
      outlineStyle: "solid",
      ringWidth: "[0px]",
      _disabled: {
        cursor: "not-allowed",
        backgroundColor: "gray.20",
        borderColor: "gray.40"
      },
      _invalid: {
        border: "[1px solid]",
        borderColor: "error-red.100",
        _placeholder: {
          color: "error-red.100"
        },
        _dark: {
          _placeholder: {
            color: "error-red.60"
          }
        }
      },
      _hover: {
        _notDisabled: {
          borderColor: "green.100"
        }
      },
      // default light styles
      backgroundColor: "[white]",
      borderColor: "[white]",
      color: "text.primary",
      _placeholder: {
        color: "gray.50"
      },
      _dark: {
        backgroundColor: "background",
        borderColor: "background",
        color: "text.primary",
        _placeholder: {
          color: "[calc(text.primary/50)]"
        },
        _disabled: {
          cursor: "not-allowed",
          backgroundColor: "gray.20",
          borderColor: "gray.40"
        }
      }
    },
    label: {},
    description: {},
    error: {}
  },
  variants: {
    variant: {
      contained: {},
      // default
      outlined: {
        input: {
          borderColor: "dark-teal.20",
          _dark: {
            borderColor: "[color-mix(in srgb, {colors.cream.100} 20%, {colors.background})]",
            color: "text.primary"
          }
        }
      }
    },
    size: {
      small: {
        input: {
          fontSize: "[12px]",
          padding: "[8px 12px]",
          lineHeight: "[16px]"
        }
      },
      medium: {
        input: {
          fontSize: "sm",
          padding: "[8px 12px]",
          lineHeight: "[22px]"
        }
      },
      large: {
        input: {
          fontSize: "md",
          padding: "[16px 16px]",
          lineHeight: "[24px]"
        }
      }
    },
    shape: {
      box: {
        input: {
          borderRadius: "sm"
        }
      },
      rounded: {
        input: {
          borderRadius: "full",
          borderWidth: "[2px]"
        }
      }
    },
    fullWidth: {
      false: {},
      true: {
        root: {
          width: "[100%]"
        },
        input: {
          width: "[100%]"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outlined",
    shape: "box",
    size: "medium",
    fullWidth: false
  }
});
var Input = ({
  label,
  errorMessage,
  description,
  className,
  inputClassName,
  labelClassName,
  errorClassName,
  descriptionClassName,
  ...rest
}) => {
  const [variantProps, localProps] = inputRecipe.splitVariantProps(rest);
  const recipeClassNames = inputRecipe(variantProps);
  const { size } = rest;
  return /* @__PURE__ */ jsxs(TextField, { className: cx("group", recipeClassNames.root, className), ...localProps, children: [
    /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
    /* @__PURE__ */ jsx(Input$1, { className: cx(css(focusRing), recipeClassNames.input, inputClassName) }),
    /* @__PURE__ */ jsx(
      Description,
      {
        size,
        className: cx(recipeClassNames.description, descriptionClassName),
        children: description
      }
    ),
    /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] });
};
var fileInputRecipe = sva({
  slots: ["root", "button", "icon", "text"],
  base: {
    root: {},
    // this is the div provided by DropZone.
    button: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "1",
      width: "[fit-content]",
      boxSizing: "border-box",
      fontFamily: "body",
      margin: "0",
      border: "[1px solid]",
      borderRadius: "sm",
      _hover: {
        _notDisabled: {
          borderColor: "green.100"
        }
      },
      _disabled: {
        cursor: "not-allowed",
        backgroundColor: "gray.20",
        borderColor: "gray.40"
      },
      // default light styles
      backgroundColor: "[white]",
      borderColor: "[white]",
      color: "text.primary",
      _dark: {
        backgroundColor: "background",
        borderColor: "background",
        color: "text.primary",
        _disabled: {
          cursor: "not-allowed",
          backgroundColor: "gray.20",
          borderColor: "gray.40"
        }
      }
    },
    icon: {
      _groupDisabled: {
        color: "dark-teal.100",
        stroke: "gray.80"
      }
    },
    text: {
      _groupDisabled: {
        color: "gray.80"
      }
    }
  },
  // Variants
  variants: {
    iconOnly: {
      false: {},
      true: {
        button: {
          padding: "[0]",
          border: "[none]",
          cursor: "pointer",
          backgroundColor: "[transparent]",
          _dark: {
            backgroundColor: "[transparent]"
          }
        }
      }
    },
    variant: {
      contained: {},
      // default
      outlined: {
        button: {
          border: "[1px solid]",
          borderColor: "dark-teal.20",
          _dark: {
            borderColor: "[color-mix(in srgb, {colors.cream.100} 20%, {colors.background})]",
            color: "text.primary"
          }
        }
      }
    },
    size: {
      small: {
        button: {
          padding: "[6px 12px]",
          fontSize: "[12px]"
        }
      },
      medium: {
        button: {
          padding: "[12px 24px]",
          fontSize: "[14px]"
        }
      },
      large: {
        button: {
          padding: "[24px 36px]",
          fontSize: "[16px]"
        }
      },
      full: {
        root: {
          width: "[100%]",
          height: "[100%]"
        },
        button: {
          padding: "[12px 24px]",
          fontSize: "[14px]",
          width: "[100%]",
          height: "[100%]"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outlined",
    size: "medium"
  }
});
var FileInputButton = ({
  onSelect,
  acceptedFileTypes,
  allowsMultiple = false,
  icon,
  buttonText,
  className,
  textClassName,
  iconClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = fileInputRecipe.splitVariantProps(rest);
  const recipeClassNames = fileInputRecipe(variantProps);
  return /* @__PURE__ */ jsx(
    FileTrigger,
    {
      ...localProps,
      allowsMultiple,
      acceptedFileTypes,
      onSelect,
      children: /* @__PURE__ */ jsx(
        Button$1,
        {
          ...localProps,
          ...{ disabled: localProps.isDisabled },
          className: cx("group", css(focusRing), recipeClassNames.button, className),
          children: /* @__PURE__ */ jsxs(Fragment, { children: [
            icon ?? /* @__PURE__ */ jsx(Upload, { size: "large", className: cx(recipeClassNames.icon, iconClassName) }),
            buttonText ? /* @__PURE__ */ jsx("span", { className: cx(recipeClassNames.text, textClassName), children: buttonText }) : null
          ] })
        }
      )
    }
  );
};
var FileInput = ({
  onSelect,
  acceptedFileTypes,
  allowsMultiple = false,
  icon,
  defaultText,
  className,
  buttonClassName,
  textClassName,
  iconClassName,
  children,
  ...rest
}) => {
  const [files, setFiles] = React10.useState(null);
  const [fileNames, setFileNames] = React10.useState("");
  const [variantProps, localProps] = fileInputRecipe.splitVariantProps(rest);
  const recipeClassNames = fileInputRecipe(variantProps);
  return /* @__PURE__ */ jsx(
    DropZone,
    {
      ...localProps,
      className: cx(recipeClassNames.root, className),
      onDrop: async (e) => {
        let myFiles = e.items.filter(
          (item) => item.kind === "file"
        );
        if (acceptedFileTypes) {
          myFiles = myFiles.filter(
            (file) => acceptedFileTypes.includes(String(file.type))
          );
        }
        if (!allowsMultiple && myFiles.length > 0) {
          myFiles = myFiles.slice(0, 1);
        }
        const resolvedFiles = await Promise.all(myFiles.map((f) => f.getFile()));
        const dataTransfer = new DataTransfer();
        resolvedFiles.forEach((file) => dataTransfer.items.add(file));
        setFiles(dataTransfer.files);
        setFileNames(resolvedFiles.map((file) => file.name).join(", "));
        if (onSelect) {
          onSelect(dataTransfer.files);
        }
      },
      children: children || /* @__PURE__ */ jsx(
        FileInputButton,
        {
          ...variantProps,
          onSelect,
          buttonText: defaultText || fileNames || "Drag & Drop or browse",
          icon,
          className: buttonClassName,
          iconClassName
        }
      )
    }
  );
};
var textAreaRecipe = sva({
  slots: ["root", "growContainer", "textArea", "label", "description", "error"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "body"
    },
    growContainer: {
      display: "grid",
      borderRadius: "sm",
      border: "[1px solid]",
      _hover: {
        _notDisabled: {
          borderColor: "green.100"
        }
      },
      _disabled: {
        backgroundColor: "gray.20",
        borderColor: "gray.40"
      },
      _groupInvalid: {
        borderColor: "error-red.100"
      },
      // default light colors
      backgroundColor: "[white]",
      borderColor: "[white]",
      color: "text.primary",
      _dark: {
        backgroundColor: "background",
        borderColor: "background",
        _disabled: {
          backgroundColor: "gray.20",
          borderColor: "gray.40"
        }
      },
      // this ::after pseudo-element will contain an example string that is used to calculate height.
      // its important that it has the same font-size, border, padding, etc as the textArea so that height is calculated correctly.
      _after: {
        content: 'attr(data-replicated-value) " "',
        textStyle: "inherit",
        whiteSpace: "pre-wrap",
        visibility: "hidden",
        border: "[none]",
        padding: "0",
        gridArea: "1 / 1 / 2 / 2"
        // place it at the same spot on grid as textarea
      }
    },
    textArea: {
      textStyle: "inherit",
      gridArea: "1 / 1 / 2 / 2",
      // place it at the same spot on grid as _after
      border: "[none]",
      padding: "0",
      resize: "none",
      // prevents resizing via corner clicking element
      boxSizing: "border-box",
      flex: "1",
      minWidth: "[0]",
      outlineStyle: "solid",
      ringWidth: "[0px]",
      _disabled: {
        cursor: "not-allowed",
        backgroundColor: "[inherit]",
        borderColor: "gray.40"
      },
      _invalid: {
        _placeholder: {
          color: "error-red.100"
        },
        _dark: {
          _placeholder: {
            color: "error-red.60"
          }
        }
      },
      // hide scrollbar until hover or focus
      scrollbarGutter: "[stable]",
      scrollbarColor: "[transparent transparent]",
      _hoverOrFocus: {
        scrollbarColor: "[color-mix(in srgb, {colors.dark-teal.100} 50%, white) transparent]",
        _dark: {
          scrollbarColor: "[color-mix(in srgb, background 50%, white) transparent]"
        }
      },
      // default light colors
      backgroundColor: "[inherit]",
      color: "[inherit]"
    },
    label: {},
    description: {},
    error: {}
  },
  variants: {
    variant: {
      contained: {},
      // default
      outlined: {
        growContainer: {
          // default light colors
          borderColor: "dark-teal.20",
          _dark: {
            borderColor: "[color-mix(in srgb, {colors.cream.100} 20%, {colors.background})]",
            color: "text.primary"
          }
        },
        textArea: {
          backgroundColor: "[inherit]",
          color: "[inherit]"
        }
      }
    },
    size: {
      small: {
        root: {
          fontSize: "[12px]",
          lineHeight: "[1rem]"
        },
        growContainer: {
          padding: "[12px 12px]"
        }
      },
      medium: {
        root: {
          fontSize: "sm",
          lineHeight: "[1.375rem]"
        },
        growContainer: {
          padding: "[8px 12px]"
        }
      },
      large: {
        root: {
          fontSize: "lg",
          lineHeight: "1.5rem"
        },
        growContainer: {
          padding: "[16px 16px]"
        }
      }
    },
    shape: {
      box: {},
      // default
      rounded: {
        growContainer: {
          borderRadius: "[28px]",
          borderWidth: "[2px]"
        }
      }
    },
    fullWidth: {
      false: {},
      true: {
        root: {
          width: "[100%]"
        },
        textArea: {
          width: "[100%]"
        }
      }
    }
  },
  compoundVariants: [
    {
      size: ["small", "medium", "large"],
      shape: "rounded",
      css: {
        textArea: {
          padding: "[4px 8px]"
        },
        growContainer: {
          padding: "[8px 16px]",
          _after: {
            padding: "[4px 8px]"
          }
        }
      }
    }
  ],
  defaultVariants: {
    variant: "outlined",
    shape: "box",
    size: "medium",
    fullWidth: false
  }
});
var TextArea = ({
  minRows = 2,
  maxRows = 3,
  label,
  description,
  errorMessage,
  className,
  textAreaClassName,
  growContainerClassName,
  labelClassName,
  descriptionClassName,
  errorClassName,
  onChange,
  ...rest
}) => {
  const [variantProps, localProps] = textAreaRecipe.splitVariantProps(rest);
  const recipeClassNames = textAreaRecipe(variantProps);
  const { size } = rest;
  const [heightCalculationString, setHeightCalculationString] = useState(
    adjustStringToRowLimits("", minRows, maxRows)
  );
  return /* @__PURE__ */ jsxs(TextField, { className: cx("group", recipeClassNames.root, className), children: [
    /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ...{ disabled: localProps.isDisabled },
        "data-replicated-value": heightCalculationString,
        className: cx(
          css(childFocusRing),
          recipeClassNames.growContainer,
          growContainerClassName
        ),
        children: /* @__PURE__ */ jsx(
          TextArea$1,
          {
            ...{ disabled: localProps.isDisabled },
            ...localProps,
            onChange: (event) => {
              const expectedVisibleText = adjustStringToRowLimits(
                event.target.value,
                minRows,
                maxRows
              );
              setHeightCalculationString(expectedVisibleText);
              if (onChange) {
                onChange(event);
              }
            },
            className: cx(recipeClassNames.textArea, textAreaClassName)
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Description,
      {
        size,
        className: cx(recipeClassNames.description, descriptionClassName),
        children: description
      }
    ),
    /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] });
};
var adjustStringToRowLimits = (input, minRows, maxRows) => {
  const rows = input.split("\n");
  for (let i = rows.length; i < minRows; i++) {
    rows.push("");
  }
  return rows.slice(0, maxRows).join("\n");
};
var Icon = ({ children, color: color2, className: origClassName, ...rest }) => {
  const colorStyles = colorProp(color2);
  const [variantProps, localProps] = iconStyles.splitVariantProps(rest);
  return React10.cloneElement(children, {
    className: cx(origClassName, css(colorStyles, iconStyles.raw(variantProps))),
    ...localProps,
    fontSize: "none"
    // hack Mui icons =/ -- `none` is meaningless ...
  });
};
var varnishIcon = (IconComponent) => {
  const VarnishedIcon = (props) => /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsx(IconComponent, {}) });
  return VarnishedIcon;
};
var createVarnishIcon = (svgIcon) => {
  const VarnishedIcon = (props) => /* @__PURE__ */ jsx(Icon, { ...props, children: svgIcon });
  return VarnishedIcon;
};
var SVGSpriteLink = ({ href: hrefIn }) => {
  const spriteConfig = useSpriteConfig();
  const href = hrefIn ?? spriteConfig.sprite ?? void 0;
  return /* @__PURE__ */ jsx("link", { rel: "preload", href, as: "image", type: "image/svg+xml" });
};

// src/components/logos/index.ts
var logos_exports = {};
__export(logos_exports, {
  ACE: () => ACE,
  Ai2: () => Ai2,
  Ai2OLMoE: () => Ai2OLMoE,
  Ai2OpenScholar8B: () => Ai2OpenScholar8B,
  Ai2Playground: () => Ai2Playground,
  DataDecide: () => DataDecide,
  Dolma: () => Dolma,
  EarthSystems: () => EarthSystems,
  Molmo: () => Molmo,
  OLMES: () => OLMES,
  OLMo: () => OLMo,
  OLMoE: () => OLMoE,
  Paloma: () => Paloma,
  PixMo: () => PixMo,
  Playground: () => Playground,
  SafetyTool: () => SafetyTool,
  Skiff: () => Skiff,
  Tulu: () => Tulu,
  Tulu3: () => Tulu3,
  Tulu3405B: () => Tulu3405B,
  Tulu370B: () => Tulu370B,
  Varnish: () => Varnish
});
var Varnish = ({ color: color2 = "primary", aspectRatio = "797/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Varnish", aspectRatio, color: color2, ...rest });
var Tulu3 = ({ color: color2 = "primary", aspectRatio = "632/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Tulu3", aspectRatio, color: color2, ...rest });
var Tulu370B = ({ color: color2 = "primary", aspectRatio = "1034/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Tulu3-70B", aspectRatio, color: color2, ...rest });
var Tulu3405B = ({ color: color2 = "primary", aspectRatio = "1173/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Tulu3-405B", aspectRatio, color: color2, ...rest });
var Tulu = ({ color: color2 = "primary", aspectRatio = "507/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Tulu", aspectRatio, color: color2, ...rest });
var Skiff = ({ color: color2 = "primary", aspectRatio = "559/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Skiff", aspectRatio, color: color2, ...rest });
var SafetyTool = ({ color: color2 = "primary", aspectRatio = "1114/171", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "SafetyTool", aspectRatio, color: color2, ...rest });
var Playground = ({ color: color2 = "primary", aspectRatio = "1130/173", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Playground", aspectRatio, color: color2, ...rest });
var PixMo = ({ color: color2 = "primary", aspectRatio = "690/130", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "PixMo", aspectRatio, color: color2, ...rest });
var Paloma = ({ color: color2 = "primary", aspectRatio = "789/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Paloma", aspectRatio, color: color2, ...rest });
var OLMoE = ({ color: color2 = "primary", aspectRatio = "773/133", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "OLMoE", aspectRatio, color: color2, ...rest });
var OLMo = ({ color: color2 = "primary", aspectRatio = "659/133", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "OLMo", aspectRatio, color: color2, ...rest });
var OLMES = ({ color: color2 = "primary", aspectRatio = "780/133", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "OLMES", aspectRatio, color: color2, ...rest });
var Molmo = ({ color: color2 = "primary", aspectRatio = "750/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Molmo", aspectRatio, color: color2, ...rest });
var EarthSystems = ({ color: color2 = "primary", aspectRatio = "1332/171", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "EarthSystems", aspectRatio, color: color2, ...rest });
var Dolma = ({ color: color2 = "primary", aspectRatio = "704/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Dolma", aspectRatio, color: color2, ...rest });
var DataDecide = ({ color: color2 = "primary", aspectRatio = "1171/137", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "DataDecide", aspectRatio, color: color2, ...rest });
var Ai2Playground = ({ color: color2 = "primary", aspectRatio = "1485/173", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Ai2Playground", aspectRatio, color: color2, ...rest });
var Ai2OpenScholar8B = ({ color: color2 = "primary", aspectRatio = "1960/170", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Ai2OpenScholar-8B", aspectRatio, color: color2, ...rest });
var Ai2OLMoE = ({ color: color2 = "primary", aspectRatio = "1119/133", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Ai2OLMoE", aspectRatio, color: color2, ...rest });
var Ai2 = ({ color: color2 = "primary", aspectRatio = "756/240", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "Ai2", aspectRatio, color: color2, ...rest });
var ACE = ({ color: color2 = "primary", aspectRatio = "517/133", ...rest }) => /* @__PURE__ */ jsx(SVGSprite, { use: "ACE", aspectRatio, color: color2, ...rest });
var modalStyles = sva({
  slots: ["overlay", "modal", "dialog", "heading", "content", "actions", "closeButton"],
  base: {
    overlay: {
      inset: "[0]",
      position: "fixed",
      display: "flex",
      zIndex: "modal",
      alignItems: "center",
      justifyContent: "center",
      // maybe move to overlay slot
      backgroundColor: "[black/80]"
    },
    modal: {
      boxSizing: "border-box",
      display: "flex",
      "--modal-margin": "32px",
      margin: "var(--modal-margin)",
      maxHeight: "[calc(100% - var(--modal-margin))]",
      borderRadius: "sm",
      outline: "none"
      // we don't want a focus ring on the div
    },
    dialog: {},
    heading: {
      padding: "[8px 16px]",
      display: "flex",
      columnGap: "[8px]",
      // TODO: token
      justifyContent: "space-between",
      alignItems: "start"
    },
    content: {
      overflowY: "auto",
      // check into this:
      // scrollbarGutter: 'stable both-edges',
      paddingInline: "[16px]"
    },
    actions: {
      padding: "[8px 16px]"
    },
    closeButton: {
      alignSelf: "start",
      padding: "0"
    }
  },
  variants: {
    fullWidth: {
      true: {
        modal: {
          flex: "1",
          width: "[100%]"
        }
      }
    },
    size: {
      small: {
        modal: {
          maxWidth: "[300px]"
        }
      },
      medium: {
        modal: {
          maxWidth: "[500px]"
        }
      },
      large: {
        modal: {
          maxWidth: "[800px]"
        }
      }
      // maybe? fullScreen?
      // full: {
      //     modal: {
      //         width: '[100%]',
      //         height: '[100%]',
      //         margin: '[0]',
      //     },
      // },
    },
    color: {
      default: {
        modal: {
          backgroundColor: "background",
          color: "text.primary"
        }
      },
      reversed: {
        modal: {
          backgroundColor: "background.reversed",
          color: "text.primary.reversed"
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    color: "default"
  }
});
var ModalCloseIconButton = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = modalStyles.splitVariantProps(rest);
  const modalClassNames = modalStyles(variantProps);
  return /* @__PURE__ */ jsx(
    DialogCloseButton,
    {
      variant: "text",
      className: cx(modalClassNames.closeButton, className),
      ...localProps,
      children: children ?? /* @__PURE__ */ jsx(Close, { size: "large" })
    }
  );
};
var ModalActions = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = modalStyles.splitVariantProps(rest);
  const modalClassNames = modalStyles(variantProps);
  return /* @__PURE__ */ jsx(DialogActions, { className: cx(modalClassNames.actions, className), ...localProps, children });
};
var ModalHeading = ({
  className,
  closeButton = true,
  closeButtonClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = modalStyles.splitVariantProps(rest);
  const modalVariantStyles = modalStyles.raw(variantProps);
  const [dialogVariantProps] = dialogStyles.splitVariantProps(rest);
  const dialogVariantStyles = dialogStyles.raw(dialogVariantProps);
  const closeButtonComponent = closeButton === true ? /* @__PURE__ */ jsx(ModalCloseIconButton, { className: closeButtonClassName, ...variantProps }) : closeButton;
  return /* @__PURE__ */ jsxs(
    DialogHeadingBase,
    {
      className: cx(css(dialogVariantStyles.heading, modalVariantStyles.heading), className),
      ...localProps,
      children: [
        children,
        closeButtonComponent
      ]
    }
  );
};
var ModalContent = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = modalStyles.splitVariantProps(rest);
  const modalClassNames = modalStyles(variantProps);
  return /* @__PURE__ */ jsx("div", { className: cx(modalClassNames.content, className), ...localProps, children });
};
var ModalBase = ({
  className,
  style,
  overlayClassName,
  dialogClassName,
  heading: heading2,
  children,
  ...rest
}) => {
  const [dialogVariantProps] = dialogStyles.splitVariantProps(rest);
  const [variantProps, localProps] = modalStyles.splitVariantProps(rest);
  const modalClassNames = modalStyles(variantProps);
  return /* @__PURE__ */ jsx(ModalOverlay, { className: cx(modalClassNames.overlay, overlayClassName), ...localProps, children: /* @__PURE__ */ jsx(Modal$1, { className: cx(className, modalClassNames.modal), style, children: /* @__PURE__ */ jsx(
    Dialog,
    {
      heading: heading2,
      className: cx(modalClassNames.dialog, dialogClassName),
      ...dialogVariantProps,
      children
    }
  ) }) });
};
var Modal = ({
  heading: heading2,
  closeButton,
  buttons,
  headingClassName,
  closeButtonClassName,
  actionsClassName,
  contentClassName,
  children,
  ...rest
}) => {
  const [modalVariantProps] = modalStyles.splitVariantProps(rest);
  const headingNode = typeof heading2 === "string" ? /* @__PURE__ */ jsx(
    ModalHeading,
    {
      closeButton,
      className: headingClassName,
      closeButtonClassName,
      children: heading2
    }
  ) : heading2;
  const buttonsNode = buttons ? /* @__PURE__ */ jsx(ModalActions, { className: actionsClassName, ...modalVariantProps, children: buttons }) : null;
  return /* @__PURE__ */ jsxs(ModalBase, { heading: headingNode, ...rest, children: [
    /* @__PURE__ */ jsx(ModalContent, { className: contentClassName, ...modalVariantProps, children }),
    buttonsNode
  ] });
};
var radioRecipe = sva({
  slots: ["root", "circle"],
  base: {
    root: {
      display: "flex",
      gap: "[8px]",
      alignItems: "center",
      cursor: "pointer",
      _disabled: {
        cursor: "not-allowed"
      },
      _componentReadOnly: {
        cursor: "default"
      }
    },
    circle: {
      boxSizing: "border-box",
      position: "relative",
      width: "[20px]",
      height: "[20px]",
      flexShrink: "0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "[1px solid]",
      borderColor: "teal.80",
      borderRadius: "full",
      backgroundColor: "[white]",
      _before: {
        content: '""',
        display: "block",
        aspectRatio: "1",
        borderRadius: "full"
      },
      _groupHover: {
        borderColor: "teal.100"
      },
      _groupSelected: {
        backgroundColor: "[currentColor]",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[transparent]"
        },
        _before: {
          backgroundColor: "[white]"
        }
      },
      _groupDisabled: {
        color: "gray.40",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[currentColor]"
        },
        _before: {
          backgroundColor: "[white]"
        }
      },
      _groupInvalid: {
        color: "alert.error",
        borderColor: "[currentColor]",
        _before: {
          backgroundColor: "[white]"
        }
      }
    }
  },
  variants: {
    size: {
      small: {
        root: {
          fontSize: "[12px]"
        },
        circle: {
          width: "[0.75rem]",
          height: "[0.75rem]",
          _before: {
            width: "[0.25rem]"
          }
        }
      },
      medium: {
        root: {
          fontSize: "sm"
        },
        circle: {
          width: "[0.875rem]",
          height: "[0.875rem]",
          _before: {
            width: "[0.375rem]"
          }
        }
      },
      large: {
        root: {
          fontSize: "md"
        },
        circle: {
          width: "[1.25rem]",
          height: "[1.25rem]",
          _before: {
            width: "[0.5rem]"
          }
        }
      }
    },
    color: {
      primary: {
        circle: {
          color: "accent.primary"
        }
      },
      secondary: {
        circle: {
          color: "accent.secondary",
          _groupSelected: {
            _before: {
              backgroundColor: "dark-teal.100"
            }
          }
        }
      },
      tertiary: {
        circle: {
          color: "accent.tertiary"
        }
      },
      teal: {
        circle: {
          color: "teal.100"
        }
      },
      cream: {
        circle: {
          color: "cream.100",
          borderColor: "[white]",
          _groupSelected: {
            _before: {
              backgroundColor: "dark-teal.100"
            }
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    color: "primary"
  }
});
var radioGroupRecipe = sva({
  slots: ["root", "label", "description", "error"],
  base: {
    root: {
      display: "flex",
      flexDir: "column",
      alignItems: "start",
      gap: "[2px]",
      color: "text.primary"
    },
    label: {},
    description: {},
    error: {}
  }
});
var RadioVariantContext = createContext(void 0);
function RadioGroup({
  label,
  children,
  description,
  errorMessage,
  className,
  labelClassName,
  descriptionClassName,
  errorClassName,
  ...props
}) {
  const [groupVariantProps, rest] = radioGroupRecipe.splitVariantProps(props);
  const [radioVariantProps, localProps] = radioRecipe.splitVariantProps(rest);
  const recipeClassNames = radioGroupRecipe(groupVariantProps);
  const { size } = props;
  return /* @__PURE__ */ jsx(RadioGroup$1, { ...localProps, className: cx(recipeClassNames.root, className), children: /* @__PURE__ */ jsxs(RadioVariantContext.Provider, { value: radioVariantProps, children: [
    /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
    children,
    /* @__PURE__ */ jsx(
      Description,
      {
        size,
        className: cx(recipeClassNames.description, descriptionClassName),
        children: description
      }
    ),
    /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] }) });
}
function Radio({ className, circleClassName, children, ...rest }) {
  const [variantProps, localProps] = radioRecipe.splitVariantProps(rest);
  const groupProps = useContext(RadioVariantContext);
  const recipeClassNames = radioRecipe.raw({ ...groupProps, ...variantProps });
  return /* @__PURE__ */ jsx(
    Radio$1,
    {
      ...localProps,
      className: cx("group", css(focusRing, recipeClassNames.root), className),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: cx(css(recipeClassNames.circle), circleClassName) }),
        children
      ] })
    }
  );
}
var loadingSpinnerRecipe = cva({
  base: {
    display: "flex",
    transformOrigin: "center",
    animation: "loading-spinner-rotate 0.75s infinite linear",
    // default light styles
    "--spinner-color": "{colors.dark-teal.100}",
    _dark: {
      "--spinner-color": "[white]"
    }
  },
  variants: {
    size: {
      small: {
        width: "[16px]",
        height: "[16px]"
      },
      medium: {
        width: "[32px]",
        height: "[32px]"
      },
      large: {
        width: "[64px]",
        height: "[64px]"
      },
      full: {
        width: "[100%]",
        height: "[100%]"
      }
    },
    color: {
      primary: {
        "--spinner-color": "colors.accent.primary",
        _dark: {
          "--spinner-color": "colors.accent.primary"
        }
      },
      secondary: {
        "--spinner-color": "colors.accent.secondary",
        _dark: {
          "--spinner-color": "colors.accent.secondary"
        }
      },
      tertiary: {
        "--spinner-color": "colors.accent.tertiary",
        _dark: {
          "--spinner-color": "colors.accent.tertiary"
        }
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
var LoadingSpinner = ({ className, ...rest }) => {
  const [variantProps] = loadingSpinnerRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx(
    ProgressBar,
    {
      className: cx(css(loadingSpinnerRecipe.raw(variantProps)), className),
      "aria-label": "Loading\u2026",
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          style: { width: "100%", height: "100%" },
          viewBox: "0 0 32 32",
          fill: "none",
          strokeWidth: 4,
          children: /* @__PURE__ */ jsx(
            "circle",
            {
              cx: "16",
              cy: "16",
              r: "14",
              strokeDashoffset: "2",
              stroke: "var(--spinner-color)",
              strokeDasharray: "60 60",
              strokeLinecap: "round"
            }
          )
        }
      )
    }
  );
};
var popoverStyles = sva({
  slots: ["root", "arrow", "heading"],
  // mimics Dialog and Tooltip
  base: {
    root: {
      cursor: "default",
      outline: "none"
    }
  },
  variants: {
    shape: {
      rounded: {},
      box: {}
    },
    color: {
      default: {},
      reversed: {}
    }
  },
  defaultVariants: {
    shape: "box",
    color: "default"
  }
});
var Popover = ({
  heading: heading2,
  className,
  arrowClassName,
  headingClassName,
  contentClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = popoverStyles.splitVariantProps(rest);
  const popoverVariantStyles = popoverStyles.raw(variantProps);
  const [tooltipVariantProps] = tooltipRecipe.splitVariantProps(rest);
  const tooltipVariantStyles = tooltipRecipe.raw(tooltipVariantProps);
  const [dialogVariantProps] = dialogStyles.splitVariantProps(rest);
  const headingRender = typeof heading2 === "string" ? /* @__PURE__ */ jsx(PopoverHeading, { className: headingClassName, ...variantProps, children: heading2 }) : heading2;
  return /* @__PURE__ */ jsxs(
    Popover$1,
    {
      className: cx(css(tooltipVariantStyles.root, popoverVariantStyles.root), className),
      ...localProps,
      children: [
        /* @__PURE__ */ jsx(PopoverOverlayArrow, { className: arrowClassName, ...variantProps }),
        /* @__PURE__ */ jsx(Dialog, { heading: headingRender, className: contentClassName, ...dialogVariantProps, children })
      ]
    }
  );
};
var PopoverHeading = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = popoverStyles.splitVariantProps(rest);
  const popoverVariantStyles = popoverStyles.raw(variantProps);
  const [dialogVariantProps] = dialogStyles.splitVariantProps(rest);
  const dialogVariantStyles = dialogStyles.raw(dialogVariantProps);
  return /* @__PURE__ */ jsx(
    DialogHeadingBase,
    {
      className: cx(
        css(dialogVariantStyles.heading, popoverVariantStyles.heading),
        className
      ),
      ...localProps,
      children
    }
  );
};
var PopoverOverlayArrow = ({ className, ...rest }) => {
  const [variantProps, localProps] = popoverStyles.splitVariantProps(rest);
  const popoverVariantStyles = popoverStyles.raw(variantProps);
  const [tooltipVariantProps] = tooltipRecipe.splitVariantProps(rest);
  const tooltipVariantStyles = tooltipRecipe.raw(tooltipVariantProps);
  return /* @__PURE__ */ jsx(
    OverlayArrow,
    {
      className: cx(css(tooltipVariantStyles.arrow, popoverVariantStyles.arrow), className),
      ...localProps
    }
  );
};
var selectRecipe = sva({
  slots: [
    "root",
    "button",
    "arrowIcon",
    "listBox",
    "listBoxSection",
    "listBoxHeader",
    "listBoxItem",
    "listBoxItemIcon",
    "listBoxItemText",
    "popover",
    "selectValue",
    "label",
    "description",
    "error"
  ],
  base: {
    root: {
      boxSizing: "border-box",
      display: "grid",
      gridTemplateRows: "[1fr auto 1fr]",
      fontWeight: "medium",
      cursor: "pointer",
      _disabled: {
        cursor: "not-allowed"
      }
    },
    button: {
      fontSize: "[inherit]",
      fontFamily: "body",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "[fit-content]",
      cursor: "pointer",
      fontWeight: "medium",
      border: "[1px solid]",
      gap: "1",
      transition: "[background-color 250ms, color 250ms, opacity 250ms]",
      '& [data-empty-icon="true"]': {
        display: "none"
        // if no icon, then hide the default space for it
      },
      _disabled: {
        cursor: "not-allowed",
        backgroundColor: "gray.20",
        borderColor: "gray.40",
        color: "gray.80"
      },
      _hover: {
        _notDisabled: {
          borderColor: "green.100"
        }
      },
      _groupInvalid: {
        borderColor: "error-red.100",
        color: "error-red.100",
        _dark: {
          color: "error-red.60"
        }
      },
      // default light styles
      backgroundColor: "[white]",
      borderColor: "[white]",
      color: "text.primary",
      _dark: {
        backgroundColor: "background",
        borderColor: "background",
        color: "text.primary",
        _disabled: {
          cursor: "not-allowed",
          backgroundColor: "gray.20",
          borderColor: "gray.40",
          color: "gray.80"
        }
      }
    },
    popover: {
      minWidth: "var(--trigger-width)",
      width: "[fit-content]",
      padding: "[0]",
      border: "none",
      borderRadius: "md",
      marginTop: "0",
      backgroundColor: "[white]",
      _dark: {
        backgroundColor: "background",
        color: "text.primary"
      }
    },
    listBox: {
      padding: "0",
      backgroundColor: "[inherit]",
      borderRadius: "md",
      border: "[none]",
      color: "[inherit]",
      fontSize: "[inherit]"
    },
    listBoxItem: {
      display: "grid",
      gridTemplateColumns: "[24px auto]",
      alignItems: "center",
      gap: "[8px]",
      border: "[none]",
      borderRadius: "md",
      backgroundColor: "[inherit]",
      padding: "[8px 8px]",
      color: "[inherit]",
      cursor: "pointer",
      _active: {
        backgroundColor: "cream.100",
        // form/menu/selected/bg
        _dark: {
          backgroundColor: "extra-dark-teal.100"
          // form/menu/selected/bg
        }
      },
      _hover: {
        backgroundColor: "dark-teal.10",
        // form/menu/hovered/bg
        _dark: {
          backgroundColor: "cream.10"
          // form/menu/hovered/bg
        }
      }
    },
    listBoxItemIcon: {
      justifySelf: "center",
      "& svg": {
        width: "[100%]",
        height: "[100%]"
      }
    },
    listBoxItemText: {
      justifySelf: "start"
    },
    arrowIcon: {
      color: "accent.secondary",
      pointerEvents: "none",
      transition: "[transform 250ms]",
      _groupDisabled: {
        color: "gray.80"
      },
      _groupOpen: {
        transform: "rotate(180deg)"
      }
    },
    selectValue: {
      display: "flex",
      gap: "[8px]",
      alignItems: "center"
    },
    listBoxSection: {
      fontSize: "[inherit]",
      backgroundColor: "[inherit]",
      border: "[none]",
      borderRadius: "md"
    },
    listBoxHeader: {
      fontSize: "md",
      border: "[none]",
      padding: "[8px 16px]"
    },
    label: {},
    description: {},
    error: {}
  },
  variants: {
    fullWidth: {
      false: {},
      true: {
        root: {
          width: "[100%]"
        },
        button: {
          width: "[100%]"
        }
      }
    },
    variant: {
      contained: {},
      // default
      outlined: {
        button: {
          border: "[1px solid]",
          borderColor: "dark-teal.20",
          _dark: {
            borderColor: "[color-mix(in srgb, {colors.cream.100} 20%, {colors.background})]",
            color: "text.primary"
          }
        }
      }
    },
    shape: {
      box: {
        button: {
          borderRadius: "sm"
        }
      },
      rounded: {
        button: {
          borderRadius: "full"
        }
      }
    },
    size: {
      small: {
        root: {
          fontSize: "[12px]"
          // todo: add fontsize for xs
        },
        button: {
          padding: "[8px 20px]"
        },
        listBoxItem: {
          height: "[32px]",
          fontSize: "[12px]"
          // todo: add fontsize for xs
        },
        listBoxItemIcon: {
          width: "[16px]",
          height: "[16px]"
        }
      },
      medium: {
        root: {
          fontSize: "sm"
        },
        button: {
          padding: "[8px 24px]"
        },
        listBoxItem: {
          height: "[36px]",
          fontSize: "sm"
        },
        listBoxItemIcon: {
          width: "[20px]",
          height: "[20px]"
        }
      },
      large: {
        root: {
          fontSize: "md"
        },
        button: {
          padding: "[16px 24px]"
        },
        listBoxItem: {
          height: "[56px]",
          fontSize: "md"
        },
        listBoxItemIcon: {
          width: "[24px]",
          height: "[24px]"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outlined",
    shape: "box",
    size: "medium"
  }
});
var SelectValue = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    SelectValue$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.selectValue, focusRing), className)
    }
  );
};
var SelectPopover = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    Popover$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.popover, focusRing), className)
    }
  );
};
var SelectListBox = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    ListBox,
    {
      ...localProps,
      className: cx(css(recipeClassNames.listBox, focusRing), className)
    }
  );
};
var SelectListBoxItem = ({
  icon,
  text: text3,
  children,
  className,
  listBoxItemIconClassName,
  listBoxItemText,
  ...rest
}) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const groupProps = useContext(SelectVariantContext);
  const recipeClassNames = selectRecipe.raw({ ...groupProps, ...variantProps });
  return /* @__PURE__ */ jsxs(
    ListBoxItem,
    {
      ...localProps,
      className: cx(css(recipeClassNames.listBoxItem, focusRing), className),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": true,
            "data-empty-icon": icon === void 0,
            className: cx(css(recipeClassNames.listBoxItemIcon), listBoxItemIconClassName),
            children: icon
          }
        ),
        /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.listBoxItemText), listBoxItemText), children: text3 }),
        children
      ]
    }
  );
};
var SelectButton = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    Button$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.button, focusRing), className)
    }
  );
};
var SelectVariantContext = createContext(void 0);
var Select = ({
  className,
  items,
  label,
  description,
  errorMessage,
  buttonClassName,
  descriptionClassName,
  labelClassName,
  popoverClassName,
  listBoxItemClassName,
  errorClassName,
  children,
  ...rest
}) => {
  const [open, setOpen] = React10.useState(false);
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe(variantProps);
  const { size } = rest;
  return /* @__PURE__ */ jsx(
    Select$1,
    {
      ...localProps,
      isOpen: open,
      onOpenChange: setOpen,
      className: cx("group", recipeClassNames.root, className),
      children: /* @__PURE__ */ jsxs(SelectVariantContext.Provider, { value: variantProps, children: [
        /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
        /* @__PURE__ */ jsxs(SelectButton, { ...variantProps, className: buttonClassName, children: [
          /* @__PURE__ */ jsx(SelectValue, {}),
          /* @__PURE__ */ jsx(ArrowDropDownIcon, { "aria-hidden": true, className: cx(recipeClassNames.arrowIcon) })
        ] }),
        /* @__PURE__ */ jsx(
          Description,
          {
            size,
            className: cx(recipeClassNames.description, descriptionClassName),
            children: description
          }
        ),
        /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage }),
        /* @__PURE__ */ jsx(SelectPopover, { ...variantProps, offset: 0, className: popoverClassName, children: /* @__PURE__ */ jsxs(SelectListBox, { ...variantProps, className: cx(recipeClassNames.listBox), children: [
          children,
          items?.map((item) => /* @__PURE__ */ jsx(
            SelectListBoxItem,
            {
              ...variantProps,
              text: item,
              className: listBoxItemClassName
            },
            item
          ))
        ] }) })
      ] })
    }
  );
};
var ArrowDropDownIcon = ({ className }) => /* @__PURE__ */ jsx(
  "svg",
  {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("g", { id: "arrow_drop_down", children: /* @__PURE__ */ jsx("path", { id: "Vector", d: "M7 9.5L12 14.5L17 9.5H7Z", fill: "currentColor" }) })
  }
);
var SelectListBoxHeader = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    Header$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.listBoxHeader, focusRing), className)
    }
  );
};
var SelectListBoxSection = ({ className, ...rest }) => {
  const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
  const recipeClassNames = selectRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    ListBoxSection,
    {
      ...localProps,
      className: cx(css(recipeClassNames.listBoxSection, focusRing), className)
    }
  );
};
var sliderRecipe = sva({
  slots: [
    "root",
    "label",
    "output",
    "control",
    "track",
    "indicator",
    "thumb",
    "description",
    "error"
  ],
  base: {
    root: {
      display: "grid",
      gridTemplateColumns: "[1fr auto]"
    },
    // This is the <label> for the slider
    label: {},
    // this is the value (for the slider)
    output: {
      color: "[currentColor]"
    },
    control: {
      gridColumn: "[1 / -1]",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      _disabled: {
        cursor: "not-allowed",
        color: "gray.40"
      }
    },
    track: {
      position: "relative",
      borderRadius: "full",
      backgroundColor: "teal.20",
      _groupDisabled: {
        // this prevents hover state
        pointerEvents: "none",
        backgroundColor: "gray.20"
      }
    },
    indicator: {
      borderRadius: "full",
      backgroundColor: "[currentColor]"
    },
    thumb: {
      boxSizing: "border-box",
      borderRadius: "full",
      width: "var(--slider-control-size)",
      aspectRatio: "1",
      backgroundColor: "[currentColor]",
      _disabled: {
        color: "[inherit]"
      },
      _dragging: {
        color: "[inherit]"
      }
    },
    description: {},
    error: {}
  },
  variants: {
    color: {
      primary: {
        control: {
          color: "accent.primary"
        },
        thumb: {
          color: "pink.80",
          _hover: {
            color: "accent.primary"
          }
        }
      },
      secondary: {
        control: {
          color: "accent.secondary"
        },
        thumb: {
          color: "green.80",
          _hover: {
            color: "accent.secondary"
          }
        }
      },
      tertiary: {
        control: {
          color: "accent.tertiary"
        },
        thumb: {
          color: "purple.80",
          _hover: {
            color: "accent.tertiary"
          },
          _dragging: {
            color: "accent.tertiary"
          }
        }
      },
      teal: {
        control: {
          color: "teal.100"
        },
        thumb: {
          color: "teal.80",
          _hover: {
            color: "teal.100"
          }
        }
      },
      cream: {
        control: {
          color: "cream.100"
        },
        track: {
          backgroundColor: "[white]"
        },
        thumb: {
          color: "[white]",
          _hover: {
            color: "cream.100"
          }
        }
      }
    },
    size: {
      small: {
        root: {
          "--slider-control-size": "[0.75rem]",
          "--slider-track-size": "[0.25rem]"
        }
      },
      medium: {
        root: {
          "--slider-control-size": "[0.875rem]",
          "--slider-track-size": "[0.25rem]"
        }
      },
      large: {
        root: {
          "--slider-control-size": "[1.25rem]",
          "--slider-track-size": "[0.375rem]"
        }
      }
    },
    orientation: {
      horizontal: {
        root: {
          width: "[100%]"
        },
        output: {},
        control: {
          height: "var(--slider-control-size)",
          width: "[100%]"
        },
        track: {
          height: "var(--slider-track-size)",
          width: "[100%]"
        },
        indicator: {
          top: "[0]",
          height: "[100%]"
        },
        thumb: {
          top: "[50%]"
        }
      },
      vertical: {
        root: {
          height: "[100%]",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        },
        output: {
          marginBottom: "[calc(var(--slider-control-size) / 2)]"
        },
        control: {
          width: "var(--slider-control-size)",
          height: "[100%]",
          justifyContent: "center"
        },
        track: {
          width: "var(--slider-track-size)",
          height: "[100%]"
        },
        indicator: {
          left: "[0]",
          width: "[100%]"
        },
        thumb: {
          left: "[50%]"
        }
      }
    }
  },
  defaultVariants: {
    color: "primary",
    size: "medium",
    orientation: "horizontal"
  }
});
var SliderThumb = ({ className, ...rest }) => {
  const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
  const recipeClassNames = sliderRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    SliderThumb$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.thumb, focusRing), className)
    }
  );
};
var SliderTrack = ({
  className,
  trackClassName,
  indicatorClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
  const recipeClassNames = sliderRecipe(variantProps);
  return /* @__PURE__ */ jsx(
    SliderTrack$1,
    {
      ...localProps,
      className: cx("group", recipeClassNames.control, className),
      children: (renderProps) => /* @__PURE__ */ jsx("div", { className: cx(recipeClassNames.track, trackClassName), children: children(renderProps) })
    }
  );
};
var SliderOutput = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
  const recipeClassNames = sliderRecipe(variantProps);
  return /* @__PURE__ */ jsx(SliderOutput$1, { ...localProps, className: cx(recipeClassNames.output, className), children });
};
var SliderBase = ({
  className,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
  const recipeClassNames = sliderRecipe(variantProps);
  const localPropsWithOrientation = { ...localProps, orientation: variantProps.orientation };
  return /* @__PURE__ */ jsx(Slider$1, { ...localPropsWithOrientation, className: cx(recipeClassNames.root, className), children });
};
var SliderTrackIndicator = ({ state, className, ...variantProps }) => {
  const { values } = state;
  const { orientation } = variantProps;
  const recipeClassNames = sliderRecipe(variantProps);
  const style = {
    position: "absolute"
  };
  let minValue = 0;
  const maxValue = state.getThumbPercent(state.values.length - 1);
  if (values.length > 1) {
    minValue = state.getThumbPercent(0);
  }
  if (orientation === "vertical") {
    style.top = `${(1 - maxValue) * 100}%`;
    style.bottom = `${minValue * 100}%`;
  } else {
    style.left = `${minValue * 100}%`;
    style.right = `${(1 - maxValue) * 100}%`;
  }
  return /* @__PURE__ */ jsx("div", { style, className: cx(recipeClassNames.indicator, className) });
};
var Slider = ({
  label,
  thumbLabels,
  description,
  errorMessage,
  className,
  labelClassName,
  outputClassName,
  controlClassName,
  trackClassName,
  indicatorClassName,
  thumbClassName,
  descriptionClassName,
  errorClassName,
  ...props
}) => {
  const [variantProps] = sliderRecipe.splitVariantProps(props);
  const recipeClassNames = sliderRecipe(variantProps);
  const { size } = props;
  return /* @__PURE__ */ jsxs(SliderBase, { ...props, className, children: [
    /* @__PURE__ */ jsx(Label, { size, className: cx(recipeClassNames.label, labelClassName), children: label }),
    /* @__PURE__ */ jsx(SliderOutput, { ...variantProps, className: outputClassName, children: ({ state }) => state.values.map((_, i) => state.getThumbValueLabel(i)).join(" \u2013 ") }),
    /* @__PURE__ */ jsx(
      SliderTrack,
      {
        ...variantProps,
        className: controlClassName,
        trackClassName,
        children: ({ orientation, state }) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            SliderTrackIndicator,
            {
              ...variantProps,
              orientation,
              state,
              className: indicatorClassName
            }
          ),
          state.values.map((_, i) => {
            return /* @__PURE__ */ createElement(
              SliderThumb,
              {
                ...variantProps,
                key: i,
                index: i,
                "aria-label": thumbLabels?.[i],
                className: thumbClassName
              }
            );
          })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Description,
      {
        size,
        className: cx(recipeClassNames.description, descriptionClassName),
        children: description
      }
    ),
    /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
  ] });
};
var snackbarRecipe = sva({
  slots: ["root", "message", "action", "exit"],
  base: {
    root: {
      padding: "[16px 16px 16px 24px]",
      display: "flex",
      width: "[100%]",
      alignItems: "center",
      justifyContent: "space-between",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      animation: "fadeIn 250ms ease-out forwards"
    },
    message: {},
    action: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
      gap: "[8px]"
    },
    exit: {
      background: "[none]",
      cursor: "pointer",
      border: "none",
      padding: "[5px]"
    }
  },
  variants: {
    variant: {
      default: {
        root: {
          backgroundColor: "extra-dark-teal.100",
          color: "text.primary.reversed",
          _dark: {
            backgroundColor: "cream.100",
            color: "text.primary"
          }
        },
        message: {
          color: "cream.100",
          _dark: {
            color: "text.primary.reversed"
          }
        },
        action: {
          color: "accent.secondary",
          _dark: {
            color: "accent.primary"
          }
        },
        exit: {
          color: "cream.100",
          _dark: {
            color: "text.primary.reversed"
          },
          _hover: {
            backgroundColor: "cream.10",
            _dark: {
              backgroundColor: "extra-dark-teal.10"
            }
          }
        }
      },
      confirmation: {
        root: {
          backgroundColor: "alert.confirmation",
          color: "cream.100",
          _dark: {
            color: "text.primary"
          }
        },
        action: {
          color: "[inherit]"
        },
        exit: {
          color: "[inherit]",
          _hover: {
            backgroundColor: "cream.10"
          }
        }
      },
      error: {
        root: {
          backgroundColor: "alert.error",
          color: "extra-dark-teal.100"
        },
        action: {
          color: "[inherit]"
        },
        exit: {
          color: "[inherit]",
          _hover: {
            backgroundColor: "extra-dark-teal.10"
          }
        }
      }
    },
    shape: {
      rounded: {
        root: {
          borderRadius: "full"
        }
      },
      square: {
        root: {
          borderRadius: "sm"
        }
      }
    }
  },
  defaultVariants: {
    variant: "default",
    shape: "square"
  }
});
function Snackbar({
  message,
  variant = "default",
  autoHideDuration = 5e3,
  className,
  action,
  actionClassName,
  messageClassName,
  open,
  onClose,
  index,
  id,
  exitClassName,
  ariaLabel,
  ...rest
}) {
  const [variantProps, localProps] = snackbarRecipe.splitVariantProps(rest);
  const recipeClassNames = snackbarRecipe.raw({
    ...variantProps,
    variant
  });
  useEffect(() => {
    if (open && autoHideDuration && onClose !== void 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [open, autoHideDuration, onClose]);
  return open ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: cx(css(recipeClassNames.root), className),
      ...localProps,
      "aria-label": ariaLabel,
      id,
      children: [
        /* @__PURE__ */ jsx("span", { className: cx(css(recipeClassNames.message), messageClassName), children: message }),
        action !== void 0 ? /* @__PURE__ */ jsxs("div", { className: cx(css(recipeClassNames.action), actionClassName), children: [
          action,
          /* @__PURE__ */ jsx(
            Button$1,
            {
              slot: "remove",
              className: cx(css(recipeClassNames.exit), exitClassName),
              children: /* @__PURE__ */ jsx(icons_exports.Close, { size: "medium" })
            }
          )
        ] }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          Button$1,
          {
            slot: "remove",
            className: cx(css(recipeClassNames.exit), exitClassName),
            children: /* @__PURE__ */ jsx(icons_exports.Close, { size: "medium" })
          }
        ) })
      ]
    }
  ) : null;
}
var SnackbarNotificationContext = createContext(
  void 0
);
var SnackbarNotificationProvider = ({
  children,
  maxStack = 4
  // Default max stack limit
}) => {
  const [snackbarNotifications, setSnackbarNotifications] = useState({
    topLeft: [],
    topCenter: [],
    topRight: [],
    bottomLeft: [],
    bottomCenter: [],
    bottomRight: []
  });
  const removeSnackbarNotification = useCallback((anchorOrigin, id) => {
    setSnackbarNotifications((prev) => ({
      ...prev,
      [anchorOrigin]: prev[anchorOrigin].filter((notification) => notification.id !== id)
    }));
  }, []);
  const addSnackbarNotification = useCallback(
    (anchorOrigin, snackbarNotification) => {
      const id = crypto.randomUUID();
      const newSnackbarNotification = { id, ...snackbarNotification };
      setSnackbarNotifications((prev) => {
        const updatedSnackbarNotifications = [
          ...prev[anchorOrigin],
          newSnackbarNotification
        ];
        return {
          ...prev,
          [anchorOrigin]: updatedSnackbarNotifications.length > maxStack ? updatedSnackbarNotifications.slice(1) : updatedSnackbarNotifications
        };
      });
      if (snackbarNotification.autoHideDuration !== void 0) {
        setTimeout(() => {
          removeSnackbarNotification(anchorOrigin, id);
        }, snackbarNotification.autoHideDuration);
      }
    },
    [maxStack, removeSnackbarNotification]
  );
  const clearAllSnackbarNotification = useCallback(() => {
    setSnackbarNotifications({
      topLeft: [],
      topCenter: [],
      topRight: [],
      bottomLeft: [],
      bottomCenter: [],
      bottomRight: []
    });
  }, []);
  return /* @__PURE__ */ jsx(
    SnackbarNotificationContext.Provider,
    {
      value: {
        snackbarNotifications,
        addSnackbarNotification,
        removeSnackbarNotification,
        clearAllSnackbarNotification
      },
      children
    }
  );
};
var useSnackbarNotification = () => {
  const context = useContext(SnackbarNotificationContext);
  if (context === void 0)
    throw new Error(
      "useSnackbarNotification must be used within a SnackbarNotificationContext"
    );
  return context;
};
var snackbarListRecipe = sva({
  slots: ["root"],
  base: {
    root: {
      position: "fixed",
      display: "flex",
      flexDirection: "column-reverse",
      gap: "[1rem]",
      zIndex: "[snackbar]"
    }
  },
  variants: {
    anchorOrigin: {
      topLeft: {
        root: {
          top: "[1rem]",
          left: "[1rem]"
        }
      },
      topCenter: {
        root: {
          top: "[1rem]",
          left: "[50%]",
          transform: "translateX(-50%)"
        }
      },
      topRight: {
        root: {
          top: "[1rem]",
          right: "[1rem]"
        }
      },
      bottomLeft: {
        root: {
          bottom: "[1rem]",
          left: "[1rem]"
        }
      },
      bottomCenter: {
        root: {
          bottom: "[1rem]",
          left: "[50%]",
          transform: "translateX(-50%)"
        }
      },
      bottomRight: {
        root: {
          bottom: "[1rem]",
          right: "[1rem]"
        }
      }
    }
  },
  defaultVariants: {
    anchorOrigin: "bottomLeft"
  }
});
function SnackbarList({ className, ariaLabel, anchorOrigin, ...rest }) {
  const { snackbarNotifications, removeSnackbarNotification } = useSnackbarNotification();
  const notificationsForAnchor = snackbarNotifications[anchorOrigin];
  const [variantProps, localProps] = snackbarListRecipe.splitVariantProps(rest);
  const recipeClassNames = snackbarListRecipe.raw({
    ...variantProps,
    anchorOrigin
  });
  const content = /* @__PURE__ */ jsx(
    "div",
    {
      ...localProps,
      className: cx(css(recipeClassNames.root), className),
      "aria-label": ariaLabel,
      children: notificationsForAnchor.map((notification, index) => /* @__PURE__ */ jsx(
        Snackbar,
        {
          ...notification,
          open: true,
          index,
          onClose: () => {
            removeSnackbarNotification(anchorOrigin, notification.id);
          }
        },
        notification.id
      ))
    }
  );
  return createPortal(content, document.body);
}
var generateSpacing = (max) => {
  const spacing = {};
  for (let i = 0; i <= max; i++) {
    spacing[i] = { gap: `[${i}px]` };
  }
  return spacing;
};
var stackRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "0"
  },
  variants: {
    direction: {
      row: {
        flexDirection: "row"
      },
      column: {
        flexDirection: "column"
      }
    },
    align: {
      start: { alignItems: "flex-start" },
      center: { alignItems: "center" },
      end: { alignItems: "flex-end" },
      stretch: { alignItems: "stretch" }
    },
    justify: {
      start: { justifyContent: "flex-start" },
      center: { justifyContent: "center" },
      end: { justifyContent: "flex-end" },
      between: { justifyContent: "space-between" },
      around: { justifyContent: "space-around" },
      evenly: { justifyContent: "space-evenly" }
    },
    fullWidth: {
      true: {
        width: "[100%]"
      }
    },
    spacing: generateSpacing(100)
  },
  defaultVariants: {
    direction: "column",
    align: "start",
    justify: "start",
    spacing: 0
  }
});
var Stack = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = stackRecipe.splitVariantProps(rest);
  return /* @__PURE__ */ jsx("div", { className: cx(stackRecipe(variantProps), className), ...localProps, children });
};
var switchRecipe = sva({
  className: "switch-recipe",
  slots: ["root", "label", "track", "thumb", "description", "error"],
  base: {
    root: {
      display: "flex",
      gap: "[8px]",
      alignItems: "center",
      cursor: "pointer",
      color: "text.primary",
      _disabled: {
        cursor: "not-allowed"
      },
      _componentReadOnly: {
        cursor: "default"
      }
    },
    label: {},
    track: {
      boxSizing: "border-box",
      position: "relative",
      flexShrink: "0",
      display: "flex",
      alignItems: "center",
      padding: "[1px]",
      border: "[1px solid]",
      borderColor: "teal.80",
      borderRadius: "full",
      backgroundColor: "[white]",
      _groupHover: {
        borderColor: "teal.100"
      },
      _groupSelected: {
        backgroundColor: "[currentColor]",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[currentColor]"
        }
      },
      _groupDisabled: {
        color: "gray.40",
        // this overrides other states (namely hover)
        "&": {
          borderColor: "[currentColor]"
        }
      }
    },
    thumb: {
      boxSizing: "border-box",
      position: "absolute",
      display: "block",
      aspectRatio: "1",
      borderRadius: "full",
      transition: "[right 0.2s ease-in-out]",
      backgroundColor: "teal.80",
      _groupHover: {
        backgroundColor: "var(--switch-hover-thumb-color, {colors.teal.100})"
      },
      _groupSelected: {
        right: "[1px]",
        // this overrides other states
        "&": {
          backgroundColor: "[currentColor]"
        }
      },
      _groupDisabled: {
        // this is used to override the hover background color
        // its extra special to override readonly
        "&": {
          "--switch-hover-thumb-color": "{colors.gray.40}"
        },
        backgroundColor: "gray.40",
        color: "[white]"
      },
      _groupComponentReadOnly: {
        "--switch-hover-thumb-color": "{colors.teal.80}"
      }
    },
    description: {},
    error: {}
  },
  variants: {
    size: {
      small: {
        root: {
          fontSize: "[12px]"
        },
        track: {
          width: "[1.375rem]",
          height: "[0.75rem]"
        },
        thumb: {
          width: "[0.5rem]",
          // 100% - width - padding
          right: "[calc(100% - 0.5rem - 1px)]"
        }
      },
      medium: {
        root: {
          fontSize: "sm"
        },
        track: {
          width: "[1.625rem]",
          height: "[0.875rem]"
        },
        thumb: {
          width: "[0.625rem]",
          // 100% - width - padding
          right: "[calc(100% - 0.625rem - 1px)]"
        }
      },
      large: {
        root: {
          fontSize: "md"
        },
        track: {
          width: "[2.3125rem]",
          height: "[1.25rem]"
        },
        thumb: {
          width: "[0.875rem]",
          // 100% - width - padding
          right: "[calc(100% - 0.875rem - 2px)]",
          _groupSelected: {
            right: "[2px]"
          }
        }
      }
    },
    color: {
      primary: {
        track: {
          color: "accent.primary"
        },
        thumb: {
          _groupSelected: {
            color: "cream.100"
          }
        }
      },
      secondary: {
        track: {
          color: "accent.secondary"
        },
        thumb: {
          _groupSelected: {
            color: "dark-teal.100"
          }
        }
      },
      tertiary: {
        track: {
          color: "accent.tertiary"
        },
        thumb: {
          _groupSelected: {
            color: "cream.100"
          }
        }
      },
      teal: {
        track: {
          color: "teal.100"
        },
        thumb: {
          _groupSelected: {
            color: "cream.100"
          }
        }
      },
      cream: {
        track: {
          backgroundColor: "dark-teal.100",
          // unselected track color (instead of white)
          color: "cream.100",
          // selected track color
          borderColor: "cream.100/60",
          // not sure about using opacity here
          _groupHover: {
            borderColor: "cream.100"
          }
        },
        thumb: {
          backgroundColor: "cream.100",
          // unselected thumb color (instead of teal)
          _groupSelected: {
            color: "dark-teal.100"
            // selected thumb color
          },
          _groupHover: {
            // hover thumb color, instead of teal default
            backgroundColor: "var(--switch-hover-thumb-color, {colors.cream.100})"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "medium",
    color: "primary"
  }
});
var Switch = ({
  children,
  description,
  errorMessage,
  className,
  trackClassName,
  thumbClassName,
  errorClassName,
  descriptionClassName,
  ...rest
}) => {
  const [variantProps, localProps] = switchRecipe.splitVariantProps(rest);
  const recipeClassNames = switchRecipe(variantProps);
  const { size } = rest;
  return (
    // we need to wrap the `raw` focusRing and `raw` recipeClassNames.root in `css()` to merge them
    // there is no garauntee which class will take precidence
    /* @__PURE__ */ jsxs(Switch$1, { ...localProps, className: cx("group", recipeClassNames.root, className), children: [
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: cx(css(groupFocusRing), recipeClassNames.track, trackClassName), children: /* @__PURE__ */ jsx("div", { className: cx(recipeClassNames.thumb, thumbClassName) }) }),
        children
      ] }),
      /* @__PURE__ */ jsx(
        Description,
        {
          size,
          className: cx(recipeClassNames.description, descriptionClassName),
          children: description
        }
      ),
      /* @__PURE__ */ jsx(FieldError, { size, className: cx(recipeClassNames.error, errorClassName), children: errorMessage })
    ] })
  );
};
var tabsRecipe = sva({
  slots: ["root", "tabList", "tab", "tabPanel"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      "&[data-orientation=horizontal]": {
        flexDirection: "column"
      },
      "&[data-orientation=vertical]": {
        flexDirection: "row"
      }
    },
    tabList: {
      display: "flex",
      gap: "[8px]",
      '&[data-orientation="horizontal"]': {
        borderBottom: "[1px solid gray]"
      },
      "&[data-orientation=vertical]": {
        flexDirection: "column",
        borderInlineEnd: "[1px solid gray]"
      }
    },
    tab: {
      padding: "[8px 16px]",
      outline: "none",
      position: "relative",
      cursor: "default",
      color: "text.primary",
      fontSize: "[14px]",
      border: "[1px solid]",
      borderColor: "[transparent]",
      boxSizing: "border-box",
      borderBottom: "3px solid transparent",
      borderInlineEnd: "3px solid transparent",
      "& svg": {
        color: "dark-teal.100"
      },
      _dark: {
        "&[data-selected]": {
          cursor: "pointer",
          borderColor: "accent.secondary",
          color: "accent.secondary"
        },
        _hover: {
          cursor: "pointer",
          borderInlineEndColor: "accent.secondary"
        },
        "& svg": {
          color: "cream.100"
        }
      },
      _hover: {
        borderBottomColor: "accent.primary",
        cursor: "pointer",
        _dark: {
          borderBottomColor: "accent.secondary",
          borderRightColor: "[transparent]"
        }
      },
      "&[data-selected]": {
        color: "accent.primary",
        borderTopColor: "[transparent]",
        borderLeftColor: "[transparent]",
        borderRightColor: "[transparent]",
        borderBottomColor: "accent.primary",
        cursor: "pointer",
        "& svg": {
          color: "accent.primary"
        },
        _dark: {
          borderTopColor: "[transparent]",
          borderLeftColor: "[transparent]",
          borderRightColor: "[transparent]",
          borderBottomColor: "accent.secondary",
          "& svg": {
            color: "accent.secondary"
          }
        }
      },
      '&[data-selected]:is([data-orientation="vertical"] &)': {
        borderInlineEndColor: "accent.primary",
        borderBottomColor: "[transparent]",
        cursor: "pointer",
        _dark: {
          borderInlineEndColor: "accent.secondary",
          borderBottomColor: "[transparent]",
          cursor: "pointer"
        }
      },
      '&:not([data-selected]):is([data-orientation="horizontal"] &)': {
        cursor: "pointer"
      },
      '&:not([data-selected]):is([data-orientation="vertical"] &)': {
        _hover: {
          borderInlineEndColor: "accent.primary",
          borderBottomColor: "[transparent]",
          cursor: "pointer",
          _dark: {
            borderInlineEndColor: "accent.secondary",
            borderBottomColor: "[transparent]"
          }
        }
      },
      "&[data-disabled]": {
        color: "gray.60",
        cursor: "not-allowed",
        borderBottom: "3px solid transparent",
        borderInlineEnd: "3px solid transparent",
        "& svg": {
          color: "[gray.60]"
        },
        _dark: {
          borderColor: "[transparent]",
          "& svg": {
            color: "[gray.60]"
          }
        },
        _hover: {
          cursor: "not-allowed",
          borderBottomColor: "[transparent]",
          _dark: {
            borderBottomColor: "[transparent]"
          },
          '&[data-selected]:is([data-orientation="vertical"] &)': {
            borderInlineEndColor: "gray.30",
            borderBottomColor: "[transparent]"
          }
        },
        "&[data-selected]": {
          borderBottomColor: "gray.30",
          _dark: {
            borderBottomColor: "gray.30",
            color: "gray.60"
          }
        },
        '&[data-selected]:is([data-orientation="vertical"] &)': {
          borderInlineEndColor: "gray.30",
          borderBottomColor: "[transparent]",
          cursor: "not-allowed"
        },
        '&:not([data-selected]):is([data-orientation="vertical"] &)': {
          _hover: {
            borderColor: "[transparent]",
            cursor: "not-allowed"
          }
        },
        '&:not([data-selected]):is([data-orientation="horizontal"] &)': {
          cursor: "not-allowed"
        }
      }
    },
    tabPanel: {
      marginTop: "[4px]",
      padding: "[10px]",
      borderRadius: "[4px]",
      outline: "none",
      color: "text.primary",
      fontSize: "[14px]"
    }
  }
});
var TabList = ({
  className,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = tabsRecipe.splitVariantProps(rest);
  const recipeClassNames = tabsRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(TabList$1, { ...localProps, className: cx(css(recipeClassNames.tabList), className), children });
};
var Tabs = ({
  className,
  disabledKeys,
  selectedKey,
  orientation = "horizontal",
  isDisabled,
  onSelectionChange,
  items,
  tabListClassName,
  tabClassName,
  tabPanelClassName,
  children,
  ...rest
}) => {
  const [variantProps, localProps] = tabsRecipe.splitVariantProps(rest);
  const recipeClassNames = tabsRecipe.raw({
    ...variantProps
  });
  return /* @__PURE__ */ jsx(TabsContext.Provider, { value: { selectedKey, onSelectionChange }, children: /* @__PURE__ */ jsxs(
    Tabs$1,
    {
      ...localProps,
      className: cx(css(recipeClassNames.root), className),
      orientation,
      selectedKey,
      isDisabled,
      disabledKeys,
      onSelectionChange,
      children: [
        items !== void 0 && items.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(TabList, { className: cx(css(recipeClassNames.tabList), tabListClassName), children: items.map(({ id, header, isDisabled: isDisabled2 }) => /* @__PURE__ */ jsx(React10__default.Fragment, { children: header({
            id,
            className: cx(css(recipeClassNames.tab), tabClassName),
            isDisabled: isDisabled2
          }) }, id)) }),
          items.map(({ id, content }) => /* @__PURE__ */ jsx(React10__default.Fragment, { children: content({
            id,
            className: cx(
              css(recipeClassNames.tabPanel),
              tabPanelClassName
            )
          }) }, id))
        ] }) : null,
        children
      ]
    }
  ) });
};
var Tab = ({ id, isDisabled, className, children, ...rest }) => {
  const [variantProps, localProps] = tabsRecipe.splitVariantProps(rest);
  const recipeClassNames = tabsRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    Tab$1,
    {
      ...localProps,
      className: cx(css(focusRing, recipeClassNames.tab), className),
      id,
      isDisabled,
      children
    }
  );
};
var TabPanel = ({ className, children, ...rest }) => {
  const [variantProps, localProps] = tabsRecipe.splitVariantProps(rest);
  const recipeClassNames = tabsRecipe.raw(variantProps);
  return /* @__PURE__ */ jsx(
    TabPanel$1,
    {
      ...localProps,
      className: cx(css(focusRing, recipeClassNames.tabPanel), className),
      children
    }
  );
};
var systemColorModeName = "system";
var allColorModes = [systemColorModeName, "light", "dark"];
var ThemeContext = React10__default.createContext(null);
var ThemeProviderBase = ({
  localStorageKey = "varnish-ui-theme",
  defaultColorMode = systemColorModeName,
  colorModes = allColorModes,
  forceClassForSystem = false,
  classElement,
  children
}) => {
  const [colorMode, setColorMode] = React10__default.useState(defaultColorMode);
  const [systemPrefersColorMode, setSystemPrefersColorMode] = React10__default.useState("light");
  const computedColorMode = colorMode !== systemColorModeName ? colorMode : systemPrefersColorMode;
  const classElementNode = classElement ?? window.document.body;
  const setColorModeBrowser = React10__default.useCallback(
    (newColorMode) => {
      const classList = classElementNode.classList;
      if (forceClassForSystem || newColorMode !== systemColorModeName) {
        classList.add(newColorMode);
      }
      const removeList = colorModes.filter((mode) => mode !== newColorMode);
      classList.remove(...removeList);
    },
    [colorModes, forceClassForSystem, classElementNode]
  );
  React10__default.useLayoutEffect(() => {
    const colorSchemeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleMediaQueryChange = (query) => {
      setSystemPrefersColorMode(query.matches ? "dark" : "light");
    };
    handleMediaQueryChange(colorSchemeQuery);
    const item = window.localStorage.getItem(localStorageKey);
    let newColorMode = defaultColorMode;
    if (item) {
      newColorMode = JSON.parse(item) || defaultColorMode;
    }
    setColorModeBrowser(newColorMode);
    setColorMode(newColorMode);
    colorSchemeQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      colorSchemeQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, [defaultColorMode, setColorMode, setColorModeBrowser, localStorageKey]);
  const setColorModeState = (newColorMode) => {
    window.localStorage.setItem(localStorageKey, JSON.stringify(newColorMode));
    setColorModeBrowser(newColorMode);
    setColorMode(newColorMode);
  };
  return /* @__PURE__ */ jsx(
    ThemeContext.Provider,
    {
      value: {
        colorMode,
        setColorMode: setColorModeState,
        systemPrefersColorMode,
        computedColorMode
      },
      children
    }
  );
};
var useTheme = () => {
  const context = React10__default.useContext(ThemeContext);
  if (!context) {
    throw new Error("`useTheme()` must be used inside a `ThemeProvider`");
  }
  return context;
};
var fontProperty = (typography) => {
  const { fontFamily, fontSize, fontWeight, lineHeight } = VarnishTheme.typography[typography].value;
  return `${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;
};
var EmotionThemeProvider = ({ children }) => {
  const { computedColorMode } = useTheme();
  const theme = {
    ...VarnishTheme,
    palette: VarnishTheme.palette[computedColorMode],
    // helper: -- TBD usefulness
    fontProperty
  };
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children });
};
var AppProvider = ({ themeProvider, themeDefaults, children }) => {
  const ThemeProvider2 = themeProvider ?? React10__default.Fragment;
  return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(ThemeProviderBase, { ...themeDefaults, children: /* @__PURE__ */ jsx(ThemeProvider2, { children }) }) });
};
var LegalContext = React10__default.createContext(null);
var LegalProvider = ({ localStorageKey, children }) => {
  const [hasAgreed, setHasAgreed] = React10__default.useState(void 0);
  React10__default.useEffect(() => {
    const item = window.localStorage.getItem(localStorageKey);
    let hasAgreedValue = false;
    if (item) {
      hasAgreedValue = JSON.parse(item) || false;
    }
    setHasAgreed(hasAgreedValue);
  }, [setHasAgreed, localStorageKey]);
  const setAgreedState = (newHasAgreed) => {
    window.localStorage.setItem(localStorageKey, JSON.stringify(newHasAgreed));
    setHasAgreed(newHasAgreed);
  };
  return /* @__PURE__ */ jsx(LegalContext.Provider, { value: { hasAgreed, setAgreed: setAgreedState }, children });
};
var useLegalTerms = () => {
  const context = React10__default.useContext(LegalContext);
  if (!context) {
    throw new Error("`useLegalTerms()` must be used inside a `LegalProvider`");
  }
  return context;
};
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/

export { Add, Alert, AlertCloseButton, AlertTitle, AppProvider, Avatar, Button, Check, Checkbox, CheckboxGroup, CheckboxVariantContext, Chip, ChipGroup, ChipGroupContext, Close, CodeBlock, Description, Dialog, DialogActions, DialogCloseButton, DialogHeading, DialogHeadingBase, DialogTrigger, Drawer, EmotionThemeProvider, ErrorBoundary, FieldError, FileInput, FileInputButton, Footer, Form, Header, Icon, icons_exports as Icons, Input, Label, LegalProvider, Link, LoadingSpinner, logos_exports as Logos, Markdown, Menu, Modal, ModalActions, ModalBase, DialogCloseButton as ModalCloseButton, ModalCloseIconButton, ModalContent, ModalHeading, DialogTrigger as ModalTrigger, Popover, PopoverHeading, PopoverOverlayArrow, DialogTrigger as PopoverTrigger, Radio, RadioGroup, RadioVariantContext, Remove, SVGBase, SVGIcon, SVGIconSprite, SVGSpriteLink, Select, SelectButton, SelectListBox, SelectListBoxHeader, SelectListBoxItem, SelectListBoxSection, SelectPopover, SelectValue, SelectVariantContext, Slider, SliderBase, SliderOutput, SliderThumb, SliderTrack, SliderTrackIndicator, Snackbar, SnackbarList, SnackbarNotificationProvider, Spark, SpriteProvider, Stack, Switch, Tab, TabList, TabPanel, Tabs, TextArea, ThemeProviderBase, Tooltip, TooltipOverlayArrow, Upload, createVarnishIcon, cx, useLegalTerms, useSnackbarNotification, useSpriteConfig, useTheme, varnishIcon, varnishIconSprite };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map